// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteDataTypeByIdData, DeleteDataTypeByIdErrors, DeleteDataTypeByIdResponses, DeleteDataTypeFolderByIdData, DeleteDataTypeFolderByIdErrors, DeleteDataTypeFolderByIdResponses, DeleteDictionaryByIdData, DeleteDictionaryByIdErrors, DeleteDictionaryByIdResponses, DeleteDocumentBlueprintByIdData, DeleteDocumentBlueprintByIdErrors, DeleteDocumentBlueprintByIdResponses, DeleteDocumentBlueprintFolderByIdData, DeleteDocumentBlueprintFolderByIdErrors, DeleteDocumentBlueprintFolderByIdResponses, DeleteDocumentByIdData, DeleteDocumentByIdErrors, DeleteDocumentByIdPublicAccessData, DeleteDocumentByIdPublicAccessErrors, DeleteDocumentByIdPublicAccessResponses, DeleteDocumentByIdResponses, DeleteDocumentTypeByIdData, DeleteDocumentTypeByIdErrors, DeleteDocumentTypeByIdResponses, DeleteDocumentTypeFolderByIdData, DeleteDocumentTypeFolderByIdErrors, DeleteDocumentTypeFolderByIdResponses, DeleteElementByIdData, DeleteElementByIdErrors, DeleteElementByIdResponses, DeleteElementFolderByIdData, DeleteElementFolderByIdErrors, DeleteElementFolderByIdResponses, DeleteLanguageByIsoCodeData, DeleteLanguageByIsoCodeErrors, DeleteLanguageByIsoCodeResponses, DeleteLogViewerSavedSearchByNameData, DeleteLogViewerSavedSearchByNameErrors, DeleteLogViewerSavedSearchByNameResponses, DeleteMediaByIdData, DeleteMediaByIdErrors, DeleteMediaByIdResponses, DeleteMediaTypeByIdData, DeleteMediaTypeByIdErrors, DeleteMediaTypeByIdResponses, DeleteMediaTypeFolderByIdData, DeleteMediaTypeFolderByIdErrors, DeleteMediaTypeFolderByIdResponses, DeleteMemberByIdData, DeleteMemberByIdErrors, DeleteMemberByIdResponses, DeleteMemberGroupByIdData, DeleteMemberGroupByIdErrors, DeleteMemberGroupByIdResponses, DeleteMemberTypeByIdData, DeleteMemberTypeByIdErrors, DeleteMemberTypeByIdResponses, DeleteMemberTypeFolderByIdData, DeleteMemberTypeFolderByIdErrors, DeleteMemberTypeFolderByIdResponses, DeletePackageCreatedByIdData, DeletePackageCreatedByIdErrors, DeletePackageCreatedByIdResponses, DeletePartialViewByPathData, DeletePartialViewByPathErrors, DeletePartialViewByPathResponses, DeletePartialViewFolderByPathData, DeletePartialViewFolderByPathErrors, DeletePartialViewFolderByPathResponses, DeletePreviewData, DeletePreviewResponses, DeleteRecycleBinDocumentByIdData, DeleteRecycleBinDocumentByIdErrors, DeleteRecycleBinDocumentByIdResponses, DeleteRecycleBinDocumentData, DeleteRecycleBinDocumentErrors, DeleteRecycleBinDocumentResponses, DeleteRecycleBinElementByIdData, DeleteRecycleBinElementByIdErrors, DeleteRecycleBinElementByIdResponses, DeleteRecycleBinElementData, DeleteRecycleBinElementErrors, DeleteRecycleBinElementFolderByIdData, DeleteRecycleBinElementFolderByIdErrors, DeleteRecycleBinElementFolderByIdResponses, DeleteRecycleBinElementResponses, DeleteRecycleBinMediaByIdData, DeleteRecycleBinMediaByIdErrors, DeleteRecycleBinMediaByIdResponses, DeleteRecycleBinMediaData, DeleteRecycleBinMediaErrors, DeleteRecycleBinMediaResponses, DeleteRedirectManagementByIdData, DeleteRedirectManagementByIdErrors, DeleteRedirectManagementByIdResponses, DeleteScriptByPathData, DeleteScriptByPathErrors, DeleteScriptByPathResponses, DeleteScriptFolderByPathData, DeleteScriptFolderByPathErrors, DeleteScriptFolderByPathResponses, DeleteStylesheetByPathData, DeleteStylesheetByPathErrors, DeleteStylesheetByPathResponses, DeleteStylesheetFolderByPathData, DeleteStylesheetFolderByPathErrors, DeleteStylesheetFolderByPathResponses, DeleteTemplateByIdData, DeleteTemplateByIdErrors, DeleteTemplateByIdResponses, DeleteTemporaryFileByIdData, DeleteTemporaryFileByIdErrors, DeleteTemporaryFileByIdResponses, DeleteUserAvatarByIdData, DeleteUserAvatarByIdErrors, DeleteUserAvatarByIdResponses, DeleteUserById2FaByProviderNameData, DeleteUserById2FaByProviderNameErrors, DeleteUserById2FaByProviderNameResponses, DeleteUserByIdClientCredentialsByClientIdData, DeleteUserByIdClientCredentialsByClientIdErrors, DeleteUserByIdClientCredentialsByClientIdResponses, DeleteUserByIdData, DeleteUserByIdErrors, DeleteUserByIdResponses, DeleteUserCurrent2FaByProviderNameData, DeleteUserCurrent2FaByProviderNameErrors, DeleteUserCurrent2FaByProviderNameResponses, DeleteUserCurrentAvatarData, DeleteUserCurrentAvatarErrors, DeleteUserCurrentAvatarResponses, DeleteUserData, DeleteUserDataByIdData, DeleteUserDataByIdErrors, DeleteUserDataByIdResponses, DeleteUserErrors, DeleteUserGroupByIdData, DeleteUserGroupByIdErrors, DeleteUserGroupByIdResponses, DeleteUserGroupByIdUsersData, DeleteUserGroupByIdUsersErrors, DeleteUserGroupByIdUsersResponses, DeleteUserGroupData, DeleteUserGroupErrors, DeleteUserGroupResponses, DeleteUserResponses, DeleteWebhookByIdData, DeleteWebhookByIdErrors, DeleteWebhookByIdResponses, GetCollectionDocumentByIdData, GetCollectionDocumentByIdErrors, GetCollectionDocumentByIdResponses, GetCollectionMediaData, GetCollectionMediaErrors, GetCollectionMediaResponses, GetCultureData, GetCultureErrors, GetCultureResponses, GetDataTypeBatchData, GetDataTypeBatchErrors, GetDataTypeBatchResponses, GetDataTypeByIdData, GetDataTypeByIdErrors, GetDataTypeByIdIsUsedData, GetDataTypeByIdIsUsedErrors, GetDataTypeByIdIsUsedResponses, GetDataTypeByIdReferencedByData, GetDataTypeByIdReferencedByErrors, GetDataTypeByIdReferencedByResponses, GetDataTypeByIdResponses, GetDataTypeByIdSchemaData, GetDataTypeByIdSchemaErrors, GetDataTypeByIdSchemaResponses, GetDataTypeConfigurationData, GetDataTypeConfigurationErrors, GetDataTypeConfigurationResponses, GetDataTypeFolderByIdData, GetDataTypeFolderByIdErrors, GetDataTypeFolderByIdResponses, GetDataTypeSchemasBatchData, GetDataTypeSchemasBatchErrors, GetDataTypeSchemasBatchResponses, GetDictionaryByIdData, GetDictionaryByIdErrors, GetDictionaryByIdExportData, GetDictionaryByIdExportErrors, GetDictionaryByIdExportResponses, GetDictionaryByIdResponses, GetDictionaryData, GetDictionaryErrors, GetDictionaryResponses, GetDocumentAreReferencedData, GetDocumentAreReferencedErrors, GetDocumentAreReferencedResponses, GetDocumentBlueprintByIdAuditLogData, GetDocumentBlueprintByIdAuditLogErrors, GetDocumentBlueprintByIdAuditLogResponses, GetDocumentBlueprintByIdData, GetDocumentBlueprintByIdErrors, GetDocumentBlueprintByIdResponses, GetDocumentBlueprintByIdScaffoldData, GetDocumentBlueprintByIdScaffoldErrors, GetDocumentBlueprintByIdScaffoldResponses, GetDocumentBlueprintFolderByIdData, GetDocumentBlueprintFolderByIdErrors, GetDocumentBlueprintFolderByIdResponses, GetDocumentByIdAuditLogData, GetDocumentByIdAuditLogErrors, GetDocumentByIdAuditLogResponses, GetDocumentByIdAvailableSegmentOptionsData, GetDocumentByIdAvailableSegmentOptionsErrors, GetDocumentByIdAvailableSegmentOptionsResponses, GetDocumentByIdData, GetDocumentByIdDomainsData, GetDocumentByIdDomainsErrors, GetDocumentByIdDomainsResponses, GetDocumentByIdErrors, GetDocumentByIdNotificationsData, GetDocumentByIdNotificationsErrors, GetDocumentByIdNotificationsResponses, GetDocumentByIdPreviewUrlData, GetDocumentByIdPreviewUrlErrors, GetDocumentByIdPreviewUrlResponses, GetDocumentByIdPublicAccessData, GetDocumentByIdPublicAccessErrors, GetDocumentByIdPublicAccessResponses, GetDocumentByIdPublishedData, GetDocumentByIdPublishedErrors, GetDocumentByIdPublishedResponses, GetDocumentByIdPublishWithDescendantsResultByTaskIdData, GetDocumentByIdPublishWithDescendantsResultByTaskIdErrors, GetDocumentByIdPublishWithDescendantsResultByTaskIdResponses, GetDocumentByIdReferencedByData, GetDocumentByIdReferencedByErrors, GetDocumentByIdReferencedByResponses, GetDocumentByIdReferencedDescendantsData, GetDocumentByIdReferencedDescendantsErrors, GetDocumentByIdReferencedDescendantsResponses, GetDocumentByIdResponses, GetDocumentConfigurationData, GetDocumentConfigurationErrors, GetDocumentConfigurationResponses, GetDocumentTypeAllowedAtRootData, GetDocumentTypeAllowedAtRootErrors, GetDocumentTypeAllowedAtRootResponses, GetDocumentTypeAllowedInLibraryData, GetDocumentTypeAllowedInLibraryErrors, GetDocumentTypeAllowedInLibraryResponses, GetDocumentTypeBatchData, GetDocumentTypeBatchErrors, GetDocumentTypeBatchResponses, GetDocumentTypeByIdAllowedChildrenData, GetDocumentTypeByIdAllowedChildrenErrors, GetDocumentTypeByIdAllowedChildrenResponses, GetDocumentTypeByIdAllowedParentsData, GetDocumentTypeByIdAllowedParentsErrors, GetDocumentTypeByIdAllowedParentsResponses, GetDocumentTypeByIdBlueprintData, GetDocumentTypeByIdBlueprintErrors, GetDocumentTypeByIdBlueprintResponses, GetDocumentTypeByIdCompositionReferencesData, GetDocumentTypeByIdCompositionReferencesErrors, GetDocumentTypeByIdCompositionReferencesResponses, GetDocumentTypeByIdData, GetDocumentTypeByIdErrors, GetDocumentTypeByIdExportData, GetDocumentTypeByIdExportErrors, GetDocumentTypeByIdExportResponses, GetDocumentTypeByIdResponses, GetDocumentTypeByIdSchemaData, GetDocumentTypeByIdSchemaErrors, GetDocumentTypeByIdSchemaResponses, GetDocumentTypeConfigurationData, GetDocumentTypeConfigurationErrors, GetDocumentTypeConfigurationResponses, GetDocumentTypeFolderByIdData, GetDocumentTypeFolderByIdErrors, GetDocumentTypeFolderByIdResponses, GetDocumentUrlsData, GetDocumentUrlsErrors, GetDocumentUrlsResponses, GetDocumentVersionByIdData, GetDocumentVersionByIdErrors, GetDocumentVersionByIdResponses, GetDocumentVersionData, GetDocumentVersionErrors, GetDocumentVersionResponses, GetDynamicRootStepsData, GetDynamicRootStepsErrors, GetDynamicRootStepsResponses, GetElementAreReferencedData, GetElementAreReferencedErrors, GetElementAreReferencedResponses, GetElementByIdAuditLogData, GetElementByIdAuditLogErrors, GetElementByIdAuditLogResponses, GetElementByIdData, GetElementByIdErrors, GetElementByIdPublishedData, GetElementByIdPublishedErrors, GetElementByIdPublishedResponses, GetElementByIdReferencedByData, GetElementByIdReferencedByErrors, GetElementByIdReferencedByResponses, GetElementByIdResponses, GetElementConfigurationData, GetElementConfigurationErrors, GetElementConfigurationResponses, GetElementFolderByIdData, GetElementFolderByIdErrors, GetElementFolderByIdReferencedDescendantsData, GetElementFolderByIdReferencedDescendantsErrors, GetElementFolderByIdReferencedDescendantsResponses, GetElementFolderByIdResponses, GetElementVersionByIdData, GetElementVersionByIdErrors, GetElementVersionByIdResponses, GetElementVersionData, GetElementVersionErrors, GetElementVersionResponses, GetFilterDataTypeData, GetFilterDataTypeErrors, GetFilterDataTypeResponses, GetFilterMemberData, GetFilterMemberErrors, GetFilterMemberResponses, GetFilterUserData, GetFilterUserErrors, GetFilterUserGroupData, GetFilterUserGroupErrors, GetFilterUserGroupResponses, GetFilterUserResponses, GetHealthCheckGroupByNameData, GetHealthCheckGroupByNameErrors, GetHealthCheckGroupByNameResponses, GetHealthCheckGroupData, GetHealthCheckGroupErrors, GetHealthCheckGroupResponses, GetHelpData, GetHelpErrors, GetHelpResponses, GetImagingResizeUrlsData, GetImagingResizeUrlsErrors, GetImagingResizeUrlsResponses, GetImportAnalyzeData, GetImportAnalyzeErrors, GetImportAnalyzeResponses, GetIndexerByIndexNameData, GetIndexerByIndexNameErrors, GetIndexerByIndexNameResponses, GetIndexerData, GetIndexerErrors, GetIndexerResponses, GetInstallSettingsData, GetInstallSettingsErrors, GetInstallSettingsResponses, GetItemDataTypeAncestorsData, GetItemDataTypeAncestorsErrors, GetItemDataTypeAncestorsResponses, GetItemDataTypeData, GetItemDataTypeErrors, GetItemDataTypeResponses, GetItemDataTypeSearchData, GetItemDataTypeSearchErrors, GetItemDataTypeSearchResponses, GetItemDictionaryData, GetItemDictionaryErrors, GetItemDictionaryResponses, GetItemDocumentAncestorsData, GetItemDocumentAncestorsErrors, GetItemDocumentAncestorsResponses, GetItemDocumentBlueprintData, GetItemDocumentBlueprintErrors, GetItemDocumentBlueprintResponses, GetItemDocumentData, GetItemDocumentErrors, GetItemDocumentResponses, GetItemDocumentSearchData, GetItemDocumentSearchErrors, GetItemDocumentSearchResponses, GetItemDocumentTypeAncestorsData, GetItemDocumentTypeAncestorsErrors, GetItemDocumentTypeAncestorsResponses, GetItemDocumentTypeData, GetItemDocumentTypeErrors, GetItemDocumentTypeResponses, GetItemDocumentTypeSearchData, GetItemDocumentTypeSearchErrors, GetItemDocumentTypeSearchResponses, GetItemElementAncestorsData, GetItemElementAncestorsErrors, GetItemElementAncestorsResponses, GetItemElementData, GetItemElementErrors, GetItemElementFolderData, GetItemElementFolderErrors, GetItemElementFolderResponses, GetItemElementResponses, GetItemElementSearchData, GetItemElementSearchErrors, GetItemElementSearchResponses, GetItemLanguageData, GetItemLanguageDefaultData, GetItemLanguageDefaultErrors, GetItemLanguageDefaultResponses, GetItemLanguageErrors, GetItemLanguageResponses, GetItemMediaAncestorsData, GetItemMediaAncestorsErrors, GetItemMediaAncestorsResponses, GetItemMediaData, GetItemMediaErrors, GetItemMediaResponses, GetItemMediaSearchData, GetItemMediaSearchErrors, GetItemMediaSearchResponses, GetItemMediaTypeAllowedData, GetItemMediaTypeAllowedErrors, GetItemMediaTypeAllowedResponses, GetItemMediaTypeAncestorsData, GetItemMediaTypeAncestorsErrors, GetItemMediaTypeAncestorsResponses, GetItemMediaTypeData, GetItemMediaTypeErrors, GetItemMediaTypeFoldersData, GetItemMediaTypeFoldersErrors, GetItemMediaTypeFoldersResponses, GetItemMediaTypeResponses, GetItemMediaTypeSearchData, GetItemMediaTypeSearchErrors, GetItemMediaTypeSearchResponses, GetItemMemberAncestorsData, GetItemMemberAncestorsErrors, GetItemMemberAncestorsResponses, GetItemMemberData, GetItemMemberErrors, GetItemMemberGroupData, GetItemMemberGroupErrors, GetItemMemberGroupResponses, GetItemMemberResponses, GetItemMemberSearchData, GetItemMemberSearchErrors, GetItemMemberSearchResponses, GetItemMemberTypeAncestorsData, GetItemMemberTypeAncestorsErrors, GetItemMemberTypeAncestorsResponses, GetItemMemberTypeData, GetItemMemberTypeErrors, GetItemMemberTypeResponses, GetItemMemberTypeSearchData, GetItemMemberTypeSearchErrors, GetItemMemberTypeSearchResponses, GetItemPartialViewData, GetItemPartialViewErrors, GetItemPartialViewResponses, GetItemRelationTypeData, GetItemRelationTypeErrors, GetItemRelationTypeResponses, GetItemScriptData, GetItemScriptErrors, GetItemScriptResponses, GetItemStaticFileData, GetItemStaticFileErrors, GetItemStaticFileResponses, GetItemStylesheetData, GetItemStylesheetErrors, GetItemStylesheetResponses, GetItemTemplateAncestorsData, GetItemTemplateAncestorsErrors, GetItemTemplateAncestorsResponses, GetItemTemplateData, GetItemTemplateErrors, GetItemTemplateResponses, GetItemTemplateSearchData, GetItemTemplateSearchErrors, GetItemTemplateSearchResponses, GetItemUserData, GetItemUserErrors, GetItemUserGroupData, GetItemUserGroupErrors, GetItemUserGroupResponses, GetItemUserResponses, GetItemWebhookData, GetItemWebhookErrors, GetItemWebhookResponses, GetLanguageByIsoCodeData, GetLanguageByIsoCodeErrors, GetLanguageByIsoCodeResponses, GetLanguageData, GetLanguageErrors, GetLanguageResponses, GetLogViewerLevelCountData, GetLogViewerLevelCountErrors, GetLogViewerLevelCountResponses, GetLogViewerLevelData, GetLogViewerLevelErrors, GetLogViewerLevelResponses, GetLogViewerLogData, GetLogViewerLogErrors, GetLogViewerLogResponses, GetLogViewerMessageTemplateData, GetLogViewerMessageTemplateErrors, GetLogViewerMessageTemplateResponses, GetLogViewerSavedSearchByNameData, GetLogViewerSavedSearchByNameErrors, GetLogViewerSavedSearchByNameResponses, GetLogViewerSavedSearchData, GetLogViewerSavedSearchErrors, GetLogViewerSavedSearchResponses, GetLogViewerValidateLogsSizeData, GetLogViewerValidateLogsSizeErrors, GetLogViewerValidateLogsSizeResponses, GetManifestManifestData, GetManifestManifestErrors, GetManifestManifestPrivateData, GetManifestManifestPrivateErrors, GetManifestManifestPrivateResponses, GetManifestManifestPublicData, GetManifestManifestPublicResponses, GetManifestManifestResponses, GetMediaAreReferencedData, GetMediaAreReferencedErrors, GetMediaAreReferencedResponses, GetMediaByIdAuditLogData, GetMediaByIdAuditLogErrors, GetMediaByIdAuditLogResponses, GetMediaByIdData, GetMediaByIdErrors, GetMediaByIdReferencedByData, GetMediaByIdReferencedByErrors, GetMediaByIdReferencedByResponses, GetMediaByIdReferencedDescendantsData, GetMediaByIdReferencedDescendantsErrors, GetMediaByIdReferencedDescendantsResponses, GetMediaByIdResponses, GetMediaConfigurationData, GetMediaConfigurationErrors, GetMediaConfigurationResponses, GetMediaTypeAllowedAtRootData, GetMediaTypeAllowedAtRootErrors, GetMediaTypeAllowedAtRootResponses, GetMediaTypeBatchData, GetMediaTypeBatchErrors, GetMediaTypeBatchResponses, GetMediaTypeByIdAllowedChildrenData, GetMediaTypeByIdAllowedChildrenErrors, GetMediaTypeByIdAllowedChildrenResponses, GetMediaTypeByIdAllowedParentsData, GetMediaTypeByIdAllowedParentsErrors, GetMediaTypeByIdAllowedParentsResponses, GetMediaTypeByIdCompositionReferencesData, GetMediaTypeByIdCompositionReferencesErrors, GetMediaTypeByIdCompositionReferencesResponses, GetMediaTypeByIdData, GetMediaTypeByIdErrors, GetMediaTypeByIdExportData, GetMediaTypeByIdExportErrors, GetMediaTypeByIdExportResponses, GetMediaTypeByIdResponses, GetMediaTypeByIdSchemaData, GetMediaTypeByIdSchemaErrors, GetMediaTypeByIdSchemaResponses, GetMediaTypeConfigurationData, GetMediaTypeConfigurationErrors, GetMediaTypeConfigurationResponses, GetMediaTypeFolderByIdData, GetMediaTypeFolderByIdErrors, GetMediaTypeFolderByIdResponses, GetMediaUrlsData, GetMediaUrlsErrors, GetMediaUrlsResponses, GetMemberAreReferencedData, GetMemberAreReferencedErrors, GetMemberAreReferencedResponses, GetMemberByIdData, GetMemberByIdErrors, GetMemberByIdReferencedByData, GetMemberByIdReferencedByErrors, GetMemberByIdReferencedByResponses, GetMemberByIdReferencedDescendantsData, GetMemberByIdReferencedDescendantsErrors, GetMemberByIdReferencedDescendantsResponses, GetMemberByIdResponses, GetMemberGroupByIdData, GetMemberGroupByIdErrors, GetMemberGroupByIdResponses, GetMemberGroupData, GetMemberGroupErrors, GetMemberGroupResponses, GetMemberTypeAllowedAtRootData, GetMemberTypeAllowedAtRootErrors, GetMemberTypeAllowedAtRootResponses, GetMemberTypeBatchData, GetMemberTypeBatchErrors, GetMemberTypeBatchResponses, GetMemberTypeByIdCompositionReferencesData, GetMemberTypeByIdCompositionReferencesErrors, GetMemberTypeByIdCompositionReferencesResponses, GetMemberTypeByIdData, GetMemberTypeByIdErrors, GetMemberTypeByIdExportData, GetMemberTypeByIdExportErrors, GetMemberTypeByIdExportResponses, GetMemberTypeByIdResponses, GetMemberTypeByIdSchemaData, GetMemberTypeByIdSchemaErrors, GetMemberTypeByIdSchemaResponses, GetMemberTypeConfigurationData, GetMemberTypeConfigurationErrors, GetMemberTypeConfigurationResponses, GetMemberTypeFolderByIdData, GetMemberTypeFolderByIdErrors, GetMemberTypeFolderByIdResponses, GetModelsBuilderDashboardData, GetModelsBuilderDashboardErrors, GetModelsBuilderDashboardResponses, GetModelsBuilderStatusData, GetModelsBuilderStatusErrors, GetModelsBuilderStatusResponses, GetNewsDashboardData, GetNewsDashboardErrors, GetNewsDashboardResponses, GetObjectTypesData, GetObjectTypesErrors, GetObjectTypesResponses, GetOembedQueryData, GetOembedQueryErrors, GetOembedQueryResponses, GetPackageConfigurationData, GetPackageConfigurationErrors, GetPackageConfigurationResponses, GetPackageCreatedByIdData, GetPackageCreatedByIdDownloadData, GetPackageCreatedByIdDownloadErrors, GetPackageCreatedByIdDownloadResponses, GetPackageCreatedByIdErrors, GetPackageCreatedByIdResponses, GetPackageCreatedData, GetPackageCreatedErrors, GetPackageCreatedResponses, GetPackageMigrationStatusData, GetPackageMigrationStatusErrors, GetPackageMigrationStatusResponses, GetPartialViewByPathData, GetPartialViewByPathErrors, GetPartialViewByPathResponses, GetPartialViewFolderByPathData, GetPartialViewFolderByPathErrors, GetPartialViewFolderByPathResponses, GetPartialViewSnippetByIdData, GetPartialViewSnippetByIdErrors, GetPartialViewSnippetByIdResponses, GetPartialViewSnippetData, GetPartialViewSnippetErrors, GetPartialViewSnippetResponses, GetProfilingStatusData, GetProfilingStatusErrors, GetProfilingStatusResponses, GetPropertyTypeIsUsedData, GetPropertyTypeIsUsedErrors, GetPropertyTypeIsUsedResponses, GetPublishedCacheRebuildStatusData, GetPublishedCacheRebuildStatusErrors, GetPublishedCacheRebuildStatusResponses, GetRecycleBinDocumentByIdOriginalParentData, GetRecycleBinDocumentByIdOriginalParentErrors, GetRecycleBinDocumentByIdOriginalParentResponses, GetRecycleBinDocumentChildrenData, GetRecycleBinDocumentChildrenErrors, GetRecycleBinDocumentChildrenResponses, GetRecycleBinDocumentReferencedByData, GetRecycleBinDocumentReferencedByErrors, GetRecycleBinDocumentReferencedByResponses, GetRecycleBinDocumentRootData, GetRecycleBinDocumentRootErrors, GetRecycleBinDocumentRootResponses, GetRecycleBinDocumentSiblingsData, GetRecycleBinDocumentSiblingsErrors, GetRecycleBinDocumentSiblingsResponses, GetRecycleBinElementByIdOriginalParentData, GetRecycleBinElementByIdOriginalParentErrors, GetRecycleBinElementByIdOriginalParentResponses, GetRecycleBinElementChildrenData, GetRecycleBinElementChildrenErrors, GetRecycleBinElementChildrenResponses, GetRecycleBinElementFolderByIdOriginalParentData, GetRecycleBinElementFolderByIdOriginalParentErrors, GetRecycleBinElementFolderByIdOriginalParentResponses, GetRecycleBinElementReferencedByData, GetRecycleBinElementReferencedByErrors, GetRecycleBinElementReferencedByResponses, GetRecycleBinElementRootData, GetRecycleBinElementRootErrors, GetRecycleBinElementRootResponses, GetRecycleBinElementSiblingsData, GetRecycleBinElementSiblingsErrors, GetRecycleBinElementSiblingsResponses, GetRecycleBinMediaByIdOriginalParentData, GetRecycleBinMediaByIdOriginalParentErrors, GetRecycleBinMediaByIdOriginalParentResponses, GetRecycleBinMediaChildrenData, GetRecycleBinMediaChildrenErrors, GetRecycleBinMediaChildrenResponses, GetRecycleBinMediaReferencedByData, GetRecycleBinMediaReferencedByErrors, GetRecycleBinMediaReferencedByResponses, GetRecycleBinMediaRootData, GetRecycleBinMediaRootErrors, GetRecycleBinMediaRootResponses, GetRecycleBinMediaSiblingsData, GetRecycleBinMediaSiblingsErrors, GetRecycleBinMediaSiblingsResponses, GetRedirectManagementByIdData, GetRedirectManagementByIdErrors, GetRedirectManagementByIdResponses, GetRedirectManagementData, GetRedirectManagementErrors, GetRedirectManagementResponses, GetRedirectManagementStatusData, GetRedirectManagementStatusErrors, GetRedirectManagementStatusResponses, GetRelationByRelationTypeIdData, GetRelationByRelationTypeIdErrors, GetRelationByRelationTypeIdResponses, GetRelationTypeByIdData, GetRelationTypeByIdErrors, GetRelationTypeByIdResponses, GetRelationTypeData, GetRelationTypeErrors, GetRelationTypeResponses, GetScriptByPathData, GetScriptByPathErrors, GetScriptByPathResponses, GetScriptFolderByPathData, GetScriptFolderByPathErrors, GetScriptFolderByPathResponses, GetSearcherBySearcherNameQueryData, GetSearcherBySearcherNameQueryErrors, GetSearcherBySearcherNameQueryResponses, GetSearcherData, GetSearcherErrors, GetSearcherResponses, GetSecurityConfigurationData, GetSecurityConfigurationErrors, GetSecurityConfigurationResponses, GetSegmentData, GetSegmentErrors, GetSegmentResponses, GetServerConfigurationData, GetServerConfigurationResponses, GetServerInformationData, GetServerInformationErrors, GetServerInformationResponses, GetServerStatusData, GetServerStatusErrors, GetServerStatusResponses, GetServerTroubleshootingData, GetServerTroubleshootingErrors, GetServerTroubleshootingResponses, GetServerUpgradeCheckData, GetServerUpgradeCheckErrors, GetServerUpgradeCheckResponses, GetStylesheetByPathData, GetStylesheetByPathErrors, GetStylesheetByPathResponses, GetStylesheetFolderByPathData, GetStylesheetFolderByPathErrors, GetStylesheetFolderByPathResponses, GetTagData, GetTagErrors, GetTagResponses, GetTelemetryData, GetTelemetryErrors, GetTelemetryLevelData, GetTelemetryLevelErrors, GetTelemetryLevelResponses, GetTelemetryResponses, GetTemplateByIdData, GetTemplateByIdErrors, GetTemplateByIdResponses, GetTemplateConfigurationData, GetTemplateConfigurationErrors, GetTemplateConfigurationResponses, GetTemplateQuerySettingsData, GetTemplateQuerySettingsErrors, GetTemplateQuerySettingsResponses, GetTemporaryFileByIdData, GetTemporaryFileByIdErrors, GetTemporaryFileByIdResponses, GetTemporaryFileConfigurationData, GetTemporaryFileConfigurationErrors, GetTemporaryFileConfigurationResponses, GetTreeDataTypeAncestorsData, GetTreeDataTypeAncestorsErrors, GetTreeDataTypeAncestorsResponses, GetTreeDataTypeChildrenData, GetTreeDataTypeChildrenErrors, GetTreeDataTypeChildrenResponses, GetTreeDataTypeRootData, GetTreeDataTypeRootErrors, GetTreeDataTypeRootResponses, GetTreeDataTypeSearchData, GetTreeDataTypeSearchErrors, GetTreeDataTypeSearchResponses, GetTreeDataTypeSiblingsData, GetTreeDataTypeSiblingsErrors, GetTreeDataTypeSiblingsResponses, GetTreeDictionaryAncestorsData, GetTreeDictionaryAncestorsErrors, GetTreeDictionaryAncestorsResponses, GetTreeDictionaryChildrenData, GetTreeDictionaryChildrenErrors, GetTreeDictionaryChildrenResponses, GetTreeDictionaryRootData, GetTreeDictionaryRootErrors, GetTreeDictionaryRootResponses, GetTreeDocumentAncestorsData, GetTreeDocumentAncestorsErrors, GetTreeDocumentAncestorsResponses, GetTreeDocumentBlueprintAncestorsData, GetTreeDocumentBlueprintAncestorsErrors, GetTreeDocumentBlueprintAncestorsResponses, GetTreeDocumentBlueprintChildrenData, GetTreeDocumentBlueprintChildrenErrors, GetTreeDocumentBlueprintChildrenResponses, GetTreeDocumentBlueprintRootData, GetTreeDocumentBlueprintRootErrors, GetTreeDocumentBlueprintRootResponses, GetTreeDocumentBlueprintSiblingsData, GetTreeDocumentBlueprintSiblingsErrors, GetTreeDocumentBlueprintSiblingsResponses, GetTreeDocumentChildrenData, GetTreeDocumentChildrenErrors, GetTreeDocumentChildrenResponses, GetTreeDocumentRootData, GetTreeDocumentRootErrors, GetTreeDocumentRootResponses, GetTreeDocumentSiblingsData, GetTreeDocumentSiblingsErrors, GetTreeDocumentSiblingsResponses, GetTreeDocumentTypeAncestorsData, GetTreeDocumentTypeAncestorsErrors, GetTreeDocumentTypeAncestorsResponses, GetTreeDocumentTypeChildrenData, GetTreeDocumentTypeChildrenErrors, GetTreeDocumentTypeChildrenResponses, GetTreeDocumentTypeRootData, GetTreeDocumentTypeRootErrors, GetTreeDocumentTypeRootResponses, GetTreeDocumentTypeSearchData, GetTreeDocumentTypeSearchErrors, GetTreeDocumentTypeSearchResponses, GetTreeDocumentTypeSiblingsData, GetTreeDocumentTypeSiblingsErrors, GetTreeDocumentTypeSiblingsResponses, GetTreeElementAncestorsData, GetTreeElementAncestorsErrors, GetTreeElementAncestorsResponses, GetTreeElementChildrenData, GetTreeElementChildrenErrors, GetTreeElementChildrenResponses, GetTreeElementRootData, GetTreeElementRootErrors, GetTreeElementRootResponses, GetTreeElementSiblingsData, GetTreeElementSiblingsErrors, GetTreeElementSiblingsResponses, GetTreeMediaAncestorsData, GetTreeMediaAncestorsErrors, GetTreeMediaAncestorsResponses, GetTreeMediaChildrenData, GetTreeMediaChildrenErrors, GetTreeMediaChildrenResponses, GetTreeMediaRootData, GetTreeMediaRootErrors, GetTreeMediaRootResponses, GetTreeMediaSiblingsData, GetTreeMediaSiblingsErrors, GetTreeMediaSiblingsResponses, GetTreeMediaTypeAncestorsData, GetTreeMediaTypeAncestorsErrors, GetTreeMediaTypeAncestorsResponses, GetTreeMediaTypeChildrenData, GetTreeMediaTypeChildrenErrors, GetTreeMediaTypeChildrenResponses, GetTreeMediaTypeRootData, GetTreeMediaTypeRootErrors, GetTreeMediaTypeRootResponses, GetTreeMediaTypeSiblingsData, GetTreeMediaTypeSiblingsErrors, GetTreeMediaTypeSiblingsResponses, GetTreeMemberGroupRootData, GetTreeMemberGroupRootErrors, GetTreeMemberGroupRootResponses, GetTreeMemberTypeAncestorsData, GetTreeMemberTypeAncestorsErrors, GetTreeMemberTypeAncestorsResponses, GetTreeMemberTypeChildrenData, GetTreeMemberTypeChildrenErrors, GetTreeMemberTypeChildrenResponses, GetTreeMemberTypeRootData, GetTreeMemberTypeRootErrors, GetTreeMemberTypeRootResponses, GetTreeMemberTypeSiblingsData, GetTreeMemberTypeSiblingsErrors, GetTreeMemberTypeSiblingsResponses, GetTreePartialViewAncestorsData, GetTreePartialViewAncestorsErrors, GetTreePartialViewAncestorsResponses, GetTreePartialViewChildrenData, GetTreePartialViewChildrenErrors, GetTreePartialViewChildrenResponses, GetTreePartialViewRootData, GetTreePartialViewRootErrors, GetTreePartialViewRootResponses, GetTreePartialViewSiblingsData, GetTreePartialViewSiblingsErrors, GetTreePartialViewSiblingsResponses, GetTreeScriptAncestorsData, GetTreeScriptAncestorsErrors, GetTreeScriptAncestorsResponses, GetTreeScriptChildrenData, GetTreeScriptChildrenErrors, GetTreeScriptChildrenResponses, GetTreeScriptRootData, GetTreeScriptRootErrors, GetTreeScriptRootResponses, GetTreeScriptSiblingsData, GetTreeScriptSiblingsErrors, GetTreeScriptSiblingsResponses, GetTreeStaticFileAncestorsData, GetTreeStaticFileAncestorsErrors, GetTreeStaticFileAncestorsResponses, GetTreeStaticFileChildrenData, GetTreeStaticFileChildrenErrors, GetTreeStaticFileChildrenResponses, GetTreeStaticFileRootData, GetTreeStaticFileRootErrors, GetTreeStaticFileRootResponses, GetTreeStylesheetAncestorsData, GetTreeStylesheetAncestorsErrors, GetTreeStylesheetAncestorsResponses, GetTreeStylesheetChildrenData, GetTreeStylesheetChildrenErrors, GetTreeStylesheetChildrenResponses, GetTreeStylesheetRootData, GetTreeStylesheetRootErrors, GetTreeStylesheetRootResponses, GetTreeStylesheetSiblingsData, GetTreeStylesheetSiblingsErrors, GetTreeStylesheetSiblingsResponses, GetTreeTemplateAncestorsData, GetTreeTemplateAncestorsErrors, GetTreeTemplateAncestorsResponses, GetTreeTemplateChildrenData, GetTreeTemplateChildrenErrors, GetTreeTemplateChildrenResponses, GetTreeTemplateRootData, GetTreeTemplateRootErrors, GetTreeTemplateRootResponses, GetTreeTemplateSiblingsData, GetTreeTemplateSiblingsErrors, GetTreeTemplateSiblingsResponses, GetUpgradeSettingsData, GetUpgradeSettingsErrors, GetUpgradeSettingsResponses, GetUserBatchData, GetUserBatchErrors, GetUserBatchResponses, GetUserById2FaData, GetUserById2FaErrors, GetUserById2FaResponses, GetUserByIdCalculateStartNodesData, GetUserByIdCalculateStartNodesErrors, GetUserByIdCalculateStartNodesResponses, GetUserByIdClientCredentialsData, GetUserByIdClientCredentialsErrors, GetUserByIdClientCredentialsResponses, GetUserByIdData, GetUserByIdErrors, GetUserByIdResponses, GetUserConfigurationData, GetUserConfigurationErrors, GetUserConfigurationResponses, GetUserCurrent2FaByProviderNameData, GetUserCurrent2FaByProviderNameErrors, GetUserCurrent2FaByProviderNameResponses, GetUserCurrent2FaData, GetUserCurrent2FaErrors, GetUserCurrent2FaResponses, GetUserCurrentConfigurationData, GetUserCurrentConfigurationErrors, GetUserCurrentConfigurationResponses, GetUserCurrentData, GetUserCurrentErrors, GetUserCurrentLoginProvidersData, GetUserCurrentLoginProvidersErrors, GetUserCurrentLoginProvidersResponses, GetUserCurrentPermissionsData, GetUserCurrentPermissionsDocumentData, GetUserCurrentPermissionsDocumentErrors, GetUserCurrentPermissionsDocumentResponses, GetUserCurrentPermissionsElementData, GetUserCurrentPermissionsElementErrors, GetUserCurrentPermissionsElementResponses, GetUserCurrentPermissionsErrors, GetUserCurrentPermissionsMediaData, GetUserCurrentPermissionsMediaErrors, GetUserCurrentPermissionsMediaResponses, GetUserCurrentPermissionsResponses, GetUserCurrentResponses, GetUserData, GetUserDataByIdData, GetUserDataByIdErrors, GetUserDataByIdResponses, GetUserDataData, GetUserDataErrors, GetUserDataResponses, GetUserErrors, GetUserGroupByIdData, GetUserGroupByIdErrors, GetUserGroupByIdResponses, GetUserGroupData, GetUserGroupErrors, GetUserGroupResponses, GetUserResponses, GetWebhookByIdData, GetWebhookByIdErrors, GetWebhookByIdLogsData, GetWebhookByIdLogsErrors, GetWebhookByIdLogsResponses, GetWebhookByIdResponses, GetWebhookData, GetWebhookErrors, GetWebhookEventsData, GetWebhookEventsErrors, GetWebhookEventsResponses, GetWebhookLogsData, GetWebhookLogsErrors, GetWebhookLogsResponses, GetWebhookResponses, PatchDocumentByIdPatchData, PatchDocumentByIdPatchErrors, PatchDocumentByIdPatchResponses, PostDataTypeByIdCopyData, PostDataTypeByIdCopyErrors, PostDataTypeByIdCopyResponses, PostDataTypeData, PostDataTypeErrors, PostDataTypeFolderData, PostDataTypeFolderErrors, PostDataTypeFolderResponses, PostDataTypeResponses, PostDictionaryData, PostDictionaryErrors, PostDictionaryImportData, PostDictionaryImportErrors, PostDictionaryImportResponses, PostDictionaryResponses, PostDocumentBlueprintData, PostDocumentBlueprintErrors, PostDocumentBlueprintFolderData, PostDocumentBlueprintFolderErrors, PostDocumentBlueprintFolderResponses, PostDocumentBlueprintFromDocumentData, PostDocumentBlueprintFromDocumentErrors, PostDocumentBlueprintFromDocumentResponses, PostDocumentBlueprintResponses, PostDocumentByIdCopyData, PostDocumentByIdCopyErrors, PostDocumentByIdCopyResponses, PostDocumentByIdPublicAccessData, PostDocumentByIdPublicAccessErrors, PostDocumentByIdPublicAccessResponses, PostDocumentCreateAndPublishData, PostDocumentCreateAndPublishErrors, PostDocumentCreateAndPublishResponses, PostDocumentData, PostDocumentErrors, PostDocumentResponses, PostDocumentTypeAvailableCompositionsData, PostDocumentTypeAvailableCompositionsErrors, PostDocumentTypeAvailableCompositionsResponses, PostDocumentTypeByIdCopyData, PostDocumentTypeByIdCopyErrors, PostDocumentTypeByIdCopyResponses, PostDocumentTypeByIdTemplateData, PostDocumentTypeByIdTemplateErrors, PostDocumentTypeByIdTemplateResponses, PostDocumentTypeData, PostDocumentTypeErrors, PostDocumentTypeFolderData, PostDocumentTypeFolderErrors, PostDocumentTypeFolderResponses, PostDocumentTypeImportData, PostDocumentTypeImportErrors, PostDocumentTypeImportResponses, PostDocumentTypeResponses, PostDocumentValidateData, PostDocumentValidateErrors, PostDocumentValidateResponses, PostDocumentVersionByIdRollbackData, PostDocumentVersionByIdRollbackErrors, PostDocumentVersionByIdRollbackResponses, PostDynamicRootQueryData, PostDynamicRootQueryErrors, PostDynamicRootQueryResponses, PostElementByIdCopyData, PostElementByIdCopyErrors, PostElementByIdCopyResponses, PostElementCreateAndPublishData, PostElementCreateAndPublishErrors, PostElementCreateAndPublishResponses, PostElementData, PostElementErrors, PostElementFolderData, PostElementFolderErrors, PostElementFolderResponses, PostElementResponses, PostElementValidateData, PostElementValidateErrors, PostElementValidateResponses, PostElementVersionByIdRollbackData, PostElementVersionByIdRollbackErrors, PostElementVersionByIdRollbackResponses, PostHealthCheckExecuteActionData, PostHealthCheckExecuteActionErrors, PostHealthCheckExecuteActionResponses, PostHealthCheckGroupByNameCheckData, PostHealthCheckGroupByNameCheckErrors, PostHealthCheckGroupByNameCheckResponses, PostIndexerByIndexNameRebuildData, PostIndexerByIndexNameRebuildErrors, PostIndexerByIndexNameRebuildResponses, PostInstallSetupData, PostInstallSetupErrors, PostInstallSetupResponses, PostInstallValidateDatabaseData, PostInstallValidateDatabaseErrors, PostInstallValidateDatabaseResponses, PostLanguageData, PostLanguageErrors, PostLanguageResponses, PostLogViewerSavedSearchData, PostLogViewerSavedSearchErrors, PostLogViewerSavedSearchResponses, PostMediaData, PostMediaErrors, PostMediaResponses, PostMediaTypeAvailableCompositionsData, PostMediaTypeAvailableCompositionsErrors, PostMediaTypeAvailableCompositionsResponses, PostMediaTypeByIdCopyData, PostMediaTypeByIdCopyErrors, PostMediaTypeByIdCopyResponses, PostMediaTypeData, PostMediaTypeErrors, PostMediaTypeFolderData, PostMediaTypeFolderErrors, PostMediaTypeFolderResponses, PostMediaTypeImportData, PostMediaTypeImportErrors, PostMediaTypeImportResponses, PostMediaTypeResponses, PostMediaValidateData, PostMediaValidateErrors, PostMediaValidateResponses, PostMemberData, PostMemberErrors, PostMemberGroupData, PostMemberGroupErrors, PostMemberGroupResponses, PostMemberResponses, PostMemberTypeAvailableCompositionsData, PostMemberTypeAvailableCompositionsErrors, PostMemberTypeAvailableCompositionsResponses, PostMemberTypeByIdCopyData, PostMemberTypeByIdCopyErrors, PostMemberTypeByIdCopyResponses, PostMemberTypeData, PostMemberTypeErrors, PostMemberTypeFolderData, PostMemberTypeFolderErrors, PostMemberTypeFolderResponses, PostMemberTypeImportData, PostMemberTypeImportErrors, PostMemberTypeImportResponses, PostMemberTypeResponses, PostMemberValidateData, PostMemberValidateErrors, PostMemberValidateResponses, PostModelsBuilderBuildData, PostModelsBuilderBuildErrors, PostModelsBuilderBuildResponses, PostPackageByNameRunMigrationData, PostPackageByNameRunMigrationErrors, PostPackageByNameRunMigrationResponses, PostPackageCreatedData, PostPackageCreatedErrors, PostPackageCreatedResponses, PostPartialViewData, PostPartialViewErrors, PostPartialViewFolderData, PostPartialViewFolderErrors, PostPartialViewFolderResponses, PostPartialViewResponses, PostPublishedCacheRebuildData, PostPublishedCacheRebuildErrors, PostPublishedCacheRebuildResponses, PostPublishedCacheReloadData, PostPublishedCacheReloadErrors, PostPublishedCacheReloadResponses, PostRedirectManagementStatusData, PostRedirectManagementStatusErrors, PostRedirectManagementStatusResponses, PostScriptData, PostScriptErrors, PostScriptFolderData, PostScriptFolderErrors, PostScriptFolderResponses, PostScriptResponses, PostSecurityForgotPasswordData, PostSecurityForgotPasswordErrors, PostSecurityForgotPasswordResetData, PostSecurityForgotPasswordResetErrors, PostSecurityForgotPasswordResetResponses, PostSecurityForgotPasswordResponses, PostSecurityForgotPasswordVerifyData, PostSecurityForgotPasswordVerifyErrors, PostSecurityForgotPasswordVerifyResponses, PostStylesheetData, PostStylesheetErrors, PostStylesheetFolderData, PostStylesheetFolderErrors, PostStylesheetFolderResponses, PostStylesheetResponses, PostTelemetryLevelData, PostTelemetryLevelErrors, PostTelemetryLevelResponses, PostTemplateData, PostTemplateErrors, PostTemplateQueryExecuteData, PostTemplateQueryExecuteErrors, PostTemplateQueryExecuteResponses, PostTemplateResponses, PostTemporaryFileData, PostTemporaryFileErrors, PostTemporaryFileResponses, PostUpgradeAuthorizeData, PostUpgradeAuthorizeErrors, PostUpgradeAuthorizeResponses, PostUserAvatarByIdData, PostUserAvatarByIdErrors, PostUserAvatarByIdResponses, PostUserByIdChangePasswordData, PostUserByIdChangePasswordErrors, PostUserByIdChangePasswordResponses, PostUserByIdClientCredentialsData, PostUserByIdClientCredentialsErrors, PostUserByIdClientCredentialsResponses, PostUserByIdResetPasswordData, PostUserByIdResetPasswordErrors, PostUserByIdResetPasswordResponses, PostUserCurrent2FaByProviderNameData, PostUserCurrent2FaByProviderNameErrors, PostUserCurrent2FaByProviderNameResponses, PostUserCurrentAvatarData, PostUserCurrentAvatarErrors, PostUserCurrentAvatarResponses, PostUserCurrentChangePasswordData, PostUserCurrentChangePasswordErrors, PostUserCurrentChangePasswordResponses, PostUserData, PostUserDataData, PostUserDataErrors, PostUserDataResponses, PostUserDisableData, PostUserDisableErrors, PostUserDisableResponses, PostUserEnableData, PostUserEnableErrors, PostUserEnableResponses, PostUserErrors, PostUserGroupByIdUsersData, PostUserGroupByIdUsersErrors, PostUserGroupByIdUsersResponses, PostUserGroupData, PostUserGroupErrors, PostUserGroupResponses, PostUserInviteCreatePasswordData, PostUserInviteCreatePasswordErrors, PostUserInviteCreatePasswordResponses, PostUserInviteData, PostUserInviteErrors, PostUserInviteResendData, PostUserInviteResendErrors, PostUserInviteResendResponses, PostUserInviteResponses, PostUserInviteVerifyData, PostUserInviteVerifyErrors, PostUserInviteVerifyResponses, PostUserResponses, PostUserSetUserGroupsData, PostUserSetUserGroupsErrors, PostUserSetUserGroupsResponses, PostUserUnlockData, PostUserUnlockErrors, PostUserUnlockResponses, PostWebhookData, PostWebhookErrors, PostWebhookResponses, PutDataTypeByIdData, PutDataTypeByIdErrors, PutDataTypeByIdMoveData, PutDataTypeByIdMoveErrors, PutDataTypeByIdMoveResponses, PutDataTypeByIdResponses, PutDataTypeFolderByIdData, PutDataTypeFolderByIdErrors, PutDataTypeFolderByIdResponses, PutDictionaryByIdData, PutDictionaryByIdErrors, PutDictionaryByIdMoveData, PutDictionaryByIdMoveErrors, PutDictionaryByIdMoveResponses, PutDictionaryByIdResponses, PutDocumentBlueprintByIdData, PutDocumentBlueprintByIdErrors, PutDocumentBlueprintByIdMoveData, PutDocumentBlueprintByIdMoveErrors, PutDocumentBlueprintByIdMoveResponses, PutDocumentBlueprintByIdResponses, PutDocumentBlueprintFolderByIdData, PutDocumentBlueprintFolderByIdErrors, PutDocumentBlueprintFolderByIdResponses, PutDocumentByIdData, PutDocumentByIdDomainsData, PutDocumentByIdDomainsErrors, PutDocumentByIdDomainsResponses, PutDocumentByIdErrors, PutDocumentByIdMoveData, PutDocumentByIdMoveErrors, PutDocumentByIdMoveResponses, PutDocumentByIdMoveToRecycleBinData, PutDocumentByIdMoveToRecycleBinErrors, PutDocumentByIdMoveToRecycleBinResponses, PutDocumentByIdNotificationsData, PutDocumentByIdNotificationsErrors, PutDocumentByIdNotificationsResponses, PutDocumentByIdPublicAccessData, PutDocumentByIdPublicAccessErrors, PutDocumentByIdPublicAccessResponses, PutDocumentByIdPublishData, PutDocumentByIdPublishErrors, PutDocumentByIdPublishResponses, PutDocumentByIdPublishWithDescendantsData, PutDocumentByIdPublishWithDescendantsErrors, PutDocumentByIdPublishWithDescendantsResponses, PutDocumentByIdResponses, PutDocumentByIdSortChildrenData, PutDocumentByIdSortChildrenErrors, PutDocumentByIdSortChildrenResponses, PutDocumentByIdUnpublishData, PutDocumentByIdUnpublishErrors, PutDocumentByIdUnpublishResponses, PutDocumentByIdUpdateAndPublishData, PutDocumentByIdUpdateAndPublishErrors, PutDocumentByIdUpdateAndPublishResponses, PutDocumentByIdValidateData, PutDocumentByIdValidateErrors, PutDocumentByIdValidateResponses, PutDocumentRootSortChildrenData, PutDocumentRootSortChildrenErrors, PutDocumentRootSortChildrenResponses, PutDocumentSortData, PutDocumentSortErrors, PutDocumentSortResponses, PutDocumentTypeByIdData, PutDocumentTypeByIdErrors, PutDocumentTypeByIdImportData, PutDocumentTypeByIdImportErrors, PutDocumentTypeByIdImportResponses, PutDocumentTypeByIdMoveData, PutDocumentTypeByIdMoveErrors, PutDocumentTypeByIdMoveResponses, PutDocumentTypeByIdResponses, PutDocumentTypeFolderByIdData, PutDocumentTypeFolderByIdErrors, PutDocumentTypeFolderByIdResponses, PutDocumentVersionByIdPreventCleanupData, PutDocumentVersionByIdPreventCleanupErrors, PutDocumentVersionByIdPreventCleanupResponses, PutElementByIdData, PutElementByIdErrors, PutElementByIdMoveData, PutElementByIdMoveErrors, PutElementByIdMoveResponses, PutElementByIdMoveToRecycleBinData, PutElementByIdMoveToRecycleBinErrors, PutElementByIdMoveToRecycleBinResponses, PutElementByIdPublishData, PutElementByIdPublishErrors, PutElementByIdPublishResponses, PutElementByIdResponses, PutElementByIdUnpublishData, PutElementByIdUnpublishErrors, PutElementByIdUnpublishResponses, PutElementByIdUpdateAndPublishData, PutElementByIdUpdateAndPublishErrors, PutElementByIdUpdateAndPublishResponses, PutElementByIdValidateData, PutElementByIdValidateErrors, PutElementByIdValidateResponses, PutElementFolderByIdData, PutElementFolderByIdErrors, PutElementFolderByIdMoveData, PutElementFolderByIdMoveErrors, PutElementFolderByIdMoveResponses, PutElementFolderByIdMoveToRecycleBinData, PutElementFolderByIdMoveToRecycleBinErrors, PutElementFolderByIdMoveToRecycleBinResponses, PutElementFolderByIdResponses, PutElementVersionByIdPreventCleanupData, PutElementVersionByIdPreventCleanupErrors, PutElementVersionByIdPreventCleanupResponses, PutLanguageByIsoCodeData, PutLanguageByIsoCodeErrors, PutLanguageByIsoCodeResponses, PutMediaByIdData, PutMediaByIdErrors, PutMediaByIdMoveData, PutMediaByIdMoveErrors, PutMediaByIdMoveResponses, PutMediaByIdMoveToRecycleBinData, PutMediaByIdMoveToRecycleBinErrors, PutMediaByIdMoveToRecycleBinResponses, PutMediaByIdResponses, PutMediaByIdSortChildrenData, PutMediaByIdSortChildrenErrors, PutMediaByIdSortChildrenResponses, PutMediaByIdValidateData, PutMediaByIdValidateErrors, PutMediaByIdValidateResponses, PutMediaRootSortChildrenData, PutMediaRootSortChildrenErrors, PutMediaRootSortChildrenResponses, PutMediaSortData, PutMediaSortErrors, PutMediaSortResponses, PutMediaTypeByIdData, PutMediaTypeByIdErrors, PutMediaTypeByIdImportData, PutMediaTypeByIdImportErrors, PutMediaTypeByIdImportResponses, PutMediaTypeByIdMoveData, PutMediaTypeByIdMoveErrors, PutMediaTypeByIdMoveResponses, PutMediaTypeByIdResponses, PutMediaTypeFolderByIdData, PutMediaTypeFolderByIdErrors, PutMediaTypeFolderByIdResponses, PutMemberByIdData, PutMemberByIdErrors, PutMemberByIdResponses, PutMemberByIdValidateData, PutMemberByIdValidateErrors, PutMemberByIdValidateResponses, PutMemberGroupByIdData, PutMemberGroupByIdErrors, PutMemberGroupByIdResponses, PutMemberTypeByIdData, PutMemberTypeByIdErrors, PutMemberTypeByIdImportData, PutMemberTypeByIdImportErrors, PutMemberTypeByIdImportResponses, PutMemberTypeByIdMoveData, PutMemberTypeByIdMoveErrors, PutMemberTypeByIdMoveResponses, PutMemberTypeByIdResponses, PutMemberTypeFolderByIdData, PutMemberTypeFolderByIdErrors, PutMemberTypeFolderByIdResponses, PutPackageCreatedByIdData, PutPackageCreatedByIdErrors, PutPackageCreatedByIdResponses, PutPartialViewByPathData, PutPartialViewByPathErrors, PutPartialViewByPathRenameData, PutPartialViewByPathRenameErrors, PutPartialViewByPathRenameResponses, PutPartialViewByPathResponses, PutProfilingStatusData, PutProfilingStatusErrors, PutProfilingStatusResponses, PutRecycleBinDocumentByIdRestoreData, PutRecycleBinDocumentByIdRestoreErrors, PutRecycleBinDocumentByIdRestoreResponses, PutRecycleBinElementByIdRestoreData, PutRecycleBinElementByIdRestoreErrors, PutRecycleBinElementByIdRestoreResponses, PutRecycleBinElementFolderByIdRestoreData, PutRecycleBinElementFolderByIdRestoreErrors, PutRecycleBinElementFolderByIdRestoreResponses, PutRecycleBinMediaByIdRestoreData, PutRecycleBinMediaByIdRestoreErrors, PutRecycleBinMediaByIdRestoreResponses, PutScriptByPathData, PutScriptByPathErrors, PutScriptByPathRenameData, PutScriptByPathRenameErrors, PutScriptByPathRenameResponses, PutScriptByPathResponses, PutStylesheetByPathData, PutStylesheetByPathErrors, PutStylesheetByPathRenameData, PutStylesheetByPathRenameErrors, PutStylesheetByPathRenameResponses, PutStylesheetByPathResponses, PutTemplateByIdData, PutTemplateByIdErrors, PutTemplateByIdResponses, PutUserByIdData, PutUserByIdErrors, PutUserByIdResponses, PutUserCurrentProfileData, PutUserCurrentProfileErrors, PutUserCurrentProfileResponses, PutUserDataData, PutUserDataErrors, PutUserDataResponses, PutUserGroupByIdData, PutUserGroupByIdErrors, PutUserGroupByIdResponses, PutWebhookByIdData, PutWebhookByIdErrors, PutWebhookByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class CultureService {
    /**
     * Gets a paginated collection of cultures available for creating languages.
     *
     * Gets a paginated collection containing the English and localized names of all available cultures.
     */
    public static getCulture<ThrowOnError extends boolean = true>(options?: Options<GetCultureData, ThrowOnError>): RequestResult<GetCultureResponses, GetCultureErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetCultureResponses, GetCultureErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/culture',
            ...options
        });
    }
}

export class DataTypeService {
    /**
     * Creates a new data type.
     *
     * Creates a new data type with the configuration specified in the request model.
     */
    public static postDataType<ThrowOnError extends boolean = true>(options: Options<PostDataTypeData, ThrowOnError>): RequestResult<PostDataTypeResponses, PostDataTypeErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDataTypeResponses, PostDataTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a data type.
     *
     * Deletes a data type identified by the provided Id.
     */
    public static deleteDataTypeById<ThrowOnError extends boolean = true>(options: Options<DeleteDataTypeByIdData, ThrowOnError>): RequestResult<DeleteDataTypeByIdResponses, DeleteDataTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDataTypeByIdResponses, DeleteDataTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/{id}',
            ...options
        });
    }
    
    /**
     * Gets a data type.
     *
     * Gets a data type identified by the provided Id.
     */
    public static getDataTypeById<ThrowOnError extends boolean = true>(options: Options<GetDataTypeByIdData, ThrowOnError>): RequestResult<GetDataTypeByIdResponses, GetDataTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDataTypeByIdResponses, GetDataTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/{id}',
            ...options
        });
    }
    
    /**
     * Updates a data type.
     *
     * Updates a data type identified by the provided Id with the details from the request model.
     */
    public static putDataTypeById<ThrowOnError extends boolean = true>(options: Options<PutDataTypeByIdData, ThrowOnError>): RequestResult<PutDataTypeByIdResponses, PutDataTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDataTypeByIdResponses, PutDataTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Copies a data type.
     *
     * Creates a duplicate of an existing data type identified by the provided unique Id. The copied data type will be given a new Id and have ' (copy)' appended to its name. Optionally, the copy can be placed in a specific container by providing a target container Id.
     */
    public static postDataTypeByIdCopy<ThrowOnError extends boolean = true>(options: Options<PostDataTypeByIdCopyData, ThrowOnError>): RequestResult<PostDataTypeByIdCopyResponses, PostDataTypeByIdCopyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDataTypeByIdCopyResponses, PostDataTypeByIdCopyErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/{id}/copy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Checks if a data type is used.
     *
     * Checks if the data type identified by the provided Id is used in any content, media, or member types.
     */
    public static getDataTypeByIdIsUsed<ThrowOnError extends boolean = true>(options: Options<GetDataTypeByIdIsUsedData, ThrowOnError>): RequestResult<GetDataTypeByIdIsUsedResponses, GetDataTypeByIdIsUsedErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDataTypeByIdIsUsedResponses, GetDataTypeByIdIsUsedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/{id}/is-used',
            ...options
        });
    }
    
    /**
     * Moves a data type.
     *
     * Moves an existing data type identified by Id to a different container. The target container Id must be provided in the request model.
     */
    public static putDataTypeByIdMove<ThrowOnError extends boolean = true>(options: Options<PutDataTypeByIdMoveData, ThrowOnError>): RequestResult<PutDataTypeByIdMoveResponses, PutDataTypeByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDataTypeByIdMoveResponses, PutDataTypeByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a paged collection of entities that are referenced by a data type.
     *
     * Gets a paged collection of entities that are referenced by the data type with the provided Id, so you can see where it is being used.
     */
    public static getDataTypeByIdReferencedBy<ThrowOnError extends boolean = true>(options: Options<GetDataTypeByIdReferencedByData, ThrowOnError>): RequestResult<GetDataTypeByIdReferencedByResponses, GetDataTypeByIdReferencedByErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDataTypeByIdReferencedByResponses, GetDataTypeByIdReferencedByErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/{id}/referenced-by',
            ...options
        });
    }
    
    public static getDataTypeByIdSchema<ThrowOnError extends boolean = true>(options: Options<GetDataTypeByIdSchemaData, ThrowOnError>): RequestResult<GetDataTypeByIdSchemaResponses, GetDataTypeByIdSchemaErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDataTypeByIdSchemaResponses, GetDataTypeByIdSchemaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/{id}/schema',
            ...options
        });
    }
    
    /**
     * Gets multiple data types.
     *
     * Gets multiple data types identified by the provided Ids.
     */
    public static getDataTypeBatch<ThrowOnError extends boolean = true>(options?: Options<GetDataTypeBatchData, ThrowOnError>): RequestResult<GetDataTypeBatchResponses, GetDataTypeBatchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDataTypeBatchResponses, GetDataTypeBatchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/batch',
            ...options
        });
    }
    
    /**
     * Gets the data type configuration.
     *
     * Gets the configuration settings for data types.
     */
    public static getDataTypeConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetDataTypeConfigurationData, ThrowOnError>): RequestResult<GetDataTypeConfigurationResponses, GetDataTypeConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDataTypeConfigurationResponses, GetDataTypeConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/configuration',
            ...options
        });
    }
    
    /**
     * Creates a data type folder.
     *
     * Creates a new data type folder with the provided name and parent location.
     */
    public static postDataTypeFolder<ThrowOnError extends boolean = true>(options: Options<PostDataTypeFolderData, ThrowOnError>): RequestResult<PostDataTypeFolderResponses, PostDataTypeFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDataTypeFolderResponses, PostDataTypeFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a data type folder.
     *
     * Deletes a data type folder identified by the provided Id.
     */
    public static deleteDataTypeFolderById<ThrowOnError extends boolean = true>(options: Options<DeleteDataTypeFolderByIdData, ThrowOnError>): RequestResult<DeleteDataTypeFolderByIdResponses, DeleteDataTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDataTypeFolderByIdResponses, DeleteDataTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/folder/{id}',
            ...options
        });
    }
    
    /**
     * Gets a data type folder.
     *
     * Gets a data type folder identified by the provided Id.
     */
    public static getDataTypeFolderById<ThrowOnError extends boolean = true>(options: Options<GetDataTypeFolderByIdData, ThrowOnError>): RequestResult<GetDataTypeFolderByIdResponses, GetDataTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDataTypeFolderByIdResponses, GetDataTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/folder/{id}',
            ...options
        });
    }
    
    /**
     * Updates a data type folder.
     *
     * Updates a data type folder identified by the provided Id with the details provided in the request model.
     */
    public static putDataTypeFolderById<ThrowOnError extends boolean = true>(options: Options<PutDataTypeFolderByIdData, ThrowOnError>): RequestResult<PutDataTypeFolderByIdResponses, PutDataTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDataTypeFolderByIdResponses, PutDataTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/folder/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getDataTypeSchemasBatch<ThrowOnError extends boolean = true>(options?: Options<GetDataTypeSchemasBatchData, ThrowOnError>): RequestResult<GetDataTypeSchemasBatchResponses, GetDataTypeSchemasBatchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDataTypeSchemasBatchResponses, GetDataTypeSchemasBatchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/data-type/schemas/batch',
            ...options
        });
    }
    
    /**
     * Gets a filtered collection of data types.
     *
     * Filters data types based on the provided criteria with support for pagination.
     */
    public static getFilterDataType<ThrowOnError extends boolean = true>(options?: Options<GetFilterDataTypeData, ThrowOnError>): RequestResult<GetFilterDataTypeResponses, GetFilterDataTypeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetFilterDataTypeResponses, GetFilterDataTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/filter/data-type',
            ...options
        });
    }
    
    /**
     * Gets a collection of data type items.
     *
     * Gets a collection of data type items identified by the provided Ids.
     */
    public static getItemDataType<ThrowOnError extends boolean = true>(options?: Options<GetItemDataTypeData, ThrowOnError>): RequestResult<GetItemDataTypeResponses, GetItemDataTypeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDataTypeResponses, GetItemDataTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/data-type',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of data type items.
     *
     * Gets the ancestor chains for data type items identified by the provided Ids.
     */
    public static getItemDataTypeAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemDataTypeAncestorsData, ThrowOnError>): RequestResult<GetItemDataTypeAncestorsResponses, GetItemDataTypeAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDataTypeAncestorsResponses, GetItemDataTypeAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/data-type/ancestors',
            ...options
        });
    }
    
    /**
     * Searches data type items.
     *
     * Searches data type items by the provided query with pagination support.
     */
    public static getItemDataTypeSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemDataTypeSearchData, ThrowOnError>): RequestResult<GetItemDataTypeSearchResponses, GetItemDataTypeSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDataTypeSearchResponses, GetItemDataTypeSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/data-type/search',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor data type folders.
     *
     * Gets a collection of data type folders that are ancestors to the provided Id.
     */
    public static getTreeDataTypeAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeDataTypeAncestorsData, ThrowOnError>): RequestResult<GetTreeDataTypeAncestorsResponses, GetTreeDataTypeAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDataTypeAncestorsResponses, GetTreeDataTypeAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/data-type/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of data type tree child items.
     *
     * Gets a paginated collection of data type tree items that are children of the provided parent Id.
     */
    public static getTreeDataTypeChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeDataTypeChildrenData, ThrowOnError>): RequestResult<GetTreeDataTypeChildrenResponses, GetTreeDataTypeChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDataTypeChildrenResponses, GetTreeDataTypeChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/data-type/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of data type items from the root of the tree.
     *
     * Gets a paginated collection of data type items from the root of the tree with optional filtering.
     */
    public static getTreeDataTypeRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeDataTypeRootData, ThrowOnError>): RequestResult<GetTreeDataTypeRootResponses, GetTreeDataTypeRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDataTypeRootResponses, GetTreeDataTypeRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/data-type/root',
            ...options
        });
    }
    
    public static getTreeDataTypeSearch<ThrowOnError extends boolean = true>(options?: Options<GetTreeDataTypeSearchData, ThrowOnError>): RequestResult<GetTreeDataTypeSearchResponses, GetTreeDataTypeSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDataTypeSearchResponses, GetTreeDataTypeSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/data-type/search',
            ...options
        });
    }
    
    /**
     * Gets a collection of data type tree sibling items.
     *
     * Gets a paged collection of data type tree items that are siblings of the provided Id. The collection can be optionally filtered to return only folder, or folders and data types.
     */
    public static getTreeDataTypeSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeDataTypeSiblingsData, ThrowOnError>): RequestResult<GetTreeDataTypeSiblingsResponses, GetTreeDataTypeSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDataTypeSiblingsResponses, GetTreeDataTypeSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/data-type/siblings',
            ...options
        });
    }
}

export class DictionaryService {
    /**
     * Gets a paginated collection of dictionary items.
     *
     * Gets a paginated collection of dictionary items with optional filtering by name.
     */
    public static getDictionary<ThrowOnError extends boolean = true>(options?: Options<GetDictionaryData, ThrowOnError>): RequestResult<GetDictionaryResponses, GetDictionaryErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDictionaryResponses, GetDictionaryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dictionary',
            ...options
        });
    }
    
    /**
     * Creates a new dictionary.
     *
     * Creates a new dictionary with the configuration specified in the request model.
     */
    public static postDictionary<ThrowOnError extends boolean = true>(options: Options<PostDictionaryData, ThrowOnError>): RequestResult<PostDictionaryResponses, PostDictionaryErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDictionaryResponses, PostDictionaryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dictionary',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a dictionary.
     *
     * Deletes a dictionary identified by the provided Id.
     */
    public static deleteDictionaryById<ThrowOnError extends boolean = true>(options: Options<DeleteDictionaryByIdData, ThrowOnError>): RequestResult<DeleteDictionaryByIdResponses, DeleteDictionaryByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDictionaryByIdResponses, DeleteDictionaryByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dictionary/{id}',
            ...options
        });
    }
    
    /**
     * Gets a dictionary.
     *
     * Gets a dictionary identified by the provided Id.
     */
    public static getDictionaryById<ThrowOnError extends boolean = true>(options: Options<GetDictionaryByIdData, ThrowOnError>): RequestResult<GetDictionaryByIdResponses, GetDictionaryByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDictionaryByIdResponses, GetDictionaryByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dictionary/{id}',
            ...options
        });
    }
    
    /**
     * Updates a dictionary.
     *
     * Updates a dictionary identified by the provided Id with the details from the request model.
     */
    public static putDictionaryById<ThrowOnError extends boolean = true>(options: Options<PutDictionaryByIdData, ThrowOnError>): RequestResult<PutDictionaryByIdResponses, PutDictionaryByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDictionaryByIdResponses, PutDictionaryByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dictionary/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Exports a dictionary.
     *
     * Exports the dictionary identified by the provided Id to a downloadable format.
     */
    public static getDictionaryByIdExport<ThrowOnError extends boolean = true>(options: Options<GetDictionaryByIdExportData, ThrowOnError>): RequestResult<GetDictionaryByIdExportResponses, GetDictionaryByIdExportErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDictionaryByIdExportResponses, GetDictionaryByIdExportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dictionary/{id}/export',
            ...options
        });
    }
    
    /**
     * Moves a dictionary.
     *
     * Moves a dictionary identified by the provided Id to a different location.
     */
    public static putDictionaryByIdMove<ThrowOnError extends boolean = true>(options: Options<PutDictionaryByIdMoveData, ThrowOnError>): RequestResult<PutDictionaryByIdMoveResponses, PutDictionaryByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDictionaryByIdMoveResponses, PutDictionaryByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dictionary/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Imports a dictionary.
     *
     * Imports a dictionary from the provided file upload.
     */
    public static postDictionaryImport<ThrowOnError extends boolean = true>(options: Options<PostDictionaryImportData, ThrowOnError>): RequestResult<PostDictionaryImportResponses, PostDictionaryImportErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDictionaryImportResponses, PostDictionaryImportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dictionary/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of dictionary items.
     *
     * Gets a collection of dictionary items identified by the provided Ids.
     */
    public static getItemDictionary<ThrowOnError extends boolean = true>(options?: Options<GetItemDictionaryData, ThrowOnError>): RequestResult<GetItemDictionaryResponses, GetItemDictionaryErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDictionaryResponses, GetItemDictionaryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/dictionary',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor dictionary items.
     *
     * Gets a collection of dictionary items that are ancestors to the provided Id.
     */
    public static getTreeDictionaryAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeDictionaryAncestorsData, ThrowOnError>): RequestResult<GetTreeDictionaryAncestorsResponses, GetTreeDictionaryAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDictionaryAncestorsResponses, GetTreeDictionaryAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/dictionary/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of dictionary tree child items.
     *
     * Gets a paginated collection of dictionary tree items that are children of the provided parent Id.
     */
    public static getTreeDictionaryChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeDictionaryChildrenData, ThrowOnError>): RequestResult<GetTreeDictionaryChildrenResponses, GetTreeDictionaryChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDictionaryChildrenResponses, GetTreeDictionaryChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/dictionary/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of dictionary items from the root of the tree.
     *
     * Gets a paginated collection of dictionary items from the root of the tree with optional filtering.
     */
    public static getTreeDictionaryRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeDictionaryRootData, ThrowOnError>): RequestResult<GetTreeDictionaryRootResponses, GetTreeDictionaryRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDictionaryRootResponses, GetTreeDictionaryRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/dictionary/root',
            ...options
        });
    }
}

export class DocumentService {
    /**
     * Validates updating a document.
     *
     * Validates the request model for updating a document without actually updating it.
     */
    public static putDocumentByIdValidate<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdValidateData, ThrowOnError>): RequestResult<PutDocumentByIdValidateResponses, PutDocumentByIdValidateErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdValidateResponses, PutDocumentByIdValidateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1.1/document/{id}/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a document collection.
     *
     * Gets a document collection identified by the provided Id.
     */
    public static getCollectionDocumentById<ThrowOnError extends boolean = true>(options: Options<GetCollectionDocumentByIdData, ThrowOnError>): RequestResult<GetCollectionDocumentByIdResponses, GetCollectionDocumentByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetCollectionDocumentByIdResponses, GetCollectionDocumentByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/collection/document/{id}',
            ...options
        });
    }
    
    /**
     * Creates a new document.
     *
     * Creates a new document with the configuration specified in the request model.
     */
    public static postDocument<ThrowOnError extends boolean = true>(options: Options<PostDocumentData, ThrowOnError>): RequestResult<PostDocumentResponses, PostDocumentErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentResponses, PostDocumentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a document.
     *
     * Deletes a document identified by the provided Id.
     */
    public static deleteDocumentById<ThrowOnError extends boolean = true>(options: Options<DeleteDocumentByIdData, ThrowOnError>): RequestResult<DeleteDocumentByIdResponses, DeleteDocumentByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDocumentByIdResponses, DeleteDocumentByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}',
            ...options
        });
    }
    
    /**
     * Gets a document.
     *
     * Gets a document identified by the provided Id.
     */
    public static getDocumentById<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdData, ThrowOnError>): RequestResult<GetDocumentByIdResponses, GetDocumentByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdResponses, GetDocumentByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}',
            ...options
        });
    }
    
    /**
     * Updates a document.
     *
     * Updates a document identified by the provided Id with the details from the request model.
     */
    public static putDocumentById<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdData, ThrowOnError>): RequestResult<PutDocumentByIdResponses, PutDocumentByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdResponses, PutDocumentByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets the audit log for a document.
     *
     * Gets a paginated collection of audit log entries for the document identified by the provided Id.
     */
    public static getDocumentByIdAuditLog<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdAuditLogData, ThrowOnError>): RequestResult<GetDocumentByIdAuditLogResponses, GetDocumentByIdAuditLogErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdAuditLogResponses, GetDocumentByIdAuditLogErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/audit-log',
            ...options
        });
    }
    
    /**
     * Gets available segments.
     *
     * Gets a collection of available content segments for the system.
     */
    public static getDocumentByIdAvailableSegmentOptions<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdAvailableSegmentOptionsData, ThrowOnError>): RequestResult<GetDocumentByIdAvailableSegmentOptionsResponses, GetDocumentByIdAvailableSegmentOptionsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdAvailableSegmentOptionsResponses, GetDocumentByIdAvailableSegmentOptionsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/available-segment-options',
            ...options
        });
    }
    
    /**
     * Copies a document.
     *
     * Creates a duplicate of an existing document identified by the provided Id.
     */
    public static postDocumentByIdCopy<ThrowOnError extends boolean = true>(options: Options<PostDocumentByIdCopyData, ThrowOnError>): RequestResult<PostDocumentByIdCopyResponses, PostDocumentByIdCopyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentByIdCopyResponses, PostDocumentByIdCopyErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/copy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets domains for a document.
     *
     * Gets the domains and culture settings assigned to the document identified by the provided Id.
     */
    public static getDocumentByIdDomains<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdDomainsData, ThrowOnError>): RequestResult<GetDocumentByIdDomainsResponses, GetDocumentByIdDomainsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdDomainsResponses, GetDocumentByIdDomainsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/domains',
            ...options
        });
    }
    
    /**
     * Updates the domains for a document.
     *
     * Updates the domains for the document identified by the provided Id with the details from the request model.
     */
    public static putDocumentByIdDomains<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdDomainsData, ThrowOnError>): RequestResult<PutDocumentByIdDomainsResponses, PutDocumentByIdDomainsErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdDomainsResponses, PutDocumentByIdDomainsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/domains',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves a document.
     *
     * Moves a document identified by the provided Id to a different location.
     */
    public static putDocumentByIdMove<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdMoveData, ThrowOnError>): RequestResult<PutDocumentByIdMoveResponses, PutDocumentByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdMoveResponses, PutDocumentByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves a document to the recycle bin.
     *
     * Moves a document identified by the provided Id to the recycle bin.
     */
    public static putDocumentByIdMoveToRecycleBin<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdMoveToRecycleBinData, ThrowOnError>): RequestResult<PutDocumentByIdMoveToRecycleBinResponses, PutDocumentByIdMoveToRecycleBinErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdMoveToRecycleBinResponses, PutDocumentByIdMoveToRecycleBinErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/move-to-recycle-bin',
            ...options
        });
    }
    
    /**
     * Gets notifications for a document.
     *
     * Gets the notifications for the document identified by the provided Id.
     */
    public static getDocumentByIdNotifications<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdNotificationsData, ThrowOnError>): RequestResult<GetDocumentByIdNotificationsResponses, GetDocumentByIdNotificationsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdNotificationsResponses, GetDocumentByIdNotificationsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/notifications',
            ...options
        });
    }
    
    /**
     * Updates notification subscriptions for a document.
     *
     * Updates which actions the current user is subscribed to receive notifications for on the specified document.
     */
    public static putDocumentByIdNotifications<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdNotificationsData, ThrowOnError>): RequestResult<PutDocumentByIdNotificationsResponses, PutDocumentByIdNotificationsErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdNotificationsResponses, PutDocumentByIdNotificationsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/notifications',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Make partial updates to a document. For more information, see the documentation at https://docs.umbraco.com/umbraco-cms/reference/management-api/patching/document-endpoint-guide or https://docs.umbraco.com/umbraco-cms/reference/management-api/patching/document-endpoint-spec
     */
    public static patchDocumentByIdPatch<ThrowOnError extends boolean = true>(options: Options<PatchDocumentByIdPatchData, ThrowOnError>): RequestResult<PatchDocumentByIdPatchResponses, PatchDocumentByIdPatchErrors, ThrowOnError> {
        return (options.client ?? client).patch<PatchDocumentByIdPatchResponses, PatchDocumentByIdPatchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/patch',
            ...options,
            headers: {
                'Content-Type': 'application/json-patch+json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets the preview URL for a document.
     *
     * Gets the preview URL for the document identified by the provided Id.
     */
    public static getDocumentByIdPreviewUrl<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdPreviewUrlData, ThrowOnError>): RequestResult<GetDocumentByIdPreviewUrlResponses, GetDocumentByIdPreviewUrlErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdPreviewUrlResponses, GetDocumentByIdPreviewUrlErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/preview-url',
            ...options
        });
    }
    
    /**
     * Removes public access settings for a document.
     *
     * Removes public access protection/rules for the document identified by the provided Id.
     */
    public static deleteDocumentByIdPublicAccess<ThrowOnError extends boolean = true>(options: Options<DeleteDocumentByIdPublicAccessData, ThrowOnError>): RequestResult<DeleteDocumentByIdPublicAccessResponses, DeleteDocumentByIdPublicAccessErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDocumentByIdPublicAccessResponses, DeleteDocumentByIdPublicAccessErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/public-access',
            ...options
        });
    }
    
    /**
     * Gets public access rules for a document.
     *
     * Gets the public access protection settings for the document identified by the provided Id.
     */
    public static getDocumentByIdPublicAccess<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdPublicAccessData, ThrowOnError>): RequestResult<GetDocumentByIdPublicAccessResponses, GetDocumentByIdPublicAccessErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdPublicAccessResponses, GetDocumentByIdPublicAccessErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/public-access',
            ...options
        });
    }
    
    /**
     * Creates public access rules for a document.
     *
     * Creates public access protection for the document identified by the provided Id.
     */
    public static postDocumentByIdPublicAccess<ThrowOnError extends boolean = true>(options: Options<PostDocumentByIdPublicAccessData, ThrowOnError>): RequestResult<PostDocumentByIdPublicAccessResponses, PostDocumentByIdPublicAccessErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentByIdPublicAccessResponses, PostDocumentByIdPublicAccessErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/public-access',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Updates public access protection for a document.
     *
     * Updates the member protection settings for a document, controlling which members or member groups can access it.
     */
    public static putDocumentByIdPublicAccess<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdPublicAccessData, ThrowOnError>): RequestResult<PutDocumentByIdPublicAccessResponses, PutDocumentByIdPublicAccessErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdPublicAccessResponses, PutDocumentByIdPublicAccessErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/public-access',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Publishes a document.
     *
     * Publishes a document identified by the provided Id.
     */
    public static putDocumentByIdPublish<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdPublishData, ThrowOnError>): RequestResult<PutDocumentByIdPublishResponses, PutDocumentByIdPublishErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdPublishResponses, PutDocumentByIdPublishErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Publishes a document with its descendants.
     *
     * Publishes a document and its descendants identified by the provided Id.
     */
    public static putDocumentByIdPublishWithDescendants<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdPublishWithDescendantsData, ThrowOnError>): RequestResult<PutDocumentByIdPublishWithDescendantsResponses, PutDocumentByIdPublishWithDescendantsErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdPublishWithDescendantsResponses, PutDocumentByIdPublishWithDescendantsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/publish-with-descendants',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets the result of publishing a document with descendants.
     *
     * Gets the status and result of a publish with descendants operation.
     */
    public static getDocumentByIdPublishWithDescendantsResultByTaskId<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdPublishWithDescendantsResultByTaskIdData, ThrowOnError>): RequestResult<GetDocumentByIdPublishWithDescendantsResultByTaskIdResponses, GetDocumentByIdPublishWithDescendantsResultByTaskIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdPublishWithDescendantsResultByTaskIdResponses, GetDocumentByIdPublishWithDescendantsResultByTaskIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/publish-with-descendants/result/{taskId}',
            ...options
        });
    }
    
    /**
     * Gets a document.
     *
     * Gets a document identified by the provided Id.
     */
    public static getDocumentByIdPublished<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdPublishedData, ThrowOnError>): RequestResult<GetDocumentByIdPublishedResponses, GetDocumentByIdPublishedErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdPublishedResponses, GetDocumentByIdPublishedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/published',
            ...options
        });
    }
    
    /**
     * Gets a collection of items that reference documents.
     *
     * Gets a paginated collection of items that reference the documents identified by the provided Ids.
     */
    public static getDocumentByIdReferencedBy<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdReferencedByData, ThrowOnError>): RequestResult<GetDocumentByIdReferencedByResponses, GetDocumentByIdReferencedByErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdReferencedByResponses, GetDocumentByIdReferencedByErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/referenced-by',
            ...options
        });
    }
    
    /**
     * Gets document descendants that are referenced.
     *
     * Gets a paginated collection of descendant documents that are referenced by other content.
     */
    public static getDocumentByIdReferencedDescendants<ThrowOnError extends boolean = true>(options: Options<GetDocumentByIdReferencedDescendantsData, ThrowOnError>): RequestResult<GetDocumentByIdReferencedDescendantsResponses, GetDocumentByIdReferencedDescendantsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentByIdReferencedDescendantsResponses, GetDocumentByIdReferencedDescendantsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/referenced-descendants',
            ...options
        });
    }
    
    /**
     * Sorts the children of a document by a field.
     *
     * Sorts the children of the specified parent document by a system field in the given direction. When sorting by name, an optional culture selects the variant name; the culture is not validated, so children that do not vary by it (or an unrecognised culture) fall back to the invariant name.
     */
    public static putDocumentByIdSortChildren<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdSortChildrenData, ThrowOnError>): RequestResult<PutDocumentByIdSortChildrenResponses, PutDocumentByIdSortChildrenErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdSortChildrenResponses, PutDocumentByIdSortChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/sort-children',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Unpublishes a document.
     *
     * Unpublishes a document identified by the provided Id.
     */
    public static putDocumentByIdUnpublish<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdUnpublishData, ThrowOnError>): RequestResult<PutDocumentByIdUnpublishResponses, PutDocumentByIdUnpublishErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdUnpublishResponses, PutDocumentByIdUnpublishErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/unpublish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Updates and publishes a document.
     *
     * Updates and publishes a document identified by the provided Id with the details from the request model.
     */
    public static putDocumentByIdUpdateAndPublish<ThrowOnError extends boolean = true>(options: Options<PutDocumentByIdUpdateAndPublishData, ThrowOnError>): RequestResult<PutDocumentByIdUpdateAndPublishResponses, PutDocumentByIdUpdateAndPublishErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentByIdUpdateAndPublishResponses, PutDocumentByIdUpdateAndPublishErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/{id}/update-and-publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of items that reference documents.
     *
     * Gets a paginated collection of items that reference the documents identified by the provided Ids.
     */
    public static getDocumentAreReferenced<ThrowOnError extends boolean = true>(options?: Options<GetDocumentAreReferencedData, ThrowOnError>): RequestResult<GetDocumentAreReferencedResponses, GetDocumentAreReferencedErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDocumentAreReferencedResponses, GetDocumentAreReferencedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/are-referenced',
            ...options
        });
    }
    
    /**
     * Gets the document configuration.
     *
     * Gets the configuration settings for documents.
     */
    public static getDocumentConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetDocumentConfigurationData, ThrowOnError>): RequestResult<GetDocumentConfigurationResponses, GetDocumentConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDocumentConfigurationResponses, GetDocumentConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/configuration',
            ...options
        });
    }
    
    /**
     * Creates and publishes a new document.
     *
     * Creates and publishes a new document with the configuration specified in the request model.
     */
    public static postDocumentCreateAndPublish<ThrowOnError extends boolean = true>(options: Options<PostDocumentCreateAndPublishData, ThrowOnError>): RequestResult<PostDocumentCreateAndPublishResponses, PostDocumentCreateAndPublishErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentCreateAndPublishResponses, PostDocumentCreateAndPublishErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/create-and-publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sorts the root-level documents by a field.
     *
     * Sorts the root-level documents by a system field in the given direction. When sorting by name, an optional culture selects the variant name; the culture is not validated, so documents that do not vary by it (or an unrecognised culture) fall back to the invariant name.
     */
    public static putDocumentRootSortChildren<ThrowOnError extends boolean = true>(options: Options<PutDocumentRootSortChildrenData, ThrowOnError>): RequestResult<PutDocumentRootSortChildrenResponses, PutDocumentRootSortChildrenErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentRootSortChildrenResponses, PutDocumentRootSortChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/root/sort-children',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sorts documents.
     *
     * Sorts documents in the specified parent container according to the provided sort order.
     */
    public static putDocumentSort<ThrowOnError extends boolean = true>(options: Options<PutDocumentSortData, ThrowOnError>): RequestResult<PutDocumentSortResponses, PutDocumentSortErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentSortResponses, PutDocumentSortErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/sort',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets URLs for a document.
     *
     * Gets the URLs for the document identified by the provided Id.
     */
    public static getDocumentUrls<ThrowOnError extends boolean = true>(options?: Options<GetDocumentUrlsData, ThrowOnError>): RequestResult<GetDocumentUrlsResponses, GetDocumentUrlsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDocumentUrlsResponses, GetDocumentUrlsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/urls',
            ...options
        });
    }
    
    /**
     * Validates creating a document.
     *
     * Validates the request model for creating a new document without actually creating it.
     */
    public static postDocumentValidate<ThrowOnError extends boolean = true>(options: Options<PostDocumentValidateData, ThrowOnError>): RequestResult<PostDocumentValidateResponses, PostDocumentValidateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentValidateResponses, PostDocumentValidateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of document items.
     *
     * Gets a collection of document items identified by the provided Ids.
     */
    public static getItemDocument<ThrowOnError extends boolean = true>(options?: Options<GetItemDocumentData, ThrowOnError>): RequestResult<GetItemDocumentResponses, GetItemDocumentErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDocumentResponses, GetItemDocumentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/document',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of document items.
     *
     * Gets the ancestor chains for document items identified by the provided Ids.
     */
    public static getItemDocumentAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemDocumentAncestorsData, ThrowOnError>): RequestResult<GetItemDocumentAncestorsResponses, GetItemDocumentAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDocumentAncestorsResponses, GetItemDocumentAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/document/ancestors',
            ...options
        });
    }
    
    /**
     * Searches document items.
     *
     * Searches document items by the provided query with pagination support.
     */
    public static getItemDocumentSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemDocumentSearchData, ThrowOnError>): RequestResult<GetItemDocumentSearchResponses, GetItemDocumentSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDocumentSearchResponses, GetItemDocumentSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/document/search',
            ...options
        });
    }
    
    /**
     * Empties the document recycle bin.
     *
     * Permanently deletes all documents in the recycle bin. This operation cannot be undone.
     */
    public static deleteRecycleBinDocument<ThrowOnError extends boolean = true>(options?: Options<DeleteRecycleBinDocumentData, ThrowOnError>): RequestResult<DeleteRecycleBinDocumentResponses, DeleteRecycleBinDocumentErrors, ThrowOnError> {
        return (options?.client ?? client).delete<DeleteRecycleBinDocumentResponses, DeleteRecycleBinDocumentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/document',
            ...options
        });
    }
    
    /**
     * Deletes a document.
     *
     * Deletes a document identified by the provided Id.
     */
    public static deleteRecycleBinDocumentById<ThrowOnError extends boolean = true>(options: Options<DeleteRecycleBinDocumentByIdData, ThrowOnError>): RequestResult<DeleteRecycleBinDocumentByIdResponses, DeleteRecycleBinDocumentByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteRecycleBinDocumentByIdResponses, DeleteRecycleBinDocumentByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/document/{id}',
            ...options
        });
    }
    
    /**
     * Gets the original parent of a document in the recycle bin.
     *
     * Gets the original parent location of a document before it was moved to the recycle bin.
     */
    public static getRecycleBinDocumentByIdOriginalParent<ThrowOnError extends boolean = true>(options: Options<GetRecycleBinDocumentByIdOriginalParentData, ThrowOnError>): RequestResult<GetRecycleBinDocumentByIdOriginalParentResponses, GetRecycleBinDocumentByIdOriginalParentErrors, ThrowOnError> {
        return (options.client ?? client).get<GetRecycleBinDocumentByIdOriginalParentResponses, GetRecycleBinDocumentByIdOriginalParentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/document/{id}/original-parent',
            ...options
        });
    }
    
    /**
     * Restores a document from the recycle bin.
     *
     * Restores a document from the recycle bin to its original location or a specified parent.
     */
    public static putRecycleBinDocumentByIdRestore<ThrowOnError extends boolean = true>(options: Options<PutRecycleBinDocumentByIdRestoreData, ThrowOnError>): RequestResult<PutRecycleBinDocumentByIdRestoreResponses, PutRecycleBinDocumentByIdRestoreErrors, ThrowOnError> {
        return (options.client ?? client).put<PutRecycleBinDocumentByIdRestoreResponses, PutRecycleBinDocumentByIdRestoreErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/document/{id}/restore',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of documents in the recycle bin.
     *
     * Gets a paginated collection of documents that are children of the provided parent in the recycle bin.
     */
    public static getRecycleBinDocumentChildren<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinDocumentChildrenData, ThrowOnError>): RequestResult<GetRecycleBinDocumentChildrenResponses, GetRecycleBinDocumentChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinDocumentChildrenResponses, GetRecycleBinDocumentChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/document/children',
            ...options
        });
    }
    
    /**
     * Gets items referencing a document in the recycle bin.
     *
     * Gets a paginated collection of items that reference the document in the recycle bin.
     */
    public static getRecycleBinDocumentReferencedBy<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinDocumentReferencedByData, ThrowOnError>): RequestResult<GetRecycleBinDocumentReferencedByResponses, GetRecycleBinDocumentReferencedByErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinDocumentReferencedByResponses, GetRecycleBinDocumentReferencedByErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/document/referenced-by',
            ...options
        });
    }
    
    /**
     * Gets documents at the root of the recycle bin.
     *
     * Gets a paginated collection of documents at the root level of the recycle bin.
     */
    public static getRecycleBinDocumentRoot<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinDocumentRootData, ThrowOnError>): RequestResult<GetRecycleBinDocumentRootResponses, GetRecycleBinDocumentRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinDocumentRootResponses, GetRecycleBinDocumentRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/document/root',
            ...options
        });
    }
    
    /**
     * Gets sibling documents in the recycle bin.
     *
     * Gets a collection of sibling documents in the recycle bin at the same level as the provided Id.
     */
    public static getRecycleBinDocumentSiblings<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinDocumentSiblingsData, ThrowOnError>): RequestResult<GetRecycleBinDocumentSiblingsResponses, GetRecycleBinDocumentSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinDocumentSiblingsResponses, GetRecycleBinDocumentSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/document/siblings',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor document items.
     *
     * Gets a collection of document items that are ancestors to the provided Id.
     */
    public static getTreeDocumentAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentAncestorsData, ThrowOnError>): RequestResult<GetTreeDocumentAncestorsResponses, GetTreeDocumentAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentAncestorsResponses, GetTreeDocumentAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of document tree child items.
     *
     * Gets a paginated collection of document tree items that are children of the provided parent Id.
     */
    public static getTreeDocumentChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentChildrenData, ThrowOnError>): RequestResult<GetTreeDocumentChildrenResponses, GetTreeDocumentChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentChildrenResponses, GetTreeDocumentChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of document items from the root of the tree.
     *
     * Gets a paginated collection of document items from the root of the tree with optional filtering.
     */
    public static getTreeDocumentRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentRootData, ThrowOnError>): RequestResult<GetTreeDocumentRootResponses, GetTreeDocumentRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentRootResponses, GetTreeDocumentRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of document tree sibling items.
     *
     * Gets a collection of document tree items that are siblings of the provided Id.
     */
    public static getTreeDocumentSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentSiblingsData, ThrowOnError>): RequestResult<GetTreeDocumentSiblingsResponses, GetTreeDocumentSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentSiblingsResponses, GetTreeDocumentSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document/siblings',
            ...options
        });
    }
}

export class DocumentBlueprintService {
    /**
     * Creates a new document blueprint.
     *
     * Creates a new document blueprint with the configuration specified in the request model.
     */
    public static postDocumentBlueprint<ThrowOnError extends boolean = true>(options: Options<PostDocumentBlueprintData, ThrowOnError>): RequestResult<PostDocumentBlueprintResponses, PostDocumentBlueprintErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentBlueprintResponses, PostDocumentBlueprintErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a document blueprint.
     *
     * Deletes a document blueprint identified by the provided Id.
     */
    public static deleteDocumentBlueprintById<ThrowOnError extends boolean = true>(options: Options<DeleteDocumentBlueprintByIdData, ThrowOnError>): RequestResult<DeleteDocumentBlueprintByIdResponses, DeleteDocumentBlueprintByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDocumentBlueprintByIdResponses, DeleteDocumentBlueprintByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/{id}',
            ...options
        });
    }
    
    /**
     * Gets a document blueprint.
     *
     * Gets a document blueprint identified by the provided Id.
     */
    public static getDocumentBlueprintById<ThrowOnError extends boolean = true>(options: Options<GetDocumentBlueprintByIdData, ThrowOnError>): RequestResult<GetDocumentBlueprintByIdResponses, GetDocumentBlueprintByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentBlueprintByIdResponses, GetDocumentBlueprintByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/{id}',
            ...options
        });
    }
    
    /**
     * Updates a document blueprint.
     *
     * Updates a document blueprint identified by the provided Id with the details from the request model.
     */
    public static putDocumentBlueprintById<ThrowOnError extends boolean = true>(options: Options<PutDocumentBlueprintByIdData, ThrowOnError>): RequestResult<PutDocumentBlueprintByIdResponses, PutDocumentBlueprintByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentBlueprintByIdResponses, PutDocumentBlueprintByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets the audit log for a document blueprint.
     *
     * Gets a paginated collection of audit log entries for the document blueprint identified by the provided Id.
     */
    public static getDocumentBlueprintByIdAuditLog<ThrowOnError extends boolean = true>(options: Options<GetDocumentBlueprintByIdAuditLogData, ThrowOnError>): RequestResult<GetDocumentBlueprintByIdAuditLogResponses, GetDocumentBlueprintByIdAuditLogErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentBlueprintByIdAuditLogResponses, GetDocumentBlueprintByIdAuditLogErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/{id}/audit-log',
            ...options
        });
    }
    
    /**
     * Moves a document blueprint.
     *
     * Moves a document blueprint identified by the provided Id to a different location.
     */
    public static putDocumentBlueprintByIdMove<ThrowOnError extends boolean = true>(options: Options<PutDocumentBlueprintByIdMoveData, ThrowOnError>): RequestResult<PutDocumentBlueprintByIdMoveResponses, PutDocumentBlueprintByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentBlueprintByIdMoveResponses, PutDocumentBlueprintByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Scaffolds a document blueprint.
     *
     * Creates a scaffold for a new document blueprint with default values.
     */
    public static getDocumentBlueprintByIdScaffold<ThrowOnError extends boolean = true>(options: Options<GetDocumentBlueprintByIdScaffoldData, ThrowOnError>): RequestResult<GetDocumentBlueprintByIdScaffoldResponses, GetDocumentBlueprintByIdScaffoldErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentBlueprintByIdScaffoldResponses, GetDocumentBlueprintByIdScaffoldErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/{id}/scaffold',
            ...options
        });
    }
    
    /**
     * Creates a document blueprint folder.
     *
     * Creates a new document blueprint folder with the provided name and parent location.
     */
    public static postDocumentBlueprintFolder<ThrowOnError extends boolean = true>(options: Options<PostDocumentBlueprintFolderData, ThrowOnError>): RequestResult<PostDocumentBlueprintFolderResponses, PostDocumentBlueprintFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentBlueprintFolderResponses, PostDocumentBlueprintFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a document blueprint folder.
     *
     * Deletes a document blueprint folder identified by the provided Id.
     */
    public static deleteDocumentBlueprintFolderById<ThrowOnError extends boolean = true>(options: Options<DeleteDocumentBlueprintFolderByIdData, ThrowOnError>): RequestResult<DeleteDocumentBlueprintFolderByIdResponses, DeleteDocumentBlueprintFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDocumentBlueprintFolderByIdResponses, DeleteDocumentBlueprintFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/folder/{id}',
            ...options
        });
    }
    
    /**
     * Gets a document blueprint folder.
     *
     * Gets a document blueprint folder identified by the provided Id.
     */
    public static getDocumentBlueprintFolderById<ThrowOnError extends boolean = true>(options: Options<GetDocumentBlueprintFolderByIdData, ThrowOnError>): RequestResult<GetDocumentBlueprintFolderByIdResponses, GetDocumentBlueprintFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentBlueprintFolderByIdResponses, GetDocumentBlueprintFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/folder/{id}',
            ...options
        });
    }
    
    /**
     * Updates a document blueprint folder.
     *
     * Updates a document blueprint folder identified by the provided Id with the details from the request model.
     */
    public static putDocumentBlueprintFolderById<ThrowOnError extends boolean = true>(options: Options<PutDocumentBlueprintFolderByIdData, ThrowOnError>): RequestResult<PutDocumentBlueprintFolderByIdResponses, PutDocumentBlueprintFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentBlueprintFolderByIdResponses, PutDocumentBlueprintFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/folder/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Creates a document blueprint from an existing document.
     *
     * Creates a new document blueprint based on an existing document identified by the provided Id.
     */
    public static postDocumentBlueprintFromDocument<ThrowOnError extends boolean = true>(options: Options<PostDocumentBlueprintFromDocumentData, ThrowOnError>): RequestResult<PostDocumentBlueprintFromDocumentResponses, PostDocumentBlueprintFromDocumentErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentBlueprintFromDocumentResponses, PostDocumentBlueprintFromDocumentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-blueprint/from-document',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of document blueprint items.
     *
     * Gets a collection of document blueprint items identified by the provided Ids.
     */
    public static getItemDocumentBlueprint<ThrowOnError extends boolean = true>(options?: Options<GetItemDocumentBlueprintData, ThrowOnError>): RequestResult<GetItemDocumentBlueprintResponses, GetItemDocumentBlueprintErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDocumentBlueprintResponses, GetItemDocumentBlueprintErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/document-blueprint',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor document blueprint items.
     *
     * Gets a collection of document blueprint items that are ancestors to the provided Id.
     */
    public static getTreeDocumentBlueprintAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentBlueprintAncestorsData, ThrowOnError>): RequestResult<GetTreeDocumentBlueprintAncestorsResponses, GetTreeDocumentBlueprintAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentBlueprintAncestorsResponses, GetTreeDocumentBlueprintAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-blueprint/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of document blueprint tree child items.
     *
     * Gets a paginated collection of document blueprint tree items that are children of the provided parent Id.
     */
    public static getTreeDocumentBlueprintChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentBlueprintChildrenData, ThrowOnError>): RequestResult<GetTreeDocumentBlueprintChildrenResponses, GetTreeDocumentBlueprintChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentBlueprintChildrenResponses, GetTreeDocumentBlueprintChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-blueprint/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of document blueprint items from the root of the tree.
     *
     * Gets a paginated collection of document blueprint items from the root of the tree with optional filtering.
     */
    public static getTreeDocumentBlueprintRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentBlueprintRootData, ThrowOnError>): RequestResult<GetTreeDocumentBlueprintRootResponses, GetTreeDocumentBlueprintRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentBlueprintRootResponses, GetTreeDocumentBlueprintRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-blueprint/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of document blueprint tree sibling items.
     *
     * Gets a collection of document blueprint tree items that are siblings of the provided Id.
     */
    public static getTreeDocumentBlueprintSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentBlueprintSiblingsData, ThrowOnError>): RequestResult<GetTreeDocumentBlueprintSiblingsResponses, GetTreeDocumentBlueprintSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentBlueprintSiblingsResponses, GetTreeDocumentBlueprintSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-blueprint/siblings',
            ...options
        });
    }
}

export class DocumentTypeService {
    /**
     * Creates a new document type.
     *
     * Creates a new document type with the configuration specified in the request model.
     */
    public static postDocumentType<ThrowOnError extends boolean = true>(options: Options<PostDocumentTypeData, ThrowOnError>): RequestResult<PostDocumentTypeResponses, PostDocumentTypeErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentTypeResponses, PostDocumentTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a document type.
     *
     * Deletes a document type identified by the provided Id.
     */
    public static deleteDocumentTypeById<ThrowOnError extends boolean = true>(options: Options<DeleteDocumentTypeByIdData, ThrowOnError>): RequestResult<DeleteDocumentTypeByIdResponses, DeleteDocumentTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDocumentTypeByIdResponses, DeleteDocumentTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}',
            ...options
        });
    }
    
    /**
     * Gets a document type.
     *
     * Gets a document type identified by the provided Id.
     */
    public static getDocumentTypeById<ThrowOnError extends boolean = true>(options: Options<GetDocumentTypeByIdData, ThrowOnError>): RequestResult<GetDocumentTypeByIdResponses, GetDocumentTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentTypeByIdResponses, GetDocumentTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}',
            ...options
        });
    }
    
    /**
     * Updates a document type.
     *
     * Updates a document type identified by the provided Id with the details from the request model.
     */
    public static putDocumentTypeById<ThrowOnError extends boolean = true>(options: Options<PutDocumentTypeByIdData, ThrowOnError>): RequestResult<PutDocumentTypeByIdResponses, PutDocumentTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentTypeByIdResponses, PutDocumentTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets allowed child document types.
     *
     * Gets a collection of document types that are allowed as children of the specified parent document type.
     */
    public static getDocumentTypeByIdAllowedChildren<ThrowOnError extends boolean = true>(options: Options<GetDocumentTypeByIdAllowedChildrenData, ThrowOnError>): RequestResult<GetDocumentTypeByIdAllowedChildrenResponses, GetDocumentTypeByIdAllowedChildrenErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentTypeByIdAllowedChildrenResponses, GetDocumentTypeByIdAllowedChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/allowed-children',
            ...options
        });
    }
    
    /**
     * Gets allowed parent document types.
     *
     * Gets a collection of document types that are allowed as parents of the specified document type.
     */
    public static getDocumentTypeByIdAllowedParents<ThrowOnError extends boolean = true>(options: Options<GetDocumentTypeByIdAllowedParentsData, ThrowOnError>): RequestResult<GetDocumentTypeByIdAllowedParentsResponses, GetDocumentTypeByIdAllowedParentsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentTypeByIdAllowedParentsResponses, GetDocumentTypeByIdAllowedParentsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/allowed-parents',
            ...options
        });
    }
    
    /**
     * Gets document blueprints for a document type.
     *
     * Gets a collection of document blueprints available for the specified document type.
     */
    public static getDocumentTypeByIdBlueprint<ThrowOnError extends boolean = true>(options: Options<GetDocumentTypeByIdBlueprintData, ThrowOnError>): RequestResult<GetDocumentTypeByIdBlueprintResponses, GetDocumentTypeByIdBlueprintErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentTypeByIdBlueprintResponses, GetDocumentTypeByIdBlueprintErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/blueprint',
            ...options
        });
    }
    
    /**
     * Gets composition references.
     *
     * Gets a collection of document types that reference the specified document type as a composition.
     */
    public static getDocumentTypeByIdCompositionReferences<ThrowOnError extends boolean = true>(options: Options<GetDocumentTypeByIdCompositionReferencesData, ThrowOnError>): RequestResult<GetDocumentTypeByIdCompositionReferencesResponses, GetDocumentTypeByIdCompositionReferencesErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentTypeByIdCompositionReferencesResponses, GetDocumentTypeByIdCompositionReferencesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/composition-references',
            ...options
        });
    }
    
    /**
     * Copies a document type.
     *
     * Creates a duplicate of an existing document type identified by the provided Id.
     */
    public static postDocumentTypeByIdCopy<ThrowOnError extends boolean = true>(options: Options<PostDocumentTypeByIdCopyData, ThrowOnError>): RequestResult<PostDocumentTypeByIdCopyResponses, PostDocumentTypeByIdCopyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentTypeByIdCopyResponses, PostDocumentTypeByIdCopyErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/copy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Exports a document type.
     *
     * Exports the document type identified by the provided Id to a downloadable format.
     */
    public static getDocumentTypeByIdExport<ThrowOnError extends boolean = true>(options: Options<GetDocumentTypeByIdExportData, ThrowOnError>): RequestResult<GetDocumentTypeByIdExportResponses, GetDocumentTypeByIdExportErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentTypeByIdExportResponses, GetDocumentTypeByIdExportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/export',
            ...options
        });
    }
    
    /**
     * Imports a document type.
     *
     * Imports a document type from the provided file upload.
     */
    public static putDocumentTypeByIdImport<ThrowOnError extends boolean = true>(options: Options<PutDocumentTypeByIdImportData, ThrowOnError>): RequestResult<PutDocumentTypeByIdImportResponses, PutDocumentTypeByIdImportErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentTypeByIdImportResponses, PutDocumentTypeByIdImportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves a document type.
     *
     * Moves a document type identified by the provided Id to a different location.
     */
    public static putDocumentTypeByIdMove<ThrowOnError extends boolean = true>(options: Options<PutDocumentTypeByIdMoveData, ThrowOnError>): RequestResult<PutDocumentTypeByIdMoveResponses, PutDocumentTypeByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentTypeByIdMoveResponses, PutDocumentTypeByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getDocumentTypeByIdSchema<ThrowOnError extends boolean = true>(options: Options<GetDocumentTypeByIdSchemaData, ThrowOnError>): RequestResult<GetDocumentTypeByIdSchemaResponses, GetDocumentTypeByIdSchemaErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentTypeByIdSchemaResponses, GetDocumentTypeByIdSchemaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/schema',
            ...options
        });
    }
    
    /**
     * Creates a template for a document type.
     *
     * Creates a new template associated with the document type identified by the provided Id.
     */
    public static postDocumentTypeByIdTemplate<ThrowOnError extends boolean = true>(options: Options<PostDocumentTypeByIdTemplateData, ThrowOnError>): RequestResult<PostDocumentTypeByIdTemplateResponses, PostDocumentTypeByIdTemplateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentTypeByIdTemplateResponses, PostDocumentTypeByIdTemplateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/{id}/template',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets document types allowed at root.
     *
     * Gets a collection of document types that are allowed to be created at the root level.
     */
    public static getDocumentTypeAllowedAtRoot<ThrowOnError extends boolean = true>(options?: Options<GetDocumentTypeAllowedAtRootData, ThrowOnError>): RequestResult<GetDocumentTypeAllowedAtRootResponses, GetDocumentTypeAllowedAtRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDocumentTypeAllowedAtRootResponses, GetDocumentTypeAllowedAtRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/allowed-at-root',
            ...options
        });
    }
    
    /**
     * Gets document types allowed in library.
     *
     * Gets a collection of document types that are allowed in the library.
     */
    public static getDocumentTypeAllowedInLibrary<ThrowOnError extends boolean = true>(options?: Options<GetDocumentTypeAllowedInLibraryData, ThrowOnError>): RequestResult<GetDocumentTypeAllowedInLibraryResponses, GetDocumentTypeAllowedInLibraryErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDocumentTypeAllowedInLibraryResponses, GetDocumentTypeAllowedInLibraryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/allowed-in-library',
            ...options
        });
    }
    
    /**
     * Gets available compositions.
     *
     * Gets a collection of document types that are available to use as compositions for the specified document type.
     */
    public static postDocumentTypeAvailableCompositions<ThrowOnError extends boolean = true>(options: Options<PostDocumentTypeAvailableCompositionsData, ThrowOnError>): RequestResult<PostDocumentTypeAvailableCompositionsResponses, PostDocumentTypeAvailableCompositionsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentTypeAvailableCompositionsResponses, PostDocumentTypeAvailableCompositionsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/available-compositions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets multiple document types.
     *
     * Gets multiple document types identified by the provided Ids.
     */
    public static getDocumentTypeBatch<ThrowOnError extends boolean = true>(options?: Options<GetDocumentTypeBatchData, ThrowOnError>): RequestResult<GetDocumentTypeBatchResponses, GetDocumentTypeBatchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDocumentTypeBatchResponses, GetDocumentTypeBatchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/batch',
            ...options
        });
    }
    
    /**
     * Gets the document type configuration.
     *
     * Gets the configuration settings for document types.
     */
    public static getDocumentTypeConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetDocumentTypeConfigurationData, ThrowOnError>): RequestResult<GetDocumentTypeConfigurationResponses, GetDocumentTypeConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDocumentTypeConfigurationResponses, GetDocumentTypeConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/configuration',
            ...options
        });
    }
    
    /**
     * Creates a document type folder.
     *
     * Creates a new document type folder with the provided name and parent location.
     */
    public static postDocumentTypeFolder<ThrowOnError extends boolean = true>(options: Options<PostDocumentTypeFolderData, ThrowOnError>): RequestResult<PostDocumentTypeFolderResponses, PostDocumentTypeFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentTypeFolderResponses, PostDocumentTypeFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a document type folder.
     *
     * Deletes a document type folder identified by the provided Id.
     */
    public static deleteDocumentTypeFolderById<ThrowOnError extends boolean = true>(options: Options<DeleteDocumentTypeFolderByIdData, ThrowOnError>): RequestResult<DeleteDocumentTypeFolderByIdResponses, DeleteDocumentTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDocumentTypeFolderByIdResponses, DeleteDocumentTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/folder/{id}',
            ...options
        });
    }
    
    /**
     * Gets a document type folder.
     *
     * Gets a document type folder identified by the provided Id.
     */
    public static getDocumentTypeFolderById<ThrowOnError extends boolean = true>(options: Options<GetDocumentTypeFolderByIdData, ThrowOnError>): RequestResult<GetDocumentTypeFolderByIdResponses, GetDocumentTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentTypeFolderByIdResponses, GetDocumentTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/folder/{id}',
            ...options
        });
    }
    
    /**
     * Updates a document type folder.
     *
     * Updates a document type folder identified by the provided Id with the details from the request model.
     */
    public static putDocumentTypeFolderById<ThrowOnError extends boolean = true>(options: Options<PutDocumentTypeFolderByIdData, ThrowOnError>): RequestResult<PutDocumentTypeFolderByIdResponses, PutDocumentTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentTypeFolderByIdResponses, PutDocumentTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/folder/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Imports a document type.
     *
     * Imports a document type from the provided file upload.
     */
    public static postDocumentTypeImport<ThrowOnError extends boolean = true>(options: Options<PostDocumentTypeImportData, ThrowOnError>): RequestResult<PostDocumentTypeImportResponses, PostDocumentTypeImportErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentTypeImportResponses, PostDocumentTypeImportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-type/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of document type items.
     *
     * Gets a collection of document type items identified by the provided Ids.
     */
    public static getItemDocumentType<ThrowOnError extends boolean = true>(options?: Options<GetItemDocumentTypeData, ThrowOnError>): RequestResult<GetItemDocumentTypeResponses, GetItemDocumentTypeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDocumentTypeResponses, GetItemDocumentTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/document-type',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of document type items.
     *
     * Gets the ancestor chains for document type items identified by the provided Ids.
     */
    public static getItemDocumentTypeAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemDocumentTypeAncestorsData, ThrowOnError>): RequestResult<GetItemDocumentTypeAncestorsResponses, GetItemDocumentTypeAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDocumentTypeAncestorsResponses, GetItemDocumentTypeAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/document-type/ancestors',
            ...options
        });
    }
    
    /**
     * Searches document type items.
     *
     * Searches document type items by the provided query with pagination support.
     */
    public static getItemDocumentTypeSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemDocumentTypeSearchData, ThrowOnError>): RequestResult<GetItemDocumentTypeSearchResponses, GetItemDocumentTypeSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemDocumentTypeSearchResponses, GetItemDocumentTypeSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/document-type/search',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor document type items.
     *
     * Gets a collection of document type items that are ancestors to the provided Id.
     */
    public static getTreeDocumentTypeAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentTypeAncestorsData, ThrowOnError>): RequestResult<GetTreeDocumentTypeAncestorsResponses, GetTreeDocumentTypeAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentTypeAncestorsResponses, GetTreeDocumentTypeAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-type/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of document type tree child items.
     *
     * Gets a paginated collection of document type tree items that are children of the provided parent Id.
     */
    public static getTreeDocumentTypeChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentTypeChildrenData, ThrowOnError>): RequestResult<GetTreeDocumentTypeChildrenResponses, GetTreeDocumentTypeChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentTypeChildrenResponses, GetTreeDocumentTypeChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-type/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of document type items from the root of the tree.
     *
     * Gets a paginated collection of document type items from the root of the tree with optional filtering.
     */
    public static getTreeDocumentTypeRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentTypeRootData, ThrowOnError>): RequestResult<GetTreeDocumentTypeRootResponses, GetTreeDocumentTypeRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentTypeRootResponses, GetTreeDocumentTypeRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-type/root',
            ...options
        });
    }
    
    public static getTreeDocumentTypeSearch<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentTypeSearchData, ThrowOnError>): RequestResult<GetTreeDocumentTypeSearchResponses, GetTreeDocumentTypeSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentTypeSearchResponses, GetTreeDocumentTypeSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-type/search',
            ...options
        });
    }
    
    /**
     * Gets a collection of document type tree sibling items.
     *
     * Gets a collection of document type tree items that are siblings of the provided Id.
     */
    public static getTreeDocumentTypeSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeDocumentTypeSiblingsData, ThrowOnError>): RequestResult<GetTreeDocumentTypeSiblingsResponses, GetTreeDocumentTypeSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeDocumentTypeSiblingsResponses, GetTreeDocumentTypeSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/document-type/siblings',
            ...options
        });
    }
}

export class DocumentVersionService {
    /**
     * Gets a paginated collection of versions for a specific document.
     *
     * Gets a paginated collection of versions for a specific document and optional culture. Each result describes the version and includes details of the document type, editor, version date, and published status.
     */
    public static getDocumentVersion<ThrowOnError extends boolean = true>(options: Options<GetDocumentVersionData, ThrowOnError>): RequestResult<GetDocumentVersionResponses, GetDocumentVersionErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentVersionResponses, GetDocumentVersionErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-version',
            ...options
        });
    }
    
    /**
     * Gets a specific document version.
     *
     * Gets a specific document version by its Id. If found, the result describes the version and includes details of the document type, editor, version date, and published status.
     */
    public static getDocumentVersionById<ThrowOnError extends boolean = true>(options: Options<GetDocumentVersionByIdData, ThrowOnError>): RequestResult<GetDocumentVersionByIdResponses, GetDocumentVersionByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetDocumentVersionByIdResponses, GetDocumentVersionByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-version/{id}',
            ...options
        });
    }
    
    /**
     * Sets the prevent clean up status for a document version.
     *
     * Sets the prevent clean up boolean status for a document version to the provided value. This controls whether the version will be a candidate for removal in content history clean up.
     */
    public static putDocumentVersionByIdPreventCleanup<ThrowOnError extends boolean = true>(options: Options<PutDocumentVersionByIdPreventCleanupData, ThrowOnError>): RequestResult<PutDocumentVersionByIdPreventCleanupResponses, PutDocumentVersionByIdPreventCleanupErrors, ThrowOnError> {
        return (options.client ?? client).put<PutDocumentVersionByIdPreventCleanupResponses, PutDocumentVersionByIdPreventCleanupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-version/{id}/prevent-cleanup',
            ...options
        });
    }
    
    /**
     * Rolls back a document to a specific version.
     *
     * Rolls back a document to the version indicated by the provided Id. This will archive the current version of the document and publish the provided one.
     */
    public static postDocumentVersionByIdRollback<ThrowOnError extends boolean = true>(options: Options<PostDocumentVersionByIdRollbackData, ThrowOnError>): RequestResult<PostDocumentVersionByIdRollbackResponses, PostDocumentVersionByIdRollbackErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDocumentVersionByIdRollbackResponses, PostDocumentVersionByIdRollbackErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/document-version/{id}/rollback',
            ...options
        });
    }
}

export class DynamicRootService {
    /**
     * Gets dynamic roots.
     *
     * Gets a collection of dynamic root items based on the provided query configuration.
     */
    public static postDynamicRootQuery<ThrowOnError extends boolean = true>(options: Options<PostDynamicRootQueryData, ThrowOnError>): RequestResult<PostDynamicRootQueryResponses, PostDynamicRootQueryErrors, ThrowOnError> {
        return (options.client ?? client).post<PostDynamicRootQueryResponses, PostDynamicRootQueryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dynamic-root/query',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets dynamic root query steps.
     *
     * Gets a collection of available query steps for configuring dynamic root queries.
     */
    public static getDynamicRootSteps<ThrowOnError extends boolean = true>(options?: Options<GetDynamicRootStepsData, ThrowOnError>): RequestResult<GetDynamicRootStepsResponses, GetDynamicRootStepsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetDynamicRootStepsResponses, GetDynamicRootStepsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/dynamic-root/steps',
            ...options
        });
    }
}

export class ElementService {
    /**
     * Creates a new element.
     *
     * Creates a new element with the configuration specified in the request model.
     */
    public static postElement<ThrowOnError extends boolean = true>(options: Options<PostElementData, ThrowOnError>): RequestResult<PostElementResponses, PostElementErrors, ThrowOnError> {
        return (options.client ?? client).post<PostElementResponses, PostElementErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes an element.
     *
     * Deletes an element identified by the provided Id.
     */
    public static deleteElementById<ThrowOnError extends boolean = true>(options: Options<DeleteElementByIdData, ThrowOnError>): RequestResult<DeleteElementByIdResponses, DeleteElementByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteElementByIdResponses, DeleteElementByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}',
            ...options
        });
    }
    
    /**
     * Gets an element.
     *
     * Gets an element identified by the provided Id.
     */
    public static getElementById<ThrowOnError extends boolean = true>(options: Options<GetElementByIdData, ThrowOnError>): RequestResult<GetElementByIdResponses, GetElementByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetElementByIdResponses, GetElementByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}',
            ...options
        });
    }
    
    /**
     * Updates an element.
     *
     * Updates an element identified by the provided Id with the details from the request model.
     */
    public static putElementById<ThrowOnError extends boolean = true>(options: Options<PutElementByIdData, ThrowOnError>): RequestResult<PutElementByIdResponses, PutElementByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementByIdResponses, PutElementByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets the audit log for an element.
     *
     * Gets a paginated collection of audit log entries for the element identified by the provided Id.
     */
    public static getElementByIdAuditLog<ThrowOnError extends boolean = true>(options: Options<GetElementByIdAuditLogData, ThrowOnError>): RequestResult<GetElementByIdAuditLogResponses, GetElementByIdAuditLogErrors, ThrowOnError> {
        return (options.client ?? client).get<GetElementByIdAuditLogResponses, GetElementByIdAuditLogErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/audit-log',
            ...options
        });
    }
    
    /**
     * Copies an element.
     *
     * Creates a duplicate of an existing element identified by the provided Id.
     */
    public static postElementByIdCopy<ThrowOnError extends boolean = true>(options: Options<PostElementByIdCopyData, ThrowOnError>): RequestResult<PostElementByIdCopyResponses, PostElementByIdCopyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostElementByIdCopyResponses, PostElementByIdCopyErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/copy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves an element.
     *
     * Moves an element identified by the provided Id to a different location.
     */
    public static putElementByIdMove<ThrowOnError extends boolean = true>(options: Options<PutElementByIdMoveData, ThrowOnError>): RequestResult<PutElementByIdMoveResponses, PutElementByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementByIdMoveResponses, PutElementByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves an element to the recycle bin.
     *
     * Moves an element identified by the provided Id to the recycle bin.
     */
    public static putElementByIdMoveToRecycleBin<ThrowOnError extends boolean = true>(options: Options<PutElementByIdMoveToRecycleBinData, ThrowOnError>): RequestResult<PutElementByIdMoveToRecycleBinResponses, PutElementByIdMoveToRecycleBinErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementByIdMoveToRecycleBinResponses, PutElementByIdMoveToRecycleBinErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/move-to-recycle-bin',
            ...options
        });
    }
    
    /**
     * Publishes an element.
     *
     * Publishes an element identified by the provided Id.
     */
    public static putElementByIdPublish<ThrowOnError extends boolean = true>(options: Options<PutElementByIdPublishData, ThrowOnError>): RequestResult<PutElementByIdPublishResponses, PutElementByIdPublishErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementByIdPublishResponses, PutElementByIdPublishErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a published element.
     *
     * Gets a published element identified by the provided Id.
     */
    public static getElementByIdPublished<ThrowOnError extends boolean = true>(options: Options<GetElementByIdPublishedData, ThrowOnError>): RequestResult<GetElementByIdPublishedResponses, GetElementByIdPublishedErrors, ThrowOnError> {
        return (options.client ?? client).get<GetElementByIdPublishedResponses, GetElementByIdPublishedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/published',
            ...options
        });
    }
    
    /**
     * Gets items referencing an element.
     *
     * Gets a paginated collection of items that reference the element identified by the provided Id.
     */
    public static getElementByIdReferencedBy<ThrowOnError extends boolean = true>(options: Options<GetElementByIdReferencedByData, ThrowOnError>): RequestResult<GetElementByIdReferencedByResponses, GetElementByIdReferencedByErrors, ThrowOnError> {
        return (options.client ?? client).get<GetElementByIdReferencedByResponses, GetElementByIdReferencedByErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/referenced-by',
            ...options
        });
    }
    
    /**
     * Unpublishes an element.
     *
     * Unpublishes an element identified by the provided Id.
     */
    public static putElementByIdUnpublish<ThrowOnError extends boolean = true>(options: Options<PutElementByIdUnpublishData, ThrowOnError>): RequestResult<PutElementByIdUnpublishResponses, PutElementByIdUnpublishErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementByIdUnpublishResponses, PutElementByIdUnpublishErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/unpublish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Updates and publishes an element.
     *
     * Updates and publishes an element identified by the provided Id with the details from the request model.
     */
    public static putElementByIdUpdateAndPublish<ThrowOnError extends boolean = true>(options: Options<PutElementByIdUpdateAndPublishData, ThrowOnError>): RequestResult<PutElementByIdUpdateAndPublishResponses, PutElementByIdUpdateAndPublishErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementByIdUpdateAndPublishResponses, PutElementByIdUpdateAndPublishErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/update-and-publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Validates updating an element.
     *
     * Validates the request model for updating an element without actually updating it.
     */
    public static putElementByIdValidate<ThrowOnError extends boolean = true>(options: Options<PutElementByIdValidateData, ThrowOnError>): RequestResult<PutElementByIdValidateResponses, PutElementByIdValidateErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementByIdValidateResponses, PutElementByIdValidateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/{id}/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of items that reference elements.
     *
     * Gets a paginated collection of items that reference the elements identified by the provided Ids.
     */
    public static getElementAreReferenced<ThrowOnError extends boolean = true>(options?: Options<GetElementAreReferencedData, ThrowOnError>): RequestResult<GetElementAreReferencedResponses, GetElementAreReferencedErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetElementAreReferencedResponses, GetElementAreReferencedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/are-referenced',
            ...options
        });
    }
    
    /**
     * Gets the element configuration.
     *
     * Gets the configuration settings for elements.
     */
    public static getElementConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetElementConfigurationData, ThrowOnError>): RequestResult<GetElementConfigurationResponses, GetElementConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetElementConfigurationResponses, GetElementConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/configuration',
            ...options
        });
    }
    
    /**
     * Creates and publishes a new element.
     *
     * Creates and publishes a new element with the configuration specified in the request model.
     */
    public static postElementCreateAndPublish<ThrowOnError extends boolean = true>(options: Options<PostElementCreateAndPublishData, ThrowOnError>): RequestResult<PostElementCreateAndPublishResponses, PostElementCreateAndPublishErrors, ThrowOnError> {
        return (options.client ?? client).post<PostElementCreateAndPublishResponses, PostElementCreateAndPublishErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/create-and-publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Creates an element folder.
     *
     * Creates a new element folder with the provided name and parent location.
     */
    public static postElementFolder<ThrowOnError extends boolean = true>(options: Options<PostElementFolderData, ThrowOnError>): RequestResult<PostElementFolderResponses, PostElementFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostElementFolderResponses, PostElementFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes an element folder.
     *
     * Deletes an element folder identified by the provided Id.
     */
    public static deleteElementFolderById<ThrowOnError extends boolean = true>(options: Options<DeleteElementFolderByIdData, ThrowOnError>): RequestResult<DeleteElementFolderByIdResponses, DeleteElementFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteElementFolderByIdResponses, DeleteElementFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/folder/{id}',
            ...options
        });
    }
    
    /**
     * Gets an element folder.
     *
     * Gets an element folder identified by the provided Id.
     */
    public static getElementFolderById<ThrowOnError extends boolean = true>(options: Options<GetElementFolderByIdData, ThrowOnError>): RequestResult<GetElementFolderByIdResponses, GetElementFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetElementFolderByIdResponses, GetElementFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/folder/{id}',
            ...options
        });
    }
    
    /**
     * Updates an element folder.
     *
     * Updates an element folder identified by the provided Id with the details provided in the request model.
     */
    public static putElementFolderById<ThrowOnError extends boolean = true>(options: Options<PutElementFolderByIdData, ThrowOnError>): RequestResult<PutElementFolderByIdResponses, PutElementFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementFolderByIdResponses, PutElementFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/folder/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves an element folder.
     *
     * Moves an element folder identified by the provided Id to a different location.
     */
    public static putElementFolderByIdMove<ThrowOnError extends boolean = true>(options: Options<PutElementFolderByIdMoveData, ThrowOnError>): RequestResult<PutElementFolderByIdMoveResponses, PutElementFolderByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementFolderByIdMoveResponses, PutElementFolderByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/folder/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves an element folder to the recycle bin.
     *
     * Moves an element folder identified by the provided Id to the recycle bin.
     */
    public static putElementFolderByIdMoveToRecycleBin<ThrowOnError extends boolean = true>(options: Options<PutElementFolderByIdMoveToRecycleBinData, ThrowOnError>): RequestResult<PutElementFolderByIdMoveToRecycleBinResponses, PutElementFolderByIdMoveToRecycleBinErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementFolderByIdMoveToRecycleBinResponses, PutElementFolderByIdMoveToRecycleBinErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/folder/{id}/move-to-recycle-bin',
            ...options
        });
    }
    
    /**
     * Gets element folder descendants that are referenced.
     *
     * Gets a paginated collection of descendant elements in a folder that are referenced by other content.
     */
    public static getElementFolderByIdReferencedDescendants<ThrowOnError extends boolean = true>(options: Options<GetElementFolderByIdReferencedDescendantsData, ThrowOnError>): RequestResult<GetElementFolderByIdReferencedDescendantsResponses, GetElementFolderByIdReferencedDescendantsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetElementFolderByIdReferencedDescendantsResponses, GetElementFolderByIdReferencedDescendantsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/folder/{id}/referenced-descendants',
            ...options
        });
    }
    
    /**
     * Validates creating an element.
     *
     * Validates the request model for creating a new element without actually creating it.
     */
    public static postElementValidate<ThrowOnError extends boolean = true>(options: Options<PostElementValidateData, ThrowOnError>): RequestResult<PostElementValidateResponses, PostElementValidateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostElementValidateResponses, PostElementValidateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of element items.
     *
     * Gets a collection of element items identified by the provided Ids.
     */
    public static getItemElement<ThrowOnError extends boolean = true>(options?: Options<GetItemElementData, ThrowOnError>): RequestResult<GetItemElementResponses, GetItemElementErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemElementResponses, GetItemElementErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/element',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of element items.
     *
     * Gets the ancestor chains for element items identified by the provided Ids.
     */
    public static getItemElementAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemElementAncestorsData, ThrowOnError>): RequestResult<GetItemElementAncestorsResponses, GetItemElementAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemElementAncestorsResponses, GetItemElementAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/element/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of element folder items.
     *
     * Gets a collection of element folder items identified by the provided Ids.
     */
    public static getItemElementFolder<ThrowOnError extends boolean = true>(options?: Options<GetItemElementFolderData, ThrowOnError>): RequestResult<GetItemElementFolderResponses, GetItemElementFolderErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemElementFolderResponses, GetItemElementFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/element/folder',
            ...options
        });
    }
    
    /**
     * Searches element items.
     *
     * Searches element items by the provided query with pagination support.
     */
    public static getItemElementSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemElementSearchData, ThrowOnError>): RequestResult<GetItemElementSearchResponses, GetItemElementSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemElementSearchResponses, GetItemElementSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/element/search',
            ...options
        });
    }
    
    /**
     * Empties the element recycle bin.
     *
     * Permanently deletes all elements in the recycle bin. This operation cannot be undone.
     */
    public static deleteRecycleBinElement<ThrowOnError extends boolean = true>(options?: Options<DeleteRecycleBinElementData, ThrowOnError>): RequestResult<DeleteRecycleBinElementResponses, DeleteRecycleBinElementErrors, ThrowOnError> {
        return (options?.client ?? client).delete<DeleteRecycleBinElementResponses, DeleteRecycleBinElementErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element',
            ...options
        });
    }
    
    /**
     * Deletes an element from the recycle bin.
     *
     * Permanently deletes an element identified by the provided Id from the recycle bin.
     */
    public static deleteRecycleBinElementById<ThrowOnError extends boolean = true>(options: Options<DeleteRecycleBinElementByIdData, ThrowOnError>): RequestResult<DeleteRecycleBinElementByIdResponses, DeleteRecycleBinElementByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteRecycleBinElementByIdResponses, DeleteRecycleBinElementByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/{id}',
            ...options
        });
    }
    
    /**
     * Gets the original parent of an element in the recycle bin.
     *
     * Gets the original parent location of an element before it was moved to the recycle bin.
     */
    public static getRecycleBinElementByIdOriginalParent<ThrowOnError extends boolean = true>(options: Options<GetRecycleBinElementByIdOriginalParentData, ThrowOnError>): RequestResult<GetRecycleBinElementByIdOriginalParentResponses, GetRecycleBinElementByIdOriginalParentErrors, ThrowOnError> {
        return (options.client ?? client).get<GetRecycleBinElementByIdOriginalParentResponses, GetRecycleBinElementByIdOriginalParentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/{id}/original-parent',
            ...options
        });
    }
    
    /**
     * Restores an element from the recycle bin.
     *
     * Restores an element from the recycle bin to its original location or a specified parent.
     */
    public static putRecycleBinElementByIdRestore<ThrowOnError extends boolean = true>(options: Options<PutRecycleBinElementByIdRestoreData, ThrowOnError>): RequestResult<PutRecycleBinElementByIdRestoreResponses, PutRecycleBinElementByIdRestoreErrors, ThrowOnError> {
        return (options.client ?? client).put<PutRecycleBinElementByIdRestoreResponses, PutRecycleBinElementByIdRestoreErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/{id}/restore',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of elements in the recycle bin.
     *
     * Gets a paginated collection of elements that are children of the provided parent in the recycle bin.
     */
    public static getRecycleBinElementChildren<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinElementChildrenData, ThrowOnError>): RequestResult<GetRecycleBinElementChildrenResponses, GetRecycleBinElementChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinElementChildrenResponses, GetRecycleBinElementChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/children',
            ...options
        });
    }
    
    /**
     * Deletes an element folder from the recycle bin.
     *
     * Permanently deletes an element folder identified by the provided Id from the recycle bin.
     */
    public static deleteRecycleBinElementFolderById<ThrowOnError extends boolean = true>(options: Options<DeleteRecycleBinElementFolderByIdData, ThrowOnError>): RequestResult<DeleteRecycleBinElementFolderByIdResponses, DeleteRecycleBinElementFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteRecycleBinElementFolderByIdResponses, DeleteRecycleBinElementFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/folder/{id}',
            ...options
        });
    }
    
    /**
     * Gets the original parent of an element folder in the recycle bin.
     *
     * Gets the original parent location of an element folder before it was moved to the recycle bin.
     */
    public static getRecycleBinElementFolderByIdOriginalParent<ThrowOnError extends boolean = true>(options: Options<GetRecycleBinElementFolderByIdOriginalParentData, ThrowOnError>): RequestResult<GetRecycleBinElementFolderByIdOriginalParentResponses, GetRecycleBinElementFolderByIdOriginalParentErrors, ThrowOnError> {
        return (options.client ?? client).get<GetRecycleBinElementFolderByIdOriginalParentResponses, GetRecycleBinElementFolderByIdOriginalParentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/folder/{id}/original-parent',
            ...options
        });
    }
    
    /**
     * Restores an element folder from the recycle bin.
     *
     * Restores an element folder from the recycle bin to its original location or a specified parent.
     */
    public static putRecycleBinElementFolderByIdRestore<ThrowOnError extends boolean = true>(options: Options<PutRecycleBinElementFolderByIdRestoreData, ThrowOnError>): RequestResult<PutRecycleBinElementFolderByIdRestoreResponses, PutRecycleBinElementFolderByIdRestoreErrors, ThrowOnError> {
        return (options.client ?? client).put<PutRecycleBinElementFolderByIdRestoreResponses, PutRecycleBinElementFolderByIdRestoreErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/folder/{id}/restore',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets items referencing an element in the recycle bin.
     *
     * Gets a paginated collection of items that reference the element in the recycle bin.
     */
    public static getRecycleBinElementReferencedBy<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinElementReferencedByData, ThrowOnError>): RequestResult<GetRecycleBinElementReferencedByResponses, GetRecycleBinElementReferencedByErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinElementReferencedByResponses, GetRecycleBinElementReferencedByErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/referenced-by',
            ...options
        });
    }
    
    /**
     * Gets elements at the root of the recycle bin.
     *
     * Gets a paginated collection of elements at the root level of the recycle bin.
     */
    public static getRecycleBinElementRoot<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinElementRootData, ThrowOnError>): RequestResult<GetRecycleBinElementRootResponses, GetRecycleBinElementRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinElementRootResponses, GetRecycleBinElementRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/root',
            ...options
        });
    }
    
    /**
     * Gets sibling elements in the recycle bin.
     *
     * Gets a collection of sibling elements in the recycle bin at the same level as the provided Id.
     */
    public static getRecycleBinElementSiblings<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinElementSiblingsData, ThrowOnError>): RequestResult<GetRecycleBinElementSiblingsResponses, GetRecycleBinElementSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinElementSiblingsResponses, GetRecycleBinElementSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/element/siblings',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor element items.
     *
     * Gets a collection of element items that are ancestors to the provided Id.
     */
    public static getTreeElementAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeElementAncestorsData, ThrowOnError>): RequestResult<GetTreeElementAncestorsResponses, GetTreeElementAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeElementAncestorsResponses, GetTreeElementAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/element/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of element tree child items.
     *
     * Gets a paginated collection of element tree items that are children of the provided parent Id.
     */
    public static getTreeElementChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeElementChildrenData, ThrowOnError>): RequestResult<GetTreeElementChildrenResponses, GetTreeElementChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeElementChildrenResponses, GetTreeElementChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/element/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of element items from the root of the tree.
     *
     * Gets a paginated collection of element items from the root of the tree with optional filtering.
     */
    public static getTreeElementRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeElementRootData, ThrowOnError>): RequestResult<GetTreeElementRootResponses, GetTreeElementRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeElementRootResponses, GetTreeElementRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/element/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of element tree sibling items.
     *
     * Gets a collection of element tree items that are siblings of the provided Id.
     */
    public static getTreeElementSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeElementSiblingsData, ThrowOnError>): RequestResult<GetTreeElementSiblingsResponses, GetTreeElementSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeElementSiblingsResponses, GetTreeElementSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/element/siblings',
            ...options
        });
    }
}

export class ElementVersionService {
    /**
     * Gets a paginated collection of versions for a specific element.
     *
     * Gets a paginated collection of versions for a specific element and optional culture. Each result describes the version and includes details of the element type, editor, version date, and published status.
     */
    public static getElementVersion<ThrowOnError extends boolean = true>(options: Options<GetElementVersionData, ThrowOnError>): RequestResult<GetElementVersionResponses, GetElementVersionErrors, ThrowOnError> {
        return (options.client ?? client).get<GetElementVersionResponses, GetElementVersionErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element-version',
            ...options
        });
    }
    
    /**
     * Gets a specific element version.
     *
     * Gets a specific element version by its Id. If found, the result describes the version and includes details of the element type, editor, version date, and published status.
     */
    public static getElementVersionById<ThrowOnError extends boolean = true>(options: Options<GetElementVersionByIdData, ThrowOnError>): RequestResult<GetElementVersionByIdResponses, GetElementVersionByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetElementVersionByIdResponses, GetElementVersionByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element-version/{id}',
            ...options
        });
    }
    
    /**
     * Sets the prevent clean up status for an element version.
     *
     * Sets the prevent clean up boolean status for an element version to the provided value. This controls whether the version will be a candidate for removal in content history clean up.
     */
    public static putElementVersionByIdPreventCleanup<ThrowOnError extends boolean = true>(options: Options<PutElementVersionByIdPreventCleanupData, ThrowOnError>): RequestResult<PutElementVersionByIdPreventCleanupResponses, PutElementVersionByIdPreventCleanupErrors, ThrowOnError> {
        return (options.client ?? client).put<PutElementVersionByIdPreventCleanupResponses, PutElementVersionByIdPreventCleanupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element-version/{id}/prevent-cleanup',
            ...options
        });
    }
    
    /**
     * Rolls back an element to a specific version.
     *
     * Rolls back an element to the version indicated by the provided Id. This will archive the current version of the element and publish the provided one.
     */
    public static postElementVersionByIdRollback<ThrowOnError extends boolean = true>(options: Options<PostElementVersionByIdRollbackData, ThrowOnError>): RequestResult<PostElementVersionByIdRollbackResponses, PostElementVersionByIdRollbackErrors, ThrowOnError> {
        return (options.client ?? client).post<PostElementVersionByIdRollbackResponses, PostElementVersionByIdRollbackErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/element-version/{id}/rollback',
            ...options
        });
    }
}

export class HealthCheckService {
    /**
     * Gets a collection of health check groups.
     *
     * Gets a collection of health check groups with their associated health checks.
     */
    public static getHealthCheckGroup<ThrowOnError extends boolean = true>(options?: Options<GetHealthCheckGroupData, ThrowOnError>): RequestResult<GetHealthCheckGroupResponses, GetHealthCheckGroupErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetHealthCheckGroupResponses, GetHealthCheckGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/health-check-group',
            ...options
        });
    }
    
    /**
     * Gets a health check group by name.
     *
     * Gets a health check group and all its associated health checks identified by the provided group name.
     */
    public static getHealthCheckGroupByName<ThrowOnError extends boolean = true>(options: Options<GetHealthCheckGroupByNameData, ThrowOnError>): RequestResult<GetHealthCheckGroupByNameResponses, GetHealthCheckGroupByNameErrors, ThrowOnError> {
        return (options.client ?? client).get<GetHealthCheckGroupByNameResponses, GetHealthCheckGroupByNameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/health-check-group/{name}',
            ...options
        });
    }
    
    /**
     * Executes all health checks in a group.
     *
     * Runs all health checks in the group identified by the provided name and returns the results.
     */
    public static postHealthCheckGroupByNameCheck<ThrowOnError extends boolean = true>(options: Options<PostHealthCheckGroupByNameCheckData, ThrowOnError>): RequestResult<PostHealthCheckGroupByNameCheckResponses, PostHealthCheckGroupByNameCheckErrors, ThrowOnError> {
        return (options.client ?? client).post<PostHealthCheckGroupByNameCheckResponses, PostHealthCheckGroupByNameCheckErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/health-check-group/{name}/check',
            ...options
        });
    }
    
    /**
     * Executes a health check action.
     *
     * Executes a specific action to fix or address a health check issue.
     */
    public static postHealthCheckExecuteAction<ThrowOnError extends boolean = true>(options: Options<PostHealthCheckExecuteActionData, ThrowOnError>): RequestResult<PostHealthCheckExecuteActionResponses, PostHealthCheckExecuteActionErrors, ThrowOnError> {
        return (options.client ?? client).post<PostHealthCheckExecuteActionResponses, PostHealthCheckExecuteActionErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/health-check/execute-action',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class HelpService {
    /**
     * Gets help information.
     *
     * Gets help information and documentation resources for the Umbraco back office.
     */
    public static getHelp<ThrowOnError extends boolean = true>(options?: Options<GetHelpData, ThrowOnError>): RequestResult<GetHelpResponses, GetHelpErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetHelpResponses, GetHelpErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/help',
            ...options
        });
    }
}

export class ImagingService {
    /**
     * Gets URLs for image resizing.
     *
     * Gets a collection of URLs for resizing images with the provided dimensions and options.
     */
    public static getImagingResizeUrls<ThrowOnError extends boolean = true>(options?: Options<GetImagingResizeUrlsData, ThrowOnError>): RequestResult<GetImagingResizeUrlsResponses, GetImagingResizeUrlsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetImagingResizeUrlsResponses, GetImagingResizeUrlsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/imaging/resize/urls',
            ...options
        });
    }
}

export class ImportService {
    /**
     * Analyzes an import file.
     *
     * Analyzes the uploaded import file and returns an analysis of the imported entities.
     */
    public static getImportAnalyze<ThrowOnError extends boolean = true>(options?: Options<GetImportAnalyzeData, ThrowOnError>): RequestResult<GetImportAnalyzeResponses, GetImportAnalyzeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetImportAnalyzeResponses, GetImportAnalyzeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/import/analyze',
            ...options
        });
    }
}

export class IndexerService {
    /**
     * Gets a collection of indexers.
     *
     * Gets a collection of configured search indexers in the Umbraco installation.
     */
    public static getIndexer<ThrowOnError extends boolean = true>(options?: Options<GetIndexerData, ThrowOnError>): RequestResult<GetIndexerResponses, GetIndexerErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetIndexerResponses, GetIndexerErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/indexer',
            ...options
        });
    }
    
    /**
     * Gets indexer details.
     *
     * Gets detailed information about the indexer identified by the provided name.
     */
    public static getIndexerByIndexName<ThrowOnError extends boolean = true>(options: Options<GetIndexerByIndexNameData, ThrowOnError>): RequestResult<GetIndexerByIndexNameResponses, GetIndexerByIndexNameErrors, ThrowOnError> {
        return (options.client ?? client).get<GetIndexerByIndexNameResponses, GetIndexerByIndexNameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/indexer/{indexName}',
            ...options
        });
    }
    
    /**
     * Rebuilds an indexer.
     *
     * Rebuilds the search index for the indexer identified by the provided name.
     */
    public static postIndexerByIndexNameRebuild<ThrowOnError extends boolean = true>(options: Options<PostIndexerByIndexNameRebuildData, ThrowOnError>): RequestResult<PostIndexerByIndexNameRebuildResponses, PostIndexerByIndexNameRebuildErrors, ThrowOnError> {
        return (options.client ?? client).post<PostIndexerByIndexNameRebuildResponses, PostIndexerByIndexNameRebuildErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/indexer/{indexName}/rebuild',
            ...options
        });
    }
}

export class InstallService {
    /**
     * Gets install settings.
     *
     * Gets the current installation settings and status.
     */
    public static getInstallSettings<ThrowOnError extends boolean = true>(options?: Options<GetInstallSettingsData, ThrowOnError>): RequestResult<GetInstallSettingsResponses, GetInstallSettingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetInstallSettingsResponses, GetInstallSettingsErrors, ThrowOnError>({ url: '/umbraco/management/api/v1/install/settings', ...options });
    }
    
    /**
     * Performs installation setup.
     *
     * Performs the initial setup and installation of Umbraco.
     */
    public static postInstallSetup<ThrowOnError extends boolean = true>(options: Options<PostInstallSetupData, ThrowOnError>): RequestResult<PostInstallSetupResponses, PostInstallSetupErrors, ThrowOnError> {
        return (options.client ?? client).post<PostInstallSetupResponses, PostInstallSetupErrors, ThrowOnError>({
            url: '/umbraco/management/api/v1/install/setup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Validates database connection.
     *
     * Validates the database connection settings provided during installation.
     */
    public static postInstallValidateDatabase<ThrowOnError extends boolean = true>(options: Options<PostInstallValidateDatabaseData, ThrowOnError>): RequestResult<PostInstallValidateDatabaseResponses, PostInstallValidateDatabaseErrors, ThrowOnError> {
        return (options.client ?? client).post<PostInstallValidateDatabaseResponses, PostInstallValidateDatabaseErrors, ThrowOnError>({
            url: '/umbraco/management/api/v1/install/validate-database',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class LanguageService {
    /**
     * Gets a collection of language items.
     *
     * Gets a collection of language items identified by the provided Ids.
     */
    public static getItemLanguage<ThrowOnError extends boolean = true>(options?: Options<GetItemLanguageData, ThrowOnError>): RequestResult<GetItemLanguageResponses, GetItemLanguageErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemLanguageResponses, GetItemLanguageErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/language',
            ...options
        });
    }
    
    /**
     * Gets the default language.
     *
     * Gets the default language configured for the Umbraco installation.
     */
    public static getItemLanguageDefault<ThrowOnError extends boolean = true>(options?: Options<GetItemLanguageDefaultData, ThrowOnError>): RequestResult<GetItemLanguageDefaultResponses, GetItemLanguageDefaultErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemLanguageDefaultResponses, GetItemLanguageDefaultErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/language/default',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of languages.
     *
     * Gets a paginated collection of all configured languages.
     */
    public static getLanguage<ThrowOnError extends boolean = true>(options?: Options<GetLanguageData, ThrowOnError>): RequestResult<GetLanguageResponses, GetLanguageErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetLanguageResponses, GetLanguageErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/language',
            ...options
        });
    }
    
    /**
     * Creates a new language.
     *
     * Creates a new language with the configuration specified in the request model.
     */
    public static postLanguage<ThrowOnError extends boolean = true>(options: Options<PostLanguageData, ThrowOnError>): RequestResult<PostLanguageResponses, PostLanguageErrors, ThrowOnError> {
        return (options.client ?? client).post<PostLanguageResponses, PostLanguageErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/language',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a language.
     *
     * Deletes a language identified by the provided Id.
     */
    public static deleteLanguageByIsoCode<ThrowOnError extends boolean = true>(options: Options<DeleteLanguageByIsoCodeData, ThrowOnError>): RequestResult<DeleteLanguageByIsoCodeResponses, DeleteLanguageByIsoCodeErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteLanguageByIsoCodeResponses, DeleteLanguageByIsoCodeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/language/{isoCode}',
            ...options
        });
    }
    
    /**
     * Gets a language by ISO code.
     *
     * Gets a language identified by the provided ISO code.
     */
    public static getLanguageByIsoCode<ThrowOnError extends boolean = true>(options: Options<GetLanguageByIsoCodeData, ThrowOnError>): RequestResult<GetLanguageByIsoCodeResponses, GetLanguageByIsoCodeErrors, ThrowOnError> {
        return (options.client ?? client).get<GetLanguageByIsoCodeResponses, GetLanguageByIsoCodeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/language/{isoCode}',
            ...options
        });
    }
    
    /**
     * Updates a language.
     *
     * Updates a language identified by the provided Id with the details from the request model.
     */
    public static putLanguageByIsoCode<ThrowOnError extends boolean = true>(options: Options<PutLanguageByIsoCodeData, ThrowOnError>): RequestResult<PutLanguageByIsoCodeResponses, PutLanguageByIsoCodeErrors, ThrowOnError> {
        return (options.client ?? client).put<PutLanguageByIsoCodeResponses, PutLanguageByIsoCodeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/language/{isoCode}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class LogViewerService {
    /**
     * Gets a collection of log sink levels.
     *
     * Gets a collection of configured log sinks with their minimum log levels.
     */
    public static getLogViewerLevel<ThrowOnError extends boolean = true>(options?: Options<GetLogViewerLevelData, ThrowOnError>): RequestResult<GetLogViewerLevelResponses, GetLogViewerLevelErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetLogViewerLevelResponses, GetLogViewerLevelErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/level',
            ...options
        });
    }
    
    /**
     * Gets log level counts.
     *
     * Gets the count of log entries for each log level within the specified date range.
     */
    public static getLogViewerLevelCount<ThrowOnError extends boolean = true>(options?: Options<GetLogViewerLevelCountData, ThrowOnError>): RequestResult<GetLogViewerLevelCountResponses, GetLogViewerLevelCountErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetLogViewerLevelCountResponses, GetLogViewerLevelCountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/level-count',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of log entries.
     *
     * Gets a paginated collection of log entries with optional filtering and date range.
     */
    public static getLogViewerLog<ThrowOnError extends boolean = true>(options?: Options<GetLogViewerLogData, ThrowOnError>): RequestResult<GetLogViewerLogResponses, GetLogViewerLogErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetLogViewerLogResponses, GetLogViewerLogErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/log',
            ...options
        });
    }
    
    /**
     * Gets a collection of log message templates.
     *
     * Gets a paginated collection of unique message templates found in the logs.
     */
    public static getLogViewerMessageTemplate<ThrowOnError extends boolean = true>(options?: Options<GetLogViewerMessageTemplateData, ThrowOnError>): RequestResult<GetLogViewerMessageTemplateResponses, GetLogViewerMessageTemplateErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetLogViewerMessageTemplateResponses, GetLogViewerMessageTemplateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/message-template',
            ...options
        });
    }
    
    /**
     * Gets a collection of saved log searches.
     *
     * Gets a collection of saved log searches defined in the Umbraco installation.
     */
    public static getLogViewerSavedSearch<ThrowOnError extends boolean = true>(options?: Options<GetLogViewerSavedSearchData, ThrowOnError>): RequestResult<GetLogViewerSavedSearchResponses, GetLogViewerSavedSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetLogViewerSavedSearchResponses, GetLogViewerSavedSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/saved-search',
            ...options
        });
    }
    
    /**
     * Creates a saved log search.
     *
     * Creates a new saved log search with the provided name and query configuration.
     */
    public static postLogViewerSavedSearch<ThrowOnError extends boolean = true>(options: Options<PostLogViewerSavedSearchData, ThrowOnError>): RequestResult<PostLogViewerSavedSearchResponses, PostLogViewerSavedSearchErrors, ThrowOnError> {
        return (options.client ?? client).post<PostLogViewerSavedSearchResponses, PostLogViewerSavedSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/saved-search',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a saved log search.
     *
     * Deletes a saved log search identified by the provided name.
     */
    public static deleteLogViewerSavedSearchByName<ThrowOnError extends boolean = true>(options: Options<DeleteLogViewerSavedSearchByNameData, ThrowOnError>): RequestResult<DeleteLogViewerSavedSearchByNameResponses, DeleteLogViewerSavedSearchByNameErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteLogViewerSavedSearchByNameResponses, DeleteLogViewerSavedSearchByNameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/saved-search/{name}',
            ...options
        });
    }
    
    /**
     * Gets a saved log search by name.
     *
     * Gets a saved log search identified by the provided name.
     */
    public static getLogViewerSavedSearchByName<ThrowOnError extends boolean = true>(options: Options<GetLogViewerSavedSearchByNameData, ThrowOnError>): RequestResult<GetLogViewerSavedSearchByNameResponses, GetLogViewerSavedSearchByNameErrors, ThrowOnError> {
        return (options.client ?? client).get<GetLogViewerSavedSearchByNameResponses, GetLogViewerSavedSearchByNameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/saved-search/{name}',
            ...options
        });
    }
    
    /**
     * Validates if logs can be viewed.
     *
     * Checks if the log files are within the size limit and can be viewed.
     */
    public static getLogViewerValidateLogsSize<ThrowOnError extends boolean = true>(options?: Options<GetLogViewerValidateLogsSizeData, ThrowOnError>): RequestResult<GetLogViewerValidateLogsSizeResponses, GetLogViewerValidateLogsSizeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetLogViewerValidateLogsSizeResponses, GetLogViewerValidateLogsSizeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/log-viewer/validate-logs-size',
            ...options
        });
    }
}

export class ManifestService {
    /**
     * Gets all manifests.
     *
     * Gets a collection of all package manifests including both public and private manifests.
     */
    public static getManifestManifest<ThrowOnError extends boolean = true>(options?: Options<GetManifestManifestData, ThrowOnError>): RequestResult<GetManifestManifestResponses, GetManifestManifestErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetManifestManifestResponses, GetManifestManifestErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/manifest/manifest',
            ...options
        });
    }
    
    /**
     * Gets private manifests.
     *
     * Gets a collection of private package manifests specific to the current user.
     */
    public static getManifestManifestPrivate<ThrowOnError extends boolean = true>(options?: Options<GetManifestManifestPrivateData, ThrowOnError>): RequestResult<GetManifestManifestPrivateResponses, GetManifestManifestPrivateErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetManifestManifestPrivateResponses, GetManifestManifestPrivateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/manifest/manifest/private',
            ...options
        });
    }
    
    /**
     * Gets public manifests.
     *
     * Gets a collection of public package manifests available to all users.
     */
    public static getManifestManifestPublic<ThrowOnError extends boolean = true>(options?: Options<GetManifestManifestPublicData, ThrowOnError>): RequestResult<GetManifestManifestPublicResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetManifestManifestPublicResponses, unknown, ThrowOnError>({ url: '/umbraco/management/api/v1/manifest/manifest/public', ...options });
    }
}

export class MediaService {
    /**
     * Gets a collection of media items.
     *
     * Gets a paginated collection of media items, optionally filtered and sorted.
     */
    public static getCollectionMedia<ThrowOnError extends boolean = true>(options?: Options<GetCollectionMediaData, ThrowOnError>): RequestResult<GetCollectionMediaResponses, GetCollectionMediaErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetCollectionMediaResponses, GetCollectionMediaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/collection/media',
            ...options
        });
    }
    
    /**
     * Gets a collection of media items.
     *
     * Gets a collection of media items identified by the provided Ids.
     */
    public static getItemMedia<ThrowOnError extends boolean = true>(options?: Options<GetItemMediaData, ThrowOnError>): RequestResult<GetItemMediaResponses, GetItemMediaErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMediaResponses, GetItemMediaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/media',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of media items.
     *
     * Gets the ancestor chains for media items identified by the provided Ids.
     */
    public static getItemMediaAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemMediaAncestorsData, ThrowOnError>): RequestResult<GetItemMediaAncestorsResponses, GetItemMediaAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMediaAncestorsResponses, GetItemMediaAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/media/ancestors',
            ...options
        });
    }
    
    /**
     * Searches media items.
     *
     * Searches media items by the provided query with pagination support.
     */
    public static getItemMediaSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemMediaSearchData, ThrowOnError>): RequestResult<GetItemMediaSearchResponses, GetItemMediaSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMediaSearchResponses, GetItemMediaSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/media/search',
            ...options
        });
    }
    
    /**
     * Creates a new media.
     *
     * Creates a new media with the configuration specified in the request model.
     */
    public static postMedia<ThrowOnError extends boolean = true>(options: Options<PostMediaData, ThrowOnError>): RequestResult<PostMediaResponses, PostMediaErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMediaResponses, PostMediaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a media item.
     *
     * Deletes a media item identified by the provided Id.
     */
    public static deleteMediaById<ThrowOnError extends boolean = true>(options: Options<DeleteMediaByIdData, ThrowOnError>): RequestResult<DeleteMediaByIdResponses, DeleteMediaByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMediaByIdResponses, DeleteMediaByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}',
            ...options
        });
    }
    
    /**
     * Gets a media item.
     *
     * Gets a media item identified by the provided Id.
     */
    public static getMediaById<ThrowOnError extends boolean = true>(options: Options<GetMediaByIdData, ThrowOnError>): RequestResult<GetMediaByIdResponses, GetMediaByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaByIdResponses, GetMediaByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}',
            ...options
        });
    }
    
    /**
     * Updates a media item.
     *
     * Updates a media item identified by the provided Id with the details from the request model.
     */
    public static putMediaById<ThrowOnError extends boolean = true>(options: Options<PutMediaByIdData, ThrowOnError>): RequestResult<PutMediaByIdResponses, PutMediaByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaByIdResponses, PutMediaByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets the audit log for a media item.
     *
     * Gets a paginated collection of audit log entries for the media identified by the provided Id.
     */
    public static getMediaByIdAuditLog<ThrowOnError extends boolean = true>(options: Options<GetMediaByIdAuditLogData, ThrowOnError>): RequestResult<GetMediaByIdAuditLogResponses, GetMediaByIdAuditLogErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaByIdAuditLogResponses, GetMediaByIdAuditLogErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}/audit-log',
            ...options
        });
    }
    
    /**
     * Moves a media item.
     *
     * Moves a media item identified by the provided Id to a different location.
     */
    public static putMediaByIdMove<ThrowOnError extends boolean = true>(options: Options<PutMediaByIdMoveData, ThrowOnError>): RequestResult<PutMediaByIdMoveResponses, PutMediaByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaByIdMoveResponses, PutMediaByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves a media item to the recycle bin.
     *
     * Moves a media item identified by the provided Id to the recycle bin.
     */
    public static putMediaByIdMoveToRecycleBin<ThrowOnError extends boolean = true>(options: Options<PutMediaByIdMoveToRecycleBinData, ThrowOnError>): RequestResult<PutMediaByIdMoveToRecycleBinResponses, PutMediaByIdMoveToRecycleBinErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaByIdMoveToRecycleBinResponses, PutMediaByIdMoveToRecycleBinErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}/move-to-recycle-bin',
            ...options
        });
    }
    
    /**
     * Gets a collection of items that reference a media item.
     *
     * Gets a paginated collection of items that reference the media item identified by the provided Id.
     */
    public static getMediaByIdReferencedBy<ThrowOnError extends boolean = true>(options: Options<GetMediaByIdReferencedByData, ThrowOnError>): RequestResult<GetMediaByIdReferencedByResponses, GetMediaByIdReferencedByErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaByIdReferencedByResponses, GetMediaByIdReferencedByErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}/referenced-by',
            ...options
        });
    }
    
    /**
     * Gets media descendants that are referenced.
     *
     * Gets a paginated collection of descendant media items that are referenced by other content.
     */
    public static getMediaByIdReferencedDescendants<ThrowOnError extends boolean = true>(options: Options<GetMediaByIdReferencedDescendantsData, ThrowOnError>): RequestResult<GetMediaByIdReferencedDescendantsResponses, GetMediaByIdReferencedDescendantsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaByIdReferencedDescendantsResponses, GetMediaByIdReferencedDescendantsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}/referenced-descendants',
            ...options
        });
    }
    
    /**
     * Sorts the children of a media item by a field.
     *
     * Sorts the children of the specified parent media item by a system field in the given direction.
     */
    public static putMediaByIdSortChildren<ThrowOnError extends boolean = true>(options: Options<PutMediaByIdSortChildrenData, ThrowOnError>): RequestResult<PutMediaByIdSortChildrenResponses, PutMediaByIdSortChildrenErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaByIdSortChildrenResponses, PutMediaByIdSortChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}/sort-children',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Validates updating a media item.
     *
     * Validates the request model for updating a media item without actually updating it.
     */
    public static putMediaByIdValidate<ThrowOnError extends boolean = true>(options: Options<PutMediaByIdValidateData, ThrowOnError>): RequestResult<PutMediaByIdValidateResponses, PutMediaByIdValidateErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaByIdValidateResponses, PutMediaByIdValidateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/{id}/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of referenced media items.
     *
     * Gets a paginated collection of media items that are referenced, identified by the provided Ids.
     */
    public static getMediaAreReferenced<ThrowOnError extends boolean = true>(options?: Options<GetMediaAreReferencedData, ThrowOnError>): RequestResult<GetMediaAreReferencedResponses, GetMediaAreReferencedErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMediaAreReferencedResponses, GetMediaAreReferencedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/are-referenced',
            ...options
        });
    }
    
    /**
     * Gets the media configuration.
     *
     * Gets the configuration settings for media.
     */
    public static getMediaConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetMediaConfigurationData, ThrowOnError>): RequestResult<GetMediaConfigurationResponses, GetMediaConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMediaConfigurationResponses, GetMediaConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/configuration',
            ...options
        });
    }
    
    /**
     * Sorts the root-level media items by a field.
     *
     * Sorts the root-level media items by a system field in the given direction.
     */
    public static putMediaRootSortChildren<ThrowOnError extends boolean = true>(options: Options<PutMediaRootSortChildrenData, ThrowOnError>): RequestResult<PutMediaRootSortChildrenResponses, PutMediaRootSortChildrenErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaRootSortChildrenResponses, PutMediaRootSortChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/root/sort-children',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sorts media items.
     *
     * Sorts media items in the specified parent container according to the provided sort order.
     */
    public static putMediaSort<ThrowOnError extends boolean = true>(options: Options<PutMediaSortData, ThrowOnError>): RequestResult<PutMediaSortResponses, PutMediaSortErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaSortResponses, PutMediaSortErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/sort',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets URLs for media items.
     *
     * Gets the URLs for the media items identified by the provided Ids.
     */
    public static getMediaUrls<ThrowOnError extends boolean = true>(options?: Options<GetMediaUrlsData, ThrowOnError>): RequestResult<GetMediaUrlsResponses, GetMediaUrlsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMediaUrlsResponses, GetMediaUrlsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/urls',
            ...options
        });
    }
    
    /**
     * Validates creating a media item.
     *
     * Validates the request model for creating a new media item without actually creating it.
     */
    public static postMediaValidate<ThrowOnError extends boolean = true>(options: Options<PostMediaValidateData, ThrowOnError>): RequestResult<PostMediaValidateResponses, PostMediaValidateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMediaValidateResponses, PostMediaValidateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Empties the media recycle bin.
     *
     * Permanently deletes all media items in the recycle bin. This operation cannot be undone.
     */
    public static deleteRecycleBinMedia<ThrowOnError extends boolean = true>(options?: Options<DeleteRecycleBinMediaData, ThrowOnError>): RequestResult<DeleteRecycleBinMediaResponses, DeleteRecycleBinMediaErrors, ThrowOnError> {
        return (options?.client ?? client).delete<DeleteRecycleBinMediaResponses, DeleteRecycleBinMediaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/media',
            ...options
        });
    }
    
    /**
     * Deletes a media item from the recycle bin.
     *
     * Permanently deletes a media item from the recycle bin identified by the provided Id.
     */
    public static deleteRecycleBinMediaById<ThrowOnError extends boolean = true>(options: Options<DeleteRecycleBinMediaByIdData, ThrowOnError>): RequestResult<DeleteRecycleBinMediaByIdResponses, DeleteRecycleBinMediaByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteRecycleBinMediaByIdResponses, DeleteRecycleBinMediaByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/media/{id}',
            ...options
        });
    }
    
    /**
     * Gets the original parent of a media item in the recycle bin.
     *
     * Gets the original parent location of a media item before it was moved to the recycle bin.
     */
    public static getRecycleBinMediaByIdOriginalParent<ThrowOnError extends boolean = true>(options: Options<GetRecycleBinMediaByIdOriginalParentData, ThrowOnError>): RequestResult<GetRecycleBinMediaByIdOriginalParentResponses, GetRecycleBinMediaByIdOriginalParentErrors, ThrowOnError> {
        return (options.client ?? client).get<GetRecycleBinMediaByIdOriginalParentResponses, GetRecycleBinMediaByIdOriginalParentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/media/{id}/original-parent',
            ...options
        });
    }
    
    /**
     * Restores a media item from the recycle bin.
     *
     * Restores a media item from the recycle bin to its original location or a specified parent.
     */
    public static putRecycleBinMediaByIdRestore<ThrowOnError extends boolean = true>(options: Options<PutRecycleBinMediaByIdRestoreData, ThrowOnError>): RequestResult<PutRecycleBinMediaByIdRestoreResponses, PutRecycleBinMediaByIdRestoreErrors, ThrowOnError> {
        return (options.client ?? client).put<PutRecycleBinMediaByIdRestoreResponses, PutRecycleBinMediaByIdRestoreErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/media/{id}/restore',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of media items in the recycle bin.
     *
     * Gets a paginated collection of media items that are children of the provided parent in the recycle bin.
     */
    public static getRecycleBinMediaChildren<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinMediaChildrenData, ThrowOnError>): RequestResult<GetRecycleBinMediaChildrenResponses, GetRecycleBinMediaChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinMediaChildrenResponses, GetRecycleBinMediaChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/media/children',
            ...options
        });
    }
    
    /**
     * Gets items referencing media in the recycle bin.
     *
     * Gets a paginated collection of items that reference the media in the recycle bin.
     */
    public static getRecycleBinMediaReferencedBy<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinMediaReferencedByData, ThrowOnError>): RequestResult<GetRecycleBinMediaReferencedByResponses, GetRecycleBinMediaReferencedByErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinMediaReferencedByResponses, GetRecycleBinMediaReferencedByErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/media/referenced-by',
            ...options
        });
    }
    
    /**
     * Gets media at the root of the recycle bin.
     *
     * Gets a paginated collection of media items at the root level of the recycle bin.
     */
    public static getRecycleBinMediaRoot<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinMediaRootData, ThrowOnError>): RequestResult<GetRecycleBinMediaRootResponses, GetRecycleBinMediaRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinMediaRootResponses, GetRecycleBinMediaRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/media/root',
            ...options
        });
    }
    
    /**
     * Gets sibling media in the recycle bin.
     *
     * Gets a collection of sibling media items in the recycle bin at the same level as the provided Id.
     */
    public static getRecycleBinMediaSiblings<ThrowOnError extends boolean = true>(options?: Options<GetRecycleBinMediaSiblingsData, ThrowOnError>): RequestResult<GetRecycleBinMediaSiblingsResponses, GetRecycleBinMediaSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRecycleBinMediaSiblingsResponses, GetRecycleBinMediaSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/recycle-bin/media/siblings',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor media items.
     *
     * Gets a collection of media items that are ancestors to the provided Id.
     */
    public static getTreeMediaAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeMediaAncestorsData, ThrowOnError>): RequestResult<GetTreeMediaAncestorsResponses, GetTreeMediaAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMediaAncestorsResponses, GetTreeMediaAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/media/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of media tree child items.
     *
     * Gets a paginated collection of media tree items that are children of the provided parent Id.
     */
    public static getTreeMediaChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeMediaChildrenData, ThrowOnError>): RequestResult<GetTreeMediaChildrenResponses, GetTreeMediaChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMediaChildrenResponses, GetTreeMediaChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/media/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of media items from the root of the tree.
     *
     * Gets a paginated collection of media items from the root of the tree with optional filtering.
     */
    public static getTreeMediaRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeMediaRootData, ThrowOnError>): RequestResult<GetTreeMediaRootResponses, GetTreeMediaRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMediaRootResponses, GetTreeMediaRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/media/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of media tree sibling items.
     *
     * Gets a collection of media tree items that are siblings of the provided Id.
     */
    public static getTreeMediaSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeMediaSiblingsData, ThrowOnError>): RequestResult<GetTreeMediaSiblingsResponses, GetTreeMediaSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMediaSiblingsResponses, GetTreeMediaSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/media/siblings',
            ...options
        });
    }
}

export class MediaTypeService {
    /**
     * Gets a collection of media type items.
     *
     * Gets a collection of media type items identified by the provided Ids.
     */
    public static getItemMediaType<ThrowOnError extends boolean = true>(options?: Options<GetItemMediaTypeData, ThrowOnError>): RequestResult<GetItemMediaTypeResponses, GetItemMediaTypeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMediaTypeResponses, GetItemMediaTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/media-type',
            ...options
        });
    }
    
    /**
     * Gets a collection of media type items.
     *
     * Gets a collection of allowed media type items for the specified file extension.
     */
    public static getItemMediaTypeAllowed<ThrowOnError extends boolean = true>(options?: Options<GetItemMediaTypeAllowedData, ThrowOnError>): RequestResult<GetItemMediaTypeAllowedResponses, GetItemMediaTypeAllowedErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMediaTypeAllowedResponses, GetItemMediaTypeAllowedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/media-type/allowed',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of media type items.
     *
     * Gets the ancestor chains for media type items identified by the provided Ids.
     */
    public static getItemMediaTypeAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemMediaTypeAncestorsData, ThrowOnError>): RequestResult<GetItemMediaTypeAncestorsResponses, GetItemMediaTypeAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMediaTypeAncestorsResponses, GetItemMediaTypeAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/media-type/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of media type folder items.
     *
     * Gets a paginated collection of media type folder items.
     */
    public static getItemMediaTypeFolders<ThrowOnError extends boolean = true>(options?: Options<GetItemMediaTypeFoldersData, ThrowOnError>): RequestResult<GetItemMediaTypeFoldersResponses, GetItemMediaTypeFoldersErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMediaTypeFoldersResponses, GetItemMediaTypeFoldersErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/media-type/folders',
            ...options
        });
    }
    
    /**
     * Searches media type items.
     *
     * Searches media type items by the provided query with pagination support.
     */
    public static getItemMediaTypeSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemMediaTypeSearchData, ThrowOnError>): RequestResult<GetItemMediaTypeSearchResponses, GetItemMediaTypeSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMediaTypeSearchResponses, GetItemMediaTypeSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/media-type/search',
            ...options
        });
    }
    
    /**
     * Creates a new media type.
     *
     * Creates a new media type with the configuration specified in the request model.
     */
    public static postMediaType<ThrowOnError extends boolean = true>(options: Options<PostMediaTypeData, ThrowOnError>): RequestResult<PostMediaTypeResponses, PostMediaTypeErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMediaTypeResponses, PostMediaTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a media type.
     *
     * Deletes a media type identified by the provided Id.
     */
    public static deleteMediaTypeById<ThrowOnError extends boolean = true>(options: Options<DeleteMediaTypeByIdData, ThrowOnError>): RequestResult<DeleteMediaTypeByIdResponses, DeleteMediaTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMediaTypeByIdResponses, DeleteMediaTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}',
            ...options
        });
    }
    
    /**
     * Gets a media type.
     *
     * Gets a media type identified by the provided Id.
     */
    public static getMediaTypeById<ThrowOnError extends boolean = true>(options: Options<GetMediaTypeByIdData, ThrowOnError>): RequestResult<GetMediaTypeByIdResponses, GetMediaTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaTypeByIdResponses, GetMediaTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}',
            ...options
        });
    }
    
    /**
     * Updates a media type.
     *
     * Updates a media type identified by the provided Id with the details from the request model.
     */
    public static putMediaTypeById<ThrowOnError extends boolean = true>(options: Options<PutMediaTypeByIdData, ThrowOnError>): RequestResult<PutMediaTypeByIdResponses, PutMediaTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaTypeByIdResponses, PutMediaTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets allowed child media types.
     *
     * Gets a collection of media types that are allowed as children of the specified parent media type.
     */
    public static getMediaTypeByIdAllowedChildren<ThrowOnError extends boolean = true>(options: Options<GetMediaTypeByIdAllowedChildrenData, ThrowOnError>): RequestResult<GetMediaTypeByIdAllowedChildrenResponses, GetMediaTypeByIdAllowedChildrenErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaTypeByIdAllowedChildrenResponses, GetMediaTypeByIdAllowedChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}/allowed-children',
            ...options
        });
    }
    
    /**
     * Gets allowed parent media types.
     *
     * Gets a collection of media types that are allowed as parents of the specified media type.
     */
    public static getMediaTypeByIdAllowedParents<ThrowOnError extends boolean = true>(options: Options<GetMediaTypeByIdAllowedParentsData, ThrowOnError>): RequestResult<GetMediaTypeByIdAllowedParentsResponses, GetMediaTypeByIdAllowedParentsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaTypeByIdAllowedParentsResponses, GetMediaTypeByIdAllowedParentsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}/allowed-parents',
            ...options
        });
    }
    
    /**
     * Gets composition references.
     *
     * Gets a collection of media types that reference the specified media type as a composition.
     */
    public static getMediaTypeByIdCompositionReferences<ThrowOnError extends boolean = true>(options: Options<GetMediaTypeByIdCompositionReferencesData, ThrowOnError>): RequestResult<GetMediaTypeByIdCompositionReferencesResponses, GetMediaTypeByIdCompositionReferencesErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaTypeByIdCompositionReferencesResponses, GetMediaTypeByIdCompositionReferencesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}/composition-references',
            ...options
        });
    }
    
    /**
     * Copies a media type.
     *
     * Creates a duplicate of an existing media type identified by the provided Id.
     */
    public static postMediaTypeByIdCopy<ThrowOnError extends boolean = true>(options: Options<PostMediaTypeByIdCopyData, ThrowOnError>): RequestResult<PostMediaTypeByIdCopyResponses, PostMediaTypeByIdCopyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMediaTypeByIdCopyResponses, PostMediaTypeByIdCopyErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}/copy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Exports a media type.
     *
     * Exports the media type identified by the provided Id to a downloadable format.
     */
    public static getMediaTypeByIdExport<ThrowOnError extends boolean = true>(options: Options<GetMediaTypeByIdExportData, ThrowOnError>): RequestResult<GetMediaTypeByIdExportResponses, GetMediaTypeByIdExportErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaTypeByIdExportResponses, GetMediaTypeByIdExportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}/export',
            ...options
        });
    }
    
    /**
     * Imports a media type.
     *
     * Imports a media type from the provided file upload.
     */
    public static putMediaTypeByIdImport<ThrowOnError extends boolean = true>(options: Options<PutMediaTypeByIdImportData, ThrowOnError>): RequestResult<PutMediaTypeByIdImportResponses, PutMediaTypeByIdImportErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaTypeByIdImportResponses, PutMediaTypeByIdImportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves a media type.
     *
     * Moves a media type identified by the provided Id to a different location.
     */
    public static putMediaTypeByIdMove<ThrowOnError extends boolean = true>(options: Options<PutMediaTypeByIdMoveData, ThrowOnError>): RequestResult<PutMediaTypeByIdMoveResponses, PutMediaTypeByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaTypeByIdMoveResponses, PutMediaTypeByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getMediaTypeByIdSchema<ThrowOnError extends boolean = true>(options: Options<GetMediaTypeByIdSchemaData, ThrowOnError>): RequestResult<GetMediaTypeByIdSchemaResponses, GetMediaTypeByIdSchemaErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaTypeByIdSchemaResponses, GetMediaTypeByIdSchemaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/{id}/schema',
            ...options
        });
    }
    
    /**
     * Gets media types allowed at root.
     *
     * Gets a collection of media types that are allowed to be created at the root level.
     */
    public static getMediaTypeAllowedAtRoot<ThrowOnError extends boolean = true>(options?: Options<GetMediaTypeAllowedAtRootData, ThrowOnError>): RequestResult<GetMediaTypeAllowedAtRootResponses, GetMediaTypeAllowedAtRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMediaTypeAllowedAtRootResponses, GetMediaTypeAllowedAtRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/allowed-at-root',
            ...options
        });
    }
    
    /**
     * Gets available compositions.
     *
     * Gets a collection of media types that are available to use as compositions for the specified media type.
     */
    public static postMediaTypeAvailableCompositions<ThrowOnError extends boolean = true>(options: Options<PostMediaTypeAvailableCompositionsData, ThrowOnError>): RequestResult<PostMediaTypeAvailableCompositionsResponses, PostMediaTypeAvailableCompositionsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMediaTypeAvailableCompositionsResponses, PostMediaTypeAvailableCompositionsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/available-compositions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets multiple media types.
     *
     * Gets multiple media types identified by the provided Ids.
     */
    public static getMediaTypeBatch<ThrowOnError extends boolean = true>(options?: Options<GetMediaTypeBatchData, ThrowOnError>): RequestResult<GetMediaTypeBatchResponses, GetMediaTypeBatchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMediaTypeBatchResponses, GetMediaTypeBatchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/batch',
            ...options
        });
    }
    
    /**
     * Gets the media type configuration.
     *
     * Gets the configuration settings for media types.
     */
    public static getMediaTypeConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetMediaTypeConfigurationData, ThrowOnError>): RequestResult<GetMediaTypeConfigurationResponses, GetMediaTypeConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMediaTypeConfigurationResponses, GetMediaTypeConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/configuration',
            ...options
        });
    }
    
    /**
     * Creates a media type folder.
     *
     * Creates a new media type folder with the provided name and parent location.
     */
    public static postMediaTypeFolder<ThrowOnError extends boolean = true>(options: Options<PostMediaTypeFolderData, ThrowOnError>): RequestResult<PostMediaTypeFolderResponses, PostMediaTypeFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMediaTypeFolderResponses, PostMediaTypeFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a media type folder.
     *
     * Deletes a media type folder identified by the provided Id.
     */
    public static deleteMediaTypeFolderById<ThrowOnError extends boolean = true>(options: Options<DeleteMediaTypeFolderByIdData, ThrowOnError>): RequestResult<DeleteMediaTypeFolderByIdResponses, DeleteMediaTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMediaTypeFolderByIdResponses, DeleteMediaTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/folder/{id}',
            ...options
        });
    }
    
    /**
     * Gets a media type folder.
     *
     * Gets a media type folder identified by the provided Id.
     */
    public static getMediaTypeFolderById<ThrowOnError extends boolean = true>(options: Options<GetMediaTypeFolderByIdData, ThrowOnError>): RequestResult<GetMediaTypeFolderByIdResponses, GetMediaTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMediaTypeFolderByIdResponses, GetMediaTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/folder/{id}',
            ...options
        });
    }
    
    /**
     * Updates a media type folder.
     *
     * Updates a media type folder identified by the provided Id with the details from the request model.
     */
    public static putMediaTypeFolderById<ThrowOnError extends boolean = true>(options: Options<PutMediaTypeFolderByIdData, ThrowOnError>): RequestResult<PutMediaTypeFolderByIdResponses, PutMediaTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMediaTypeFolderByIdResponses, PutMediaTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/folder/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Imports a media type.
     *
     * Imports a media type from the provided file upload.
     */
    public static postMediaTypeImport<ThrowOnError extends boolean = true>(options: Options<PostMediaTypeImportData, ThrowOnError>): RequestResult<PostMediaTypeImportResponses, PostMediaTypeImportErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMediaTypeImportResponses, PostMediaTypeImportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/media-type/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of ancestor media type items.
     *
     * Gets a collection of media type items that are ancestors to the provided Id.
     */
    public static getTreeMediaTypeAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeMediaTypeAncestorsData, ThrowOnError>): RequestResult<GetTreeMediaTypeAncestorsResponses, GetTreeMediaTypeAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMediaTypeAncestorsResponses, GetTreeMediaTypeAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/media-type/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of media type tree child items.
     *
     * Gets a paginated collection of media type tree items that are children of the provided parent Id.
     */
    public static getTreeMediaTypeChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeMediaTypeChildrenData, ThrowOnError>): RequestResult<GetTreeMediaTypeChildrenResponses, GetTreeMediaTypeChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMediaTypeChildrenResponses, GetTreeMediaTypeChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/media-type/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of media type items from the root of the tree.
     *
     * Gets a paginated collection of media type items from the root of the tree with optional filtering.
     */
    public static getTreeMediaTypeRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeMediaTypeRootData, ThrowOnError>): RequestResult<GetTreeMediaTypeRootResponses, GetTreeMediaTypeRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMediaTypeRootResponses, GetTreeMediaTypeRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/media-type/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of media type tree sibling items.
     *
     * Gets a collection of media type tree items that are siblings of the provided Id.
     */
    public static getTreeMediaTypeSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeMediaTypeSiblingsData, ThrowOnError>): RequestResult<GetTreeMediaTypeSiblingsResponses, GetTreeMediaTypeSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMediaTypeSiblingsResponses, GetTreeMediaTypeSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/media-type/siblings',
            ...options
        });
    }
}

export class MemberService {
    /**
     * Gets a filtered collection of members.
     *
     * Filters members based on the provided criteria with support for pagination.
     */
    public static getFilterMember<ThrowOnError extends boolean = true>(options?: Options<GetFilterMemberData, ThrowOnError>): RequestResult<GetFilterMemberResponses, GetFilterMemberErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetFilterMemberResponses, GetFilterMemberErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/filter/member',
            ...options
        });
    }
    
    /**
     * Gets a collection of member items.
     *
     * Gets a collection of member items identified by the provided Ids.
     */
    public static getItemMember<ThrowOnError extends boolean = true>(options?: Options<GetItemMemberData, ThrowOnError>): RequestResult<GetItemMemberResponses, GetItemMemberErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMemberResponses, GetItemMemberErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/member',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of member items.
     *
     * Gets the ancestor chains for member items identified by the provided Ids.
     */
    public static getItemMemberAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemMemberAncestorsData, ThrowOnError>): RequestResult<GetItemMemberAncestorsResponses, GetItemMemberAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMemberAncestorsResponses, GetItemMemberAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/member/ancestors',
            ...options
        });
    }
    
    /**
     * Searches member items.
     *
     * Searches member items by the provided query with pagination support.
     */
    public static getItemMemberSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemMemberSearchData, ThrowOnError>): RequestResult<GetItemMemberSearchResponses, GetItemMemberSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMemberSearchResponses, GetItemMemberSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/member/search',
            ...options
        });
    }
    
    /**
     * Creates a new member.
     *
     * Creates a new member with the configuration specified in the request model.
     */
    public static postMember<ThrowOnError extends boolean = true>(options: Options<PostMemberData, ThrowOnError>): RequestResult<PostMemberResponses, PostMemberErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMemberResponses, PostMemberErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a member.
     *
     * Deletes a member identified by the provided Id.
     */
    public static deleteMemberById<ThrowOnError extends boolean = true>(options: Options<DeleteMemberByIdData, ThrowOnError>): RequestResult<DeleteMemberByIdResponses, DeleteMemberByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMemberByIdResponses, DeleteMemberByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member/{id}',
            ...options
        });
    }
    
    /**
     * Gets a member.
     *
     * Gets a member identified by the provided Id.
     */
    public static getMemberById<ThrowOnError extends boolean = true>(options: Options<GetMemberByIdData, ThrowOnError>): RequestResult<GetMemberByIdResponses, GetMemberByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberByIdResponses, GetMemberByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member/{id}',
            ...options
        });
    }
    
    /**
     * Updates a member.
     *
     * Updates a member identified by the provided Id with the details from the request model.
     */
    public static putMemberById<ThrowOnError extends boolean = true>(options: Options<PutMemberByIdData, ThrowOnError>): RequestResult<PutMemberByIdResponses, PutMemberByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMemberByIdResponses, PutMemberByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of items that reference members.
     *
     * Gets a paginated collection of items that reference the members identified by the provided Ids.
     */
    public static getMemberByIdReferencedBy<ThrowOnError extends boolean = true>(options: Options<GetMemberByIdReferencedByData, ThrowOnError>): RequestResult<GetMemberByIdReferencedByResponses, GetMemberByIdReferencedByErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberByIdReferencedByResponses, GetMemberByIdReferencedByErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member/{id}/referenced-by',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of referenced descendant members.
     *
     * Gets a paginated collection of descendant members that are referenced in relations for the member identified by the provided Id.
     */
    public static getMemberByIdReferencedDescendants<ThrowOnError extends boolean = true>(options: Options<GetMemberByIdReferencedDescendantsData, ThrowOnError>): RequestResult<GetMemberByIdReferencedDescendantsResponses, GetMemberByIdReferencedDescendantsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberByIdReferencedDescendantsResponses, GetMemberByIdReferencedDescendantsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member/{id}/referenced-descendants',
            ...options
        });
    }
    
    /**
     * Validates updating a member.
     *
     * Validates the request model for updating a member without actually updating it.
     */
    public static putMemberByIdValidate<ThrowOnError extends boolean = true>(options: Options<PutMemberByIdValidateData, ThrowOnError>): RequestResult<PutMemberByIdValidateResponses, PutMemberByIdValidateErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMemberByIdValidateResponses, PutMemberByIdValidateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member/{id}/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of items that reference members.
     *
     * Gets a paginated collection of items that reference the members identified by the provided Ids.
     */
    public static getMemberAreReferenced<ThrowOnError extends boolean = true>(options?: Options<GetMemberAreReferencedData, ThrowOnError>): RequestResult<GetMemberAreReferencedResponses, GetMemberAreReferencedErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMemberAreReferencedResponses, GetMemberAreReferencedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member/are-referenced',
            ...options
        });
    }
    
    /**
     * Validates creating a member.
     *
     * Validates the request model for creating a new member without actually creating it.
     */
    public static postMemberValidate<ThrowOnError extends boolean = true>(options: Options<PostMemberValidateData, ThrowOnError>): RequestResult<PostMemberValidateResponses, PostMemberValidateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMemberValidateResponses, PostMemberValidateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class MemberGroupService {
    /**
     * Gets a collection of member group items.
     *
     * Gets a collection of member group items identified by the provided Ids.
     */
    public static getItemMemberGroup<ThrowOnError extends boolean = true>(options?: Options<GetItemMemberGroupData, ThrowOnError>): RequestResult<GetItemMemberGroupResponses, GetItemMemberGroupErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMemberGroupResponses, GetItemMemberGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/member-group',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of member groups.
     *
     * Gets a paginated collection of all member groups.
     */
    public static getMemberGroup<ThrowOnError extends boolean = true>(options?: Options<GetMemberGroupData, ThrowOnError>): RequestResult<GetMemberGroupResponses, GetMemberGroupErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMemberGroupResponses, GetMemberGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-group',
            ...options
        });
    }
    
    /**
     * Creates a new member group.
     *
     * Creates a new member group with the configuration specified in the request model.
     */
    public static postMemberGroup<ThrowOnError extends boolean = true>(options: Options<PostMemberGroupData, ThrowOnError>): RequestResult<PostMemberGroupResponses, PostMemberGroupErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMemberGroupResponses, PostMemberGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-group',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a member group.
     *
     * Deletes a member group identified by the provided Id.
     */
    public static deleteMemberGroupById<ThrowOnError extends boolean = true>(options: Options<DeleteMemberGroupByIdData, ThrowOnError>): RequestResult<DeleteMemberGroupByIdResponses, DeleteMemberGroupByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMemberGroupByIdResponses, DeleteMemberGroupByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-group/{id}',
            ...options
        });
    }
    
    /**
     * Gets a member group.
     *
     * Gets a member group identified by the provided Id.
     */
    public static getMemberGroupById<ThrowOnError extends boolean = true>(options: Options<GetMemberGroupByIdData, ThrowOnError>): RequestResult<GetMemberGroupByIdResponses, GetMemberGroupByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberGroupByIdResponses, GetMemberGroupByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-group/{id}',
            ...options
        });
    }
    
    /**
     * Updates a member group.
     *
     * Updates a member group identified by the provided Id with the details from the request model.
     */
    public static putMemberGroupById<ThrowOnError extends boolean = true>(options: Options<PutMemberGroupByIdData, ThrowOnError>): RequestResult<PutMemberGroupByIdResponses, PutMemberGroupByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMemberGroupByIdResponses, PutMemberGroupByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-group/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of member group items from the root of the tree.
     *
     * Gets a paginated collection of member group items from the root of the tree with optional filtering.
     */
    public static getTreeMemberGroupRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeMemberGroupRootData, ThrowOnError>): RequestResult<GetTreeMemberGroupRootResponses, GetTreeMemberGroupRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMemberGroupRootResponses, GetTreeMemberGroupRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/member-group/root',
            ...options
        });
    }
}

export class MemberTypeService {
    /**
     * Gets a collection of member type items.
     *
     * Gets a collection of member type items identified by the provided Ids.
     */
    public static getItemMemberType<ThrowOnError extends boolean = true>(options?: Options<GetItemMemberTypeData, ThrowOnError>): RequestResult<GetItemMemberTypeResponses, GetItemMemberTypeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMemberTypeResponses, GetItemMemberTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/member-type',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of member type items.
     *
     * Gets the ancestor chains for member type items identified by the provided Ids.
     */
    public static getItemMemberTypeAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemMemberTypeAncestorsData, ThrowOnError>): RequestResult<GetItemMemberTypeAncestorsResponses, GetItemMemberTypeAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMemberTypeAncestorsResponses, GetItemMemberTypeAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/member-type/ancestors',
            ...options
        });
    }
    
    /**
     * Searches member type items.
     *
     * Searches member type items by the provided query with pagination support.
     */
    public static getItemMemberTypeSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemMemberTypeSearchData, ThrowOnError>): RequestResult<GetItemMemberTypeSearchResponses, GetItemMemberTypeSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemMemberTypeSearchResponses, GetItemMemberTypeSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/member-type/search',
            ...options
        });
    }
    
    /**
     * Creates a new member type.
     *
     * Creates a new member type with the configuration specified in the request model.
     */
    public static postMemberType<ThrowOnError extends boolean = true>(options: Options<PostMemberTypeData, ThrowOnError>): RequestResult<PostMemberTypeResponses, PostMemberTypeErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMemberTypeResponses, PostMemberTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a member type.
     *
     * Deletes a member type identified by the provided Id.
     */
    public static deleteMemberTypeById<ThrowOnError extends boolean = true>(options: Options<DeleteMemberTypeByIdData, ThrowOnError>): RequestResult<DeleteMemberTypeByIdResponses, DeleteMemberTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMemberTypeByIdResponses, DeleteMemberTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}',
            ...options
        });
    }
    
    /**
     * Gets a member type.
     *
     * Gets a member type identified by the provided Id.
     */
    public static getMemberTypeById<ThrowOnError extends boolean = true>(options: Options<GetMemberTypeByIdData, ThrowOnError>): RequestResult<GetMemberTypeByIdResponses, GetMemberTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberTypeByIdResponses, GetMemberTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}',
            ...options
        });
    }
    
    /**
     * Updates a member type.
     *
     * Updates a member type identified by the provided Id with the details from the request model.
     */
    public static putMemberTypeById<ThrowOnError extends boolean = true>(options: Options<PutMemberTypeByIdData, ThrowOnError>): RequestResult<PutMemberTypeByIdResponses, PutMemberTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMemberTypeByIdResponses, PutMemberTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets composition references.
     *
     * Gets a collection of member types that reference the specified member type as a composition.
     */
    public static getMemberTypeByIdCompositionReferences<ThrowOnError extends boolean = true>(options: Options<GetMemberTypeByIdCompositionReferencesData, ThrowOnError>): RequestResult<GetMemberTypeByIdCompositionReferencesResponses, GetMemberTypeByIdCompositionReferencesErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberTypeByIdCompositionReferencesResponses, GetMemberTypeByIdCompositionReferencesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}/composition-references',
            ...options
        });
    }
    
    /**
     * Copies a member type.
     *
     * Creates a duplicate of an existing member type identified by the provided Id.
     */
    public static postMemberTypeByIdCopy<ThrowOnError extends boolean = true>(options: Options<PostMemberTypeByIdCopyData, ThrowOnError>): RequestResult<PostMemberTypeByIdCopyResponses, PostMemberTypeByIdCopyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMemberTypeByIdCopyResponses, PostMemberTypeByIdCopyErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}/copy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Exports a member type.
     *
     * Exports the member type identified by the provided Id to a downloadable format.
     */
    public static getMemberTypeByIdExport<ThrowOnError extends boolean = true>(options: Options<GetMemberTypeByIdExportData, ThrowOnError>): RequestResult<GetMemberTypeByIdExportResponses, GetMemberTypeByIdExportErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberTypeByIdExportResponses, GetMemberTypeByIdExportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}/export',
            ...options
        });
    }
    
    /**
     * Imports a member type.
     *
     * Imports a member type from the provided file upload.
     */
    public static putMemberTypeByIdImport<ThrowOnError extends boolean = true>(options: Options<PutMemberTypeByIdImportData, ThrowOnError>): RequestResult<PutMemberTypeByIdImportResponses, PutMemberTypeByIdImportErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMemberTypeByIdImportResponses, PutMemberTypeByIdImportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Moves a member type.
     *
     * Moves a member type identified by the provided Id to a different location.
     */
    public static putMemberTypeByIdMove<ThrowOnError extends boolean = true>(options: Options<PutMemberTypeByIdMoveData, ThrowOnError>): RequestResult<PutMemberTypeByIdMoveResponses, PutMemberTypeByIdMoveErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMemberTypeByIdMoveResponses, PutMemberTypeByIdMoveErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}/move',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getMemberTypeByIdSchema<ThrowOnError extends boolean = true>(options: Options<GetMemberTypeByIdSchemaData, ThrowOnError>): RequestResult<GetMemberTypeByIdSchemaResponses, GetMemberTypeByIdSchemaErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberTypeByIdSchemaResponses, GetMemberTypeByIdSchemaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/{id}/schema',
            ...options
        });
    }
    
    /**
     * Gets member types allowed at root.
     *
     * Gets a collection of member types that are allowed to be created at the root level.
     */
    public static getMemberTypeAllowedAtRoot<ThrowOnError extends boolean = true>(options?: Options<GetMemberTypeAllowedAtRootData, ThrowOnError>): RequestResult<GetMemberTypeAllowedAtRootResponses, GetMemberTypeAllowedAtRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMemberTypeAllowedAtRootResponses, GetMemberTypeAllowedAtRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/allowed-at-root',
            ...options
        });
    }
    
    /**
     * Gets available compositions.
     *
     * Gets a collection of member types that are available to use as compositions for the specified member type.
     */
    public static postMemberTypeAvailableCompositions<ThrowOnError extends boolean = true>(options: Options<PostMemberTypeAvailableCompositionsData, ThrowOnError>): RequestResult<PostMemberTypeAvailableCompositionsResponses, PostMemberTypeAvailableCompositionsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMemberTypeAvailableCompositionsResponses, PostMemberTypeAvailableCompositionsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/available-compositions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets multiple member types.
     *
     * Gets multiple member types identified by the provided Ids.
     */
    public static getMemberTypeBatch<ThrowOnError extends boolean = true>(options?: Options<GetMemberTypeBatchData, ThrowOnError>): RequestResult<GetMemberTypeBatchResponses, GetMemberTypeBatchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMemberTypeBatchResponses, GetMemberTypeBatchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/batch',
            ...options
        });
    }
    
    /**
     * Gets the member type configuration.
     *
     * Gets the configuration settings for member types.
     */
    public static getMemberTypeConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetMemberTypeConfigurationData, ThrowOnError>): RequestResult<GetMemberTypeConfigurationResponses, GetMemberTypeConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMemberTypeConfigurationResponses, GetMemberTypeConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/configuration',
            ...options
        });
    }
    
    /**
     * Creates a member type folder.
     *
     * Creates a new member type folder with the provided name and parent location.
     */
    public static postMemberTypeFolder<ThrowOnError extends boolean = true>(options: Options<PostMemberTypeFolderData, ThrowOnError>): RequestResult<PostMemberTypeFolderResponses, PostMemberTypeFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMemberTypeFolderResponses, PostMemberTypeFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a member type folder.
     *
     * Deletes a member type folder identified by the provided Id.
     */
    public static deleteMemberTypeFolderById<ThrowOnError extends boolean = true>(options: Options<DeleteMemberTypeFolderByIdData, ThrowOnError>): RequestResult<DeleteMemberTypeFolderByIdResponses, DeleteMemberTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMemberTypeFolderByIdResponses, DeleteMemberTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/folder/{id}',
            ...options
        });
    }
    
    /**
     * Gets a member type folder.
     *
     * Gets a member type folder identified by the provided Id.
     */
    public static getMemberTypeFolderById<ThrowOnError extends boolean = true>(options: Options<GetMemberTypeFolderByIdData, ThrowOnError>): RequestResult<GetMemberTypeFolderByIdResponses, GetMemberTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMemberTypeFolderByIdResponses, GetMemberTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/folder/{id}',
            ...options
        });
    }
    
    /**
     * Updates a member type folder.
     *
     * Updates a member type folder identified by the provided Id with the details from the request model.
     */
    public static putMemberTypeFolderById<ThrowOnError extends boolean = true>(options: Options<PutMemberTypeFolderByIdData, ThrowOnError>): RequestResult<PutMemberTypeFolderByIdResponses, PutMemberTypeFolderByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMemberTypeFolderByIdResponses, PutMemberTypeFolderByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/folder/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Imports a member type.
     *
     * Imports a member type from the provided file upload.
     */
    public static postMemberTypeImport<ThrowOnError extends boolean = true>(options: Options<PostMemberTypeImportData, ThrowOnError>): RequestResult<PostMemberTypeImportResponses, PostMemberTypeImportErrors, ThrowOnError> {
        return (options.client ?? client).post<PostMemberTypeImportResponses, PostMemberTypeImportErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/member-type/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a collection of ancestor member type items.
     *
     * Gets a collection of member type items that are ancestors to the provided Id.
     */
    public static getTreeMemberTypeAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeMemberTypeAncestorsData, ThrowOnError>): RequestResult<GetTreeMemberTypeAncestorsResponses, GetTreeMemberTypeAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMemberTypeAncestorsResponses, GetTreeMemberTypeAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/member-type/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of member type tree child items.
     *
     * Gets a paginated collection of member type tree items that are children of the provided parent Id.
     */
    public static getTreeMemberTypeChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeMemberTypeChildrenData, ThrowOnError>): RequestResult<GetTreeMemberTypeChildrenResponses, GetTreeMemberTypeChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMemberTypeChildrenResponses, GetTreeMemberTypeChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/member-type/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of member type items from the root of the tree.
     *
     * Gets a paginated collection of member type items from the root of the tree with optional filtering.
     */
    public static getTreeMemberTypeRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeMemberTypeRootData, ThrowOnError>): RequestResult<GetTreeMemberTypeRootResponses, GetTreeMemberTypeRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMemberTypeRootResponses, GetTreeMemberTypeRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/member-type/root',
            ...options
        });
    }
    
    /**
     * Gets sibling member types in the tree.
     *
     * Gets a collection of member type tree items that are siblings of the provided Id.
     */
    public static getTreeMemberTypeSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeMemberTypeSiblingsData, ThrowOnError>): RequestResult<GetTreeMemberTypeSiblingsResponses, GetTreeMemberTypeSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeMemberTypeSiblingsResponses, GetTreeMemberTypeSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/member-type/siblings',
            ...options
        });
    }
}

export class ModelsBuilderService {
    /**
     * Builds models.
     *
     * Triggers the models builder to generate strongly-typed models for content types.
     */
    public static postModelsBuilderBuild<ThrowOnError extends boolean = true>(options?: Options<PostModelsBuilderBuildData, ThrowOnError>): RequestResult<PostModelsBuilderBuildResponses, PostModelsBuilderBuildErrors, ThrowOnError> {
        return (options?.client ?? client).post<PostModelsBuilderBuildResponses, PostModelsBuilderBuildErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/models-builder/build',
            ...options
        });
    }
    
    /**
     * Gets models builder dashboard data.
     *
     * Gets the dashboard data and current state of the models builder.
     */
    public static getModelsBuilderDashboard<ThrowOnError extends boolean = true>(options?: Options<GetModelsBuilderDashboardData, ThrowOnError>): RequestResult<GetModelsBuilderDashboardResponses, GetModelsBuilderDashboardErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetModelsBuilderDashboardResponses, GetModelsBuilderDashboardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/models-builder/dashboard',
            ...options
        });
    }
    
    /**
     * Gets models builder status.
     *
     * Gets the current status and configuration of the models builder.
     */
    public static getModelsBuilderStatus<ThrowOnError extends boolean = true>(options?: Options<GetModelsBuilderStatusData, ThrowOnError>): RequestResult<GetModelsBuilderStatusResponses, GetModelsBuilderStatusErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetModelsBuilderStatusResponses, GetModelsBuilderStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/models-builder/status',
            ...options
        });
    }
}

export class NewsDashboardService {
    /**
     * Gets news dashboard content.
     *
     * Gets the news dashboard content including recent news items and updates for the Umbraco back office.
     */
    public static getNewsDashboard<ThrowOnError extends boolean = true>(options?: Options<GetNewsDashboardData, ThrowOnError>): RequestResult<GetNewsDashboardResponses, GetNewsDashboardErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetNewsDashboardResponses, GetNewsDashboardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/news-dashboard',
            ...options
        });
    }
}

export class ObjectTypesService {
    /**
     * Gets a paginated collection of allowed object types.
     *
     * Gets a paginated collection of object types that are allowed as relation type targets.
     */
    public static getObjectTypes<ThrowOnError extends boolean = true>(options?: Options<GetObjectTypesData, ThrowOnError>): RequestResult<GetObjectTypesResponses, GetObjectTypesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetObjectTypesResponses, GetObjectTypesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/object-types',
            ...options
        });
    }
}

export class OEmbedService {
    /**
     * Queries OEmbed information.
     *
     * Queries OEmbed information for the specified URL.
     */
    public static getOembedQuery<ThrowOnError extends boolean = true>(options?: Options<GetOembedQueryData, ThrowOnError>): RequestResult<GetOembedQueryResponses, GetOembedQueryErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetOembedQueryResponses, GetOembedQueryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/oembed/query',
            ...options
        });
    }
}

export class PackageService {
    /**
     * Runs pending package migrations.
     *
     * Executes all pending package migrations to update the database schema.
     */
    public static postPackageByNameRunMigration<ThrowOnError extends boolean = true>(options: Options<PostPackageByNameRunMigrationData, ThrowOnError>): RequestResult<PostPackageByNameRunMigrationResponses, PostPackageByNameRunMigrationErrors, ThrowOnError> {
        return (options.client ?? client).post<PostPackageByNameRunMigrationResponses, PostPackageByNameRunMigrationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/{name}/run-migration',
            ...options
        });
    }
    
    /**
     * Gets the package configuration.
     *
     * Gets the configuration settings for packages.
     */
    public static getPackageConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetPackageConfigurationData, ThrowOnError>): RequestResult<GetPackageConfigurationResponses, GetPackageConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetPackageConfigurationResponses, GetPackageConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/configuration',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of created packages.
     *
     * Gets a paginated collection of all created packages.
     */
    public static getPackageCreated<ThrowOnError extends boolean = true>(options?: Options<GetPackageCreatedData, ThrowOnError>): RequestResult<GetPackageCreatedResponses, GetPackageCreatedErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetPackageCreatedResponses, GetPackageCreatedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/created',
            ...options
        });
    }
    
    /**
     * Creates a new package.
     *
     * Creates a new package with the configuration specified in the request model.
     */
    public static postPackageCreated<ThrowOnError extends boolean = true>(options: Options<PostPackageCreatedData, ThrowOnError>): RequestResult<PostPackageCreatedResponses, PostPackageCreatedErrors, ThrowOnError> {
        return (options.client ?? client).post<PostPackageCreatedResponses, PostPackageCreatedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/created',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a package.
     *
     * Deletes a package identified by the provided Id.
     */
    public static deletePackageCreatedById<ThrowOnError extends boolean = true>(options: Options<DeletePackageCreatedByIdData, ThrowOnError>): RequestResult<DeletePackageCreatedByIdResponses, DeletePackageCreatedByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeletePackageCreatedByIdResponses, DeletePackageCreatedByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/created/{id}',
            ...options
        });
    }
    
    /**
     * Gets a package.
     *
     * Gets a package identified by the provided Id.
     */
    public static getPackageCreatedById<ThrowOnError extends boolean = true>(options: Options<GetPackageCreatedByIdData, ThrowOnError>): RequestResult<GetPackageCreatedByIdResponses, GetPackageCreatedByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetPackageCreatedByIdResponses, GetPackageCreatedByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/created/{id}',
            ...options
        });
    }
    
    /**
     * Updates a package.
     *
     * Updates a package identified by the provided Id with the details from the request model.
     */
    public static putPackageCreatedById<ThrowOnError extends boolean = true>(options: Options<PutPackageCreatedByIdData, ThrowOnError>): RequestResult<PutPackageCreatedByIdResponses, PutPackageCreatedByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutPackageCreatedByIdResponses, PutPackageCreatedByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/created/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Downloads a created package.
     *
     * Downloads the package file for the created package identified by the provided Id.
     */
    public static getPackageCreatedByIdDownload<ThrowOnError extends boolean = true>(options: Options<GetPackageCreatedByIdDownloadData, ThrowOnError>): RequestResult<GetPackageCreatedByIdDownloadResponses, GetPackageCreatedByIdDownloadErrors, ThrowOnError> {
        return (options.client ?? client).get<GetPackageCreatedByIdDownloadResponses, GetPackageCreatedByIdDownloadErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/created/{id}/download',
            ...options
        });
    }
    
    /**
     * Gets all package migration statuses.
     *
     * Gets a paginated collection of migration status for all installed packages.
     */
    public static getPackageMigrationStatus<ThrowOnError extends boolean = true>(options?: Options<GetPackageMigrationStatusData, ThrowOnError>): RequestResult<GetPackageMigrationStatusResponses, GetPackageMigrationStatusErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetPackageMigrationStatusResponses, GetPackageMigrationStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/package/migration-status',
            ...options
        });
    }
}

export class PartialViewService {
    /**
     * Gets a collection of partial view items.
     *
     * Gets a collection of partial view items identified by the provided Ids.
     */
    public static getItemPartialView<ThrowOnError extends boolean = true>(options?: Options<GetItemPartialViewData, ThrowOnError>): RequestResult<GetItemPartialViewResponses, GetItemPartialViewErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemPartialViewResponses, GetItemPartialViewErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/partial-view',
            ...options
        });
    }
    
    /**
     * Creates a new partial view.
     *
     * Creates a new partial view with the configuration specified in the request model.
     */
    public static postPartialView<ThrowOnError extends boolean = true>(options: Options<PostPartialViewData, ThrowOnError>): RequestResult<PostPartialViewResponses, PostPartialViewErrors, ThrowOnError> {
        return (options.client ?? client).post<PostPartialViewResponses, PostPartialViewErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a partial view.
     *
     * Deletes a partial view identified by the provided Id.
     */
    public static deletePartialViewByPath<ThrowOnError extends boolean = true>(options: Options<DeletePartialViewByPathData, ThrowOnError>): RequestResult<DeletePartialViewByPathResponses, DeletePartialViewByPathErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeletePartialViewByPathResponses, DeletePartialViewByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/{path}',
            ...options
        });
    }
    
    /**
     * Gets a partial view by path.
     *
     * Gets a partial view identified by the provided file path.
     */
    public static getPartialViewByPath<ThrowOnError extends boolean = true>(options: Options<GetPartialViewByPathData, ThrowOnError>): RequestResult<GetPartialViewByPathResponses, GetPartialViewByPathErrors, ThrowOnError> {
        return (options.client ?? client).get<GetPartialViewByPathResponses, GetPartialViewByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/{path}',
            ...options
        });
    }
    
    /**
     * Updates a partial view.
     *
     * Updates a partial view identified by the provided Id with the details from the request model.
     */
    public static putPartialViewByPath<ThrowOnError extends boolean = true>(options: Options<PutPartialViewByPathData, ThrowOnError>): RequestResult<PutPartialViewByPathResponses, PutPartialViewByPathErrors, ThrowOnError> {
        return (options.client ?? client).put<PutPartialViewByPathResponses, PutPartialViewByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/{path}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Renames a partial view.
     *
     * Renames a partial view file to the specified new name.
     */
    public static putPartialViewByPathRename<ThrowOnError extends boolean = true>(options: Options<PutPartialViewByPathRenameData, ThrowOnError>): RequestResult<PutPartialViewByPathRenameResponses, PutPartialViewByPathRenameErrors, ThrowOnError> {
        return (options.client ?? client).put<PutPartialViewByPathRenameResponses, PutPartialViewByPathRenameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/{path}/rename',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Creates a partial view folder.
     *
     * Creates a new partial view folder with the provided name and parent location.
     */
    public static postPartialViewFolder<ThrowOnError extends boolean = true>(options: Options<PostPartialViewFolderData, ThrowOnError>): RequestResult<PostPartialViewFolderResponses, PostPartialViewFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostPartialViewFolderResponses, PostPartialViewFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a partial view folder.
     *
     * Deletes a partial view folder identified by the provided Id.
     */
    public static deletePartialViewFolderByPath<ThrowOnError extends boolean = true>(options: Options<DeletePartialViewFolderByPathData, ThrowOnError>): RequestResult<DeletePartialViewFolderByPathResponses, DeletePartialViewFolderByPathErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeletePartialViewFolderByPathResponses, DeletePartialViewFolderByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/folder/{path}',
            ...options
        });
    }
    
    /**
     * Gets a partial view folder by path.
     *
     * Gets a partial view folder identified by the provided file path.
     */
    public static getPartialViewFolderByPath<ThrowOnError extends boolean = true>(options: Options<GetPartialViewFolderByPathData, ThrowOnError>): RequestResult<GetPartialViewFolderByPathResponses, GetPartialViewFolderByPathErrors, ThrowOnError> {
        return (options.client ?? client).get<GetPartialViewFolderByPathResponses, GetPartialViewFolderByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/folder/{path}',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of partial view snippets.
     *
     * Gets a paginated collection of available partial view code snippets that can be used when creating new partial views.
     */
    public static getPartialViewSnippet<ThrowOnError extends boolean = true>(options?: Options<GetPartialViewSnippetData, ThrowOnError>): RequestResult<GetPartialViewSnippetResponses, GetPartialViewSnippetErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetPartialViewSnippetResponses, GetPartialViewSnippetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/snippet',
            ...options
        });
    }
    
    /**
     * Gets a partial view snippet.
     *
     * Gets a partial view snippet identified by the provided Id.
     */
    public static getPartialViewSnippetById<ThrowOnError extends boolean = true>(options: Options<GetPartialViewSnippetByIdData, ThrowOnError>): RequestResult<GetPartialViewSnippetByIdResponses, GetPartialViewSnippetByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetPartialViewSnippetByIdResponses, GetPartialViewSnippetByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/partial-view/snippet/{id}',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor partial view items.
     *
     * Gets a collection of partial view items that are ancestors to the provided Id.
     */
    public static getTreePartialViewAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreePartialViewAncestorsData, ThrowOnError>): RequestResult<GetTreePartialViewAncestorsResponses, GetTreePartialViewAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreePartialViewAncestorsResponses, GetTreePartialViewAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/partial-view/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of partial view tree child items.
     *
     * Gets a paginated collection of partial view tree items that are children of the provided parent Id.
     */
    public static getTreePartialViewChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreePartialViewChildrenData, ThrowOnError>): RequestResult<GetTreePartialViewChildrenResponses, GetTreePartialViewChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreePartialViewChildrenResponses, GetTreePartialViewChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/partial-view/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of partial view items from the root of the tree.
     *
     * Gets a paginated collection of partial view items from the root of the tree with optional filtering.
     */
    public static getTreePartialViewRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreePartialViewRootData, ThrowOnError>): RequestResult<GetTreePartialViewRootResponses, GetTreePartialViewRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreePartialViewRootResponses, GetTreePartialViewRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/partial-view/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of partial view tree sibling items.
     *
     * Gets a collection of partial view tree items that are siblings of the provided Id.
     */
    public static getTreePartialViewSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreePartialViewSiblingsData, ThrowOnError>): RequestResult<GetTreePartialViewSiblingsResponses, GetTreePartialViewSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreePartialViewSiblingsResponses, GetTreePartialViewSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/partial-view/siblings',
            ...options
        });
    }
}

export class PreviewService {
    /**
     * Exits preview mode.
     *
     * Exits preview mode and returns to the normal back office viewing experience.
     */
    public static deletePreview<ThrowOnError extends boolean = true>(options?: Options<DeletePreviewData, ThrowOnError>): RequestResult<DeletePreviewResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).delete<DeletePreviewResponses, unknown, ThrowOnError>({ url: '/umbraco/management/api/v1/preview', ...options });
    }
}

export class ProfilingService {
    /**
     * Gets profiling status.
     *
     * Gets the current status of the MiniProfiler profiling tool.
     */
    public static getProfilingStatus<ThrowOnError extends boolean = true>(options?: Options<GetProfilingStatusData, ThrowOnError>): RequestResult<GetProfilingStatusResponses, GetProfilingStatusErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetProfilingStatusResponses, GetProfilingStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/profiling/status',
            ...options
        });
    }
    
    /**
     * Updates the web profiling status.
     *
     * Enables or disables web profiling according to the values provided in the request model.
     */
    public static putProfilingStatus<ThrowOnError extends boolean = true>(options: Options<PutProfilingStatusData, ThrowOnError>): RequestResult<PutProfilingStatusResponses, PutProfilingStatusErrors, ThrowOnError> {
        return (options.client ?? client).put<PutProfilingStatusResponses, PutProfilingStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/profiling/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PropertyTypeService {
    /**
     * Checks if a property type is used.
     *
     * Checks if the property type identified by the provided content type id and property alias is used in any content, media, or members.
     */
    public static getPropertyTypeIsUsed<ThrowOnError extends boolean = true>(options?: Options<GetPropertyTypeIsUsedData, ThrowOnError>): RequestResult<GetPropertyTypeIsUsedResponses, GetPropertyTypeIsUsedErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetPropertyTypeIsUsedResponses, GetPropertyTypeIsUsedErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/property-type/is-used',
            ...options
        });
    }
}

export class PublishedCacheService {
    /**
     * Rebuilds the published content cache.
     *
     * Rebuilds the entire published content cache from scratch.
     */
    public static postPublishedCacheRebuild<ThrowOnError extends boolean = true>(options?: Options<PostPublishedCacheRebuildData, ThrowOnError>): RequestResult<PostPublishedCacheRebuildResponses, PostPublishedCacheRebuildErrors, ThrowOnError> {
        return (options?.client ?? client).post<PostPublishedCacheRebuildResponses, PostPublishedCacheRebuildErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/published-cache/rebuild',
            ...options
        });
    }
    
    /**
     * Gets the rebuild cache status.
     *
     * Gets the current status of the published content cache rebuild operation.
     */
    public static getPublishedCacheRebuildStatus<ThrowOnError extends boolean = true>(options?: Options<GetPublishedCacheRebuildStatusData, ThrowOnError>): RequestResult<GetPublishedCacheRebuildStatusResponses, GetPublishedCacheRebuildStatusErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetPublishedCacheRebuildStatusResponses, GetPublishedCacheRebuildStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/published-cache/rebuild/status',
            ...options
        });
    }
    
    /**
     * Reloads the published content cache.
     *
     * Reloads the published content cache from the database.
     */
    public static postPublishedCacheReload<ThrowOnError extends boolean = true>(options?: Options<PostPublishedCacheReloadData, ThrowOnError>): RequestResult<PostPublishedCacheReloadResponses, PostPublishedCacheReloadErrors, ThrowOnError> {
        return (options?.client ?? client).post<PostPublishedCacheReloadResponses, PostPublishedCacheReloadErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/published-cache/reload',
            ...options
        });
    }
}

export class RedirectManagementService {
    /**
     * Gets a paginated collection of redirect URLs.
     *
     * Gets a paginated collection of redirect URLs with support for filtering and sorting.
     */
    public static getRedirectManagement<ThrowOnError extends boolean = true>(options?: Options<GetRedirectManagementData, ThrowOnError>): RequestResult<GetRedirectManagementResponses, GetRedirectManagementErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRedirectManagementResponses, GetRedirectManagementErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/redirect-management',
            ...options
        });
    }
    
    /**
     * Deletes a redirect URL.
     *
     * Deletes a redirect URL identified by the provided Id.
     */
    public static deleteRedirectManagementById<ThrowOnError extends boolean = true>(options: Options<DeleteRedirectManagementByIdData, ThrowOnError>): RequestResult<DeleteRedirectManagementByIdResponses, DeleteRedirectManagementByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteRedirectManagementByIdResponses, DeleteRedirectManagementByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/redirect-management/{id}',
            ...options
        });
    }
    
    /**
     * Gets a redirect URL.
     *
     * Gets a redirect URL identified by the provided Id.
     */
    public static getRedirectManagementById<ThrowOnError extends boolean = true>(options: Options<GetRedirectManagementByIdData, ThrowOnError>): RequestResult<GetRedirectManagementByIdResponses, GetRedirectManagementByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetRedirectManagementByIdResponses, GetRedirectManagementByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/redirect-management/{id}',
            ...options
        });
    }
    
    /**
     * Gets the current redirect URL management status.
     *
     * Retrieves the current status and configuration for redirect URL management.
     */
    public static getRedirectManagementStatus<ThrowOnError extends boolean = true>(options?: Options<GetRedirectManagementStatusData, ThrowOnError>): RequestResult<GetRedirectManagementStatusResponses, GetRedirectManagementStatusErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRedirectManagementStatusResponses, GetRedirectManagementStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/redirect-management/status',
            ...options
        });
    }
    
    /**
     * Deprecated. No longer changes the redirect URL tracking status.
     *
     * This endpoint is deprecated and no longer modifies the configuration. To toggle redirect URL tracking, set the Umbraco:CMS:WebRouting:DisableRedirectUrlTracking configuration key instead.
     */
    public static postRedirectManagementStatus<ThrowOnError extends boolean = true>(options?: Options<PostRedirectManagementStatusData, ThrowOnError>): RequestResult<PostRedirectManagementStatusResponses, PostRedirectManagementStatusErrors, ThrowOnError> {
        return (options?.client ?? client).post<PostRedirectManagementStatusResponses, PostRedirectManagementStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/redirect-management/status',
            ...options
        });
    }
}

export class RelationService {
    /**
     * Gets relations by relation type.
     *
     * Gets a collection of relations filtered by the specified relation type key.
     */
    public static getRelationByRelationTypeId<ThrowOnError extends boolean = true>(options: Options<GetRelationByRelationTypeIdData, ThrowOnError>): RequestResult<GetRelationByRelationTypeIdResponses, GetRelationByRelationTypeIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetRelationByRelationTypeIdResponses, GetRelationByRelationTypeIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/relation/type/{id}',
            ...options
        });
    }
}

export class RelationTypeService {
    /**
     * Gets a collection of relation type items.
     *
     * Gets a collection of relation type items identified by the provided Ids.
     */
    public static getItemRelationType<ThrowOnError extends boolean = true>(options?: Options<GetItemRelationTypeData, ThrowOnError>): RequestResult<GetItemRelationTypeResponses, GetItemRelationTypeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemRelationTypeResponses, GetItemRelationTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/relation-type',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of relation types.
     *
     * Gets a paginated collection of all relation types configured in the system.
     */
    public static getRelationType<ThrowOnError extends boolean = true>(options?: Options<GetRelationTypeData, ThrowOnError>): RequestResult<GetRelationTypeResponses, GetRelationTypeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetRelationTypeResponses, GetRelationTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/relation-type',
            ...options
        });
    }
    
    /**
     * Gets a relation type.
     *
     * Gets a relation type identified by the provided Id.
     */
    public static getRelationTypeById<ThrowOnError extends boolean = true>(options: Options<GetRelationTypeByIdData, ThrowOnError>): RequestResult<GetRelationTypeByIdResponses, GetRelationTypeByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetRelationTypeByIdResponses, GetRelationTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/relation-type/{id}',
            ...options
        });
    }
}

export class ScriptService {
    /**
     * Gets a collection of script items.
     *
     * Gets a collection of script items identified by the provided Ids.
     */
    public static getItemScript<ThrowOnError extends boolean = true>(options?: Options<GetItemScriptData, ThrowOnError>): RequestResult<GetItemScriptResponses, GetItemScriptErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemScriptResponses, GetItemScriptErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/script',
            ...options
        });
    }
    
    /**
     * Creates a new script.
     *
     * Creates a new script with the configuration specified in the request model.
     */
    public static postScript<ThrowOnError extends boolean = true>(options: Options<PostScriptData, ThrowOnError>): RequestResult<PostScriptResponses, PostScriptErrors, ThrowOnError> {
        return (options.client ?? client).post<PostScriptResponses, PostScriptErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/script',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a script.
     *
     * Deletes a script identified by the provided file path.
     */
    public static deleteScriptByPath<ThrowOnError extends boolean = true>(options: Options<DeleteScriptByPathData, ThrowOnError>): RequestResult<DeleteScriptByPathResponses, DeleteScriptByPathErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteScriptByPathResponses, DeleteScriptByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/script/{path}',
            ...options
        });
    }
    
    /**
     * Gets a script by path.
     *
     * Gets a script identified by the provided file path.
     */
    public static getScriptByPath<ThrowOnError extends boolean = true>(options: Options<GetScriptByPathData, ThrowOnError>): RequestResult<GetScriptByPathResponses, GetScriptByPathErrors, ThrowOnError> {
        return (options.client ?? client).get<GetScriptByPathResponses, GetScriptByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/script/{path}',
            ...options
        });
    }
    
    /**
     * Updates a script.
     *
     * Updates a script identified by the provided Id with the details from the request model.
     */
    public static putScriptByPath<ThrowOnError extends boolean = true>(options: Options<PutScriptByPathData, ThrowOnError>): RequestResult<PutScriptByPathResponses, PutScriptByPathErrors, ThrowOnError> {
        return (options.client ?? client).put<PutScriptByPathResponses, PutScriptByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/script/{path}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Renames a script.
     *
     * Renames a script file to the specified new name.
     */
    public static putScriptByPathRename<ThrowOnError extends boolean = true>(options: Options<PutScriptByPathRenameData, ThrowOnError>): RequestResult<PutScriptByPathRenameResponses, PutScriptByPathRenameErrors, ThrowOnError> {
        return (options.client ?? client).put<PutScriptByPathRenameResponses, PutScriptByPathRenameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/script/{path}/rename',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Creates a script folder.
     *
     * Creates a new script folder with the provided name and parent location.
     */
    public static postScriptFolder<ThrowOnError extends boolean = true>(options: Options<PostScriptFolderData, ThrowOnError>): RequestResult<PostScriptFolderResponses, PostScriptFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostScriptFolderResponses, PostScriptFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/script/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a script folder.
     *
     * Deletes a script folder identified by the provided Id.
     */
    public static deleteScriptFolderByPath<ThrowOnError extends boolean = true>(options: Options<DeleteScriptFolderByPathData, ThrowOnError>): RequestResult<DeleteScriptFolderByPathResponses, DeleteScriptFolderByPathErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteScriptFolderByPathResponses, DeleteScriptFolderByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/script/folder/{path}',
            ...options
        });
    }
    
    /**
     * Gets a script folder by path.
     *
     * Gets a script folder identified by the provided file path.
     */
    public static getScriptFolderByPath<ThrowOnError extends boolean = true>(options: Options<GetScriptFolderByPathData, ThrowOnError>): RequestResult<GetScriptFolderByPathResponses, GetScriptFolderByPathErrors, ThrowOnError> {
        return (options.client ?? client).get<GetScriptFolderByPathResponses, GetScriptFolderByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/script/folder/{path}',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor script items.
     *
     * Gets a collection of script items that are ancestors to the provided Id.
     */
    public static getTreeScriptAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeScriptAncestorsData, ThrowOnError>): RequestResult<GetTreeScriptAncestorsResponses, GetTreeScriptAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeScriptAncestorsResponses, GetTreeScriptAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/script/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of script tree child items.
     *
     * Gets a paginated collection of script tree items that are children of the provided parent Id.
     */
    public static getTreeScriptChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeScriptChildrenData, ThrowOnError>): RequestResult<GetTreeScriptChildrenResponses, GetTreeScriptChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeScriptChildrenResponses, GetTreeScriptChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/script/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of script items from the root of the tree.
     *
     * Gets a paginated collection of script items from the root of the tree with optional filtering.
     */
    public static getTreeScriptRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeScriptRootData, ThrowOnError>): RequestResult<GetTreeScriptRootResponses, GetTreeScriptRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeScriptRootResponses, GetTreeScriptRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/script/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of script tree sibling items.
     *
     * Gets a collection of script tree items that are siblings of the provided Id.
     */
    public static getTreeScriptSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeScriptSiblingsData, ThrowOnError>): RequestResult<GetTreeScriptSiblingsResponses, GetTreeScriptSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeScriptSiblingsResponses, GetTreeScriptSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/script/siblings',
            ...options
        });
    }
}

export class SearcherService {
    /**
     * Gets a collection of searchers.
     *
     * Gets a collection of configured searchers in the Umbraco installation.
     */
    public static getSearcher<ThrowOnError extends boolean = true>(options?: Options<GetSearcherData, ThrowOnError>): RequestResult<GetSearcherResponses, GetSearcherErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetSearcherResponses, GetSearcherErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/searcher',
            ...options
        });
    }
    
    /**
     * Queries a searcher.
     *
     * Queries a named searcher with the provided search term and returns a paginated collection of search results.
     */
    public static getSearcherBySearcherNameQuery<ThrowOnError extends boolean = true>(options: Options<GetSearcherBySearcherNameQueryData, ThrowOnError>): RequestResult<GetSearcherBySearcherNameQueryResponses, GetSearcherBySearcherNameQueryErrors, ThrowOnError> {
        return (options.client ?? client).get<GetSearcherBySearcherNameQueryResponses, GetSearcherBySearcherNameQueryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/searcher/{searcherName}/query',
            ...options
        });
    }
}

export class SecurityService {
    /**
     * Gets the security configuration.
     *
     * Gets the configuration settings for security.
     */
    public static getSecurityConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetSecurityConfigurationData, ThrowOnError>): RequestResult<GetSecurityConfigurationResponses, GetSecurityConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetSecurityConfigurationResponses, GetSecurityConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/security/configuration',
            ...options
        });
    }
    
    /**
     * Requests a password reset.
     *
     * Initiates a password reset process by sending a reset link to the specified email address.
     */
    public static postSecurityForgotPassword<ThrowOnError extends boolean = true>(options: Options<PostSecurityForgotPasswordData, ThrowOnError>): RequestResult<PostSecurityForgotPasswordResponses, PostSecurityForgotPasswordErrors, ThrowOnError> {
        return (options.client ?? client).post<PostSecurityForgotPasswordResponses, PostSecurityForgotPasswordErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/security/forgot-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Initiates password reset.
     *
     * Initiates a password reset process for the user with the provided email.
     */
    public static postSecurityForgotPasswordReset<ThrowOnError extends boolean = true>(options: Options<PostSecurityForgotPasswordResetData, ThrowOnError>): RequestResult<PostSecurityForgotPasswordResetResponses, PostSecurityForgotPasswordResetErrors, ThrowOnError> {
        return (options.client ?? client).post<PostSecurityForgotPasswordResetResponses, PostSecurityForgotPasswordResetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/security/forgot-password/reset',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Verifies a password reset token.
     *
     * Verifies the provided password reset token for the specified user.
     */
    public static postSecurityForgotPasswordVerify<ThrowOnError extends boolean = true>(options: Options<PostSecurityForgotPasswordVerifyData, ThrowOnError>): RequestResult<PostSecurityForgotPasswordVerifyResponses, PostSecurityForgotPasswordVerifyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostSecurityForgotPasswordVerifyResponses, PostSecurityForgotPasswordVerifyErrors, ThrowOnError>({
            url: '/umbraco/management/api/v1/security/forgot-password/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SegmentService {
    /**
     * Gets a paginated collection of segments.
     *
     * Gets a paginated collection of segments with support for filtering and pagination.
     */
    public static getSegment<ThrowOnError extends boolean = true>(options?: Options<GetSegmentData, ThrowOnError>): RequestResult<GetSegmentResponses, GetSegmentErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetSegmentResponses, GetSegmentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/segment',
            ...options
        });
    }
}

export class ServerService {
    /**
     * Gets the server configuration.
     *
     * Gets the configuration settings for servers.
     */
    public static getServerConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetServerConfigurationData, ThrowOnError>): RequestResult<GetServerConfigurationResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetServerConfigurationResponses, unknown, ThrowOnError>({ url: '/umbraco/management/api/v1/server/configuration', ...options });
    }
    
    /**
     * Gets server information.
     *
     * Gets detailed information about the server environment and configuration.
     */
    public static getServerInformation<ThrowOnError extends boolean = true>(options?: Options<GetServerInformationData, ThrowOnError>): RequestResult<GetServerInformationResponses, GetServerInformationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetServerInformationResponses, GetServerInformationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/server/information',
            ...options
        });
    }
    
    /**
     * Gets server status.
     *
     * Gets the current operational status of the Umbraco server.
     */
    public static getServerStatus<ThrowOnError extends boolean = true>(options?: Options<GetServerStatusData, ThrowOnError>): RequestResult<GetServerStatusResponses, GetServerStatusErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetServerStatusResponses, GetServerStatusErrors, ThrowOnError>({ url: '/umbraco/management/api/v1/server/status', ...options });
    }
    
    /**
     * Gets server troubleshooting information.
     *
     * Gets troubleshooting information and diagnostics for the server.
     */
    public static getServerTroubleshooting<ThrowOnError extends boolean = true>(options?: Options<GetServerTroubleshootingData, ThrowOnError>): RequestResult<GetServerTroubleshootingResponses, GetServerTroubleshootingErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetServerTroubleshootingResponses, GetServerTroubleshootingErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/server/troubleshooting',
            ...options
        });
    }
    
    /**
     * Checks for available upgrades.
     *
     * Checks if there are any available upgrades for the Umbraco installation.
     */
    public static getServerUpgradeCheck<ThrowOnError extends boolean = true>(options?: Options<GetServerUpgradeCheckData, ThrowOnError>): RequestResult<GetServerUpgradeCheckResponses, GetServerUpgradeCheckErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetServerUpgradeCheckResponses, GetServerUpgradeCheckErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/server/upgrade-check',
            ...options
        });
    }
}

export class StaticFileService {
    /**
     * Gets a collection of static file items.
     *
     * Gets a collection of static file items identified by the provided Ids.
     */
    public static getItemStaticFile<ThrowOnError extends boolean = true>(options?: Options<GetItemStaticFileData, ThrowOnError>): RequestResult<GetItemStaticFileResponses, GetItemStaticFileErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemStaticFileResponses, GetItemStaticFileErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/static-file',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor static file items.
     *
     * Gets a collection of static file items that are ancestors to the provided Id.
     */
    public static getTreeStaticFileAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeStaticFileAncestorsData, ThrowOnError>): RequestResult<GetTreeStaticFileAncestorsResponses, GetTreeStaticFileAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeStaticFileAncestorsResponses, GetTreeStaticFileAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/static-file/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of static file tree child items.
     *
     * Gets a paginated collection of static file tree items that are children of the provided parent Id.
     */
    public static getTreeStaticFileChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeStaticFileChildrenData, ThrowOnError>): RequestResult<GetTreeStaticFileChildrenResponses, GetTreeStaticFileChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeStaticFileChildrenResponses, GetTreeStaticFileChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/static-file/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of static file items from the root of the tree.
     *
     * Gets a paginated collection of static file items from the root of the tree with optional filtering.
     */
    public static getTreeStaticFileRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeStaticFileRootData, ThrowOnError>): RequestResult<GetTreeStaticFileRootResponses, GetTreeStaticFileRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeStaticFileRootResponses, GetTreeStaticFileRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/static-file/root',
            ...options
        });
    }
}

export class StylesheetService {
    /**
     * Gets a collection of stylesheet items.
     *
     * Gets a collection of stylesheet items identified by the provided Ids.
     */
    public static getItemStylesheet<ThrowOnError extends boolean = true>(options?: Options<GetItemStylesheetData, ThrowOnError>): RequestResult<GetItemStylesheetResponses, GetItemStylesheetErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemStylesheetResponses, GetItemStylesheetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/stylesheet',
            ...options
        });
    }
    
    /**
     * Creates a new stylesheet.
     *
     * Creates a new stylesheet with the configuration specified in the request model.
     */
    public static postStylesheet<ThrowOnError extends boolean = true>(options: Options<PostStylesheetData, ThrowOnError>): RequestResult<PostStylesheetResponses, PostStylesheetErrors, ThrowOnError> {
        return (options.client ?? client).post<PostStylesheetResponses, PostStylesheetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/stylesheet',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a stylesheet.
     *
     * Deletes a stylesheet identified by the provided Id.
     */
    public static deleteStylesheetByPath<ThrowOnError extends boolean = true>(options: Options<DeleteStylesheetByPathData, ThrowOnError>): RequestResult<DeleteStylesheetByPathResponses, DeleteStylesheetByPathErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteStylesheetByPathResponses, DeleteStylesheetByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/stylesheet/{path}',
            ...options
        });
    }
    
    /**
     * Gets a stylesheet by path.
     *
     * Gets a stylesheet identified by the provided file path.
     */
    public static getStylesheetByPath<ThrowOnError extends boolean = true>(options: Options<GetStylesheetByPathData, ThrowOnError>): RequestResult<GetStylesheetByPathResponses, GetStylesheetByPathErrors, ThrowOnError> {
        return (options.client ?? client).get<GetStylesheetByPathResponses, GetStylesheetByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/stylesheet/{path}',
            ...options
        });
    }
    
    /**
     * Updates a stylesheet.
     *
     * Updates a stylesheet identified by the provided Id with the details from the request model.
     */
    public static putStylesheetByPath<ThrowOnError extends boolean = true>(options: Options<PutStylesheetByPathData, ThrowOnError>): RequestResult<PutStylesheetByPathResponses, PutStylesheetByPathErrors, ThrowOnError> {
        return (options.client ?? client).put<PutStylesheetByPathResponses, PutStylesheetByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/stylesheet/{path}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Renames a stylesheet.
     *
     * Renames a stylesheet file to the specified new name.
     */
    public static putStylesheetByPathRename<ThrowOnError extends boolean = true>(options: Options<PutStylesheetByPathRenameData, ThrowOnError>): RequestResult<PutStylesheetByPathRenameResponses, PutStylesheetByPathRenameErrors, ThrowOnError> {
        return (options.client ?? client).put<PutStylesheetByPathRenameResponses, PutStylesheetByPathRenameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/stylesheet/{path}/rename',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Creates a stylesheet folder.
     *
     * Creates a new stylesheet folder with the provided name and parent location.
     */
    public static postStylesheetFolder<ThrowOnError extends boolean = true>(options: Options<PostStylesheetFolderData, ThrowOnError>): RequestResult<PostStylesheetFolderResponses, PostStylesheetFolderErrors, ThrowOnError> {
        return (options.client ?? client).post<PostStylesheetFolderResponses, PostStylesheetFolderErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/stylesheet/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a stylesheet folder.
     *
     * Deletes a stylesheet folder identified by the provided Id.
     */
    public static deleteStylesheetFolderByPath<ThrowOnError extends boolean = true>(options: Options<DeleteStylesheetFolderByPathData, ThrowOnError>): RequestResult<DeleteStylesheetFolderByPathResponses, DeleteStylesheetFolderByPathErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteStylesheetFolderByPathResponses, DeleteStylesheetFolderByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/stylesheet/folder/{path}',
            ...options
        });
    }
    
    /**
     * Gets a stylesheet folder by path.
     *
     * Gets a stylesheet folder identified by the provided file path.
     */
    public static getStylesheetFolderByPath<ThrowOnError extends boolean = true>(options: Options<GetStylesheetFolderByPathData, ThrowOnError>): RequestResult<GetStylesheetFolderByPathResponses, GetStylesheetFolderByPathErrors, ThrowOnError> {
        return (options.client ?? client).get<GetStylesheetFolderByPathResponses, GetStylesheetFolderByPathErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/stylesheet/folder/{path}',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor stylesheet items.
     *
     * Gets a collection of stylesheet items that are ancestors to the provided Id.
     */
    public static getTreeStylesheetAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeStylesheetAncestorsData, ThrowOnError>): RequestResult<GetTreeStylesheetAncestorsResponses, GetTreeStylesheetAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeStylesheetAncestorsResponses, GetTreeStylesheetAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/stylesheet/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of stylesheet tree child items.
     *
     * Gets a paginated collection of stylesheet tree items that are children of the provided parent Id.
     */
    public static getTreeStylesheetChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeStylesheetChildrenData, ThrowOnError>): RequestResult<GetTreeStylesheetChildrenResponses, GetTreeStylesheetChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeStylesheetChildrenResponses, GetTreeStylesheetChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/stylesheet/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of stylesheet items from the root of the tree.
     *
     * Gets a paginated collection of stylesheet items from the root of the tree with optional filtering.
     */
    public static getTreeStylesheetRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeStylesheetRootData, ThrowOnError>): RequestResult<GetTreeStylesheetRootResponses, GetTreeStylesheetRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeStylesheetRootResponses, GetTreeStylesheetRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/stylesheet/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of stylesheet tree sibling items.
     *
     * Gets a collection of stylesheet tree items that are siblings of the provided Id.
     */
    public static getTreeStylesheetSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeStylesheetSiblingsData, ThrowOnError>): RequestResult<GetTreeStylesheetSiblingsResponses, GetTreeStylesheetSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeStylesheetSiblingsResponses, GetTreeStylesheetSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/stylesheet/siblings',
            ...options
        });
    }
}

export class TagService {
    /**
     * Gets a collection of tags.
     *
     * Gets a collection of tags filtered by the provided query string.
     */
    public static getTag<ThrowOnError extends boolean = true>(options?: Options<GetTagData, ThrowOnError>): RequestResult<GetTagResponses, GetTagErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTagResponses, GetTagErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tag',
            ...options
        });
    }
}

export class TelemetryService {
    /**
     * Gets telemetry data.
     *
     * Gets telemetry data and statistics for the Umbraco installation.
     */
    public static getTelemetry<ThrowOnError extends boolean = true>(options?: Options<GetTelemetryData, ThrowOnError>): RequestResult<GetTelemetryResponses, GetTelemetryErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTelemetryResponses, GetTelemetryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/telemetry',
            ...options
        });
    }
    
    /**
     * Gets telemetry information.
     *
     * Gets the current telemetry configuration and consent level.
     */
    public static getTelemetryLevel<ThrowOnError extends boolean = true>(options?: Options<GetTelemetryLevelData, ThrowOnError>): RequestResult<GetTelemetryLevelResponses, GetTelemetryLevelErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTelemetryLevelResponses, GetTelemetryLevelErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/telemetry/level',
            ...options
        });
    }
    
    /**
     * Sets telemetry consent level.
     *
     * Sets the telemetry consent level for anonymous usage data collection.
     */
    public static postTelemetryLevel<ThrowOnError extends boolean = true>(options: Options<PostTelemetryLevelData, ThrowOnError>): RequestResult<PostTelemetryLevelResponses, PostTelemetryLevelErrors, ThrowOnError> {
        return (options.client ?? client).post<PostTelemetryLevelResponses, PostTelemetryLevelErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/telemetry/level',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TemplateService {
    /**
     * Gets a collection of template items.
     *
     * Gets a collection of template items identified by the provided Ids.
     */
    public static getItemTemplate<ThrowOnError extends boolean = true>(options?: Options<GetItemTemplateData, ThrowOnError>): RequestResult<GetItemTemplateResponses, GetItemTemplateErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemTemplateResponses, GetItemTemplateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/template',
            ...options
        });
    }
    
    /**
     * Gets ancestors for a collection of template items.
     *
     * Gets the ancestor chains for template items identified by the provided Ids.
     */
    public static getItemTemplateAncestors<ThrowOnError extends boolean = true>(options?: Options<GetItemTemplateAncestorsData, ThrowOnError>): RequestResult<GetItemTemplateAncestorsResponses, GetItemTemplateAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemTemplateAncestorsResponses, GetItemTemplateAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/template/ancestors',
            ...options
        });
    }
    
    /**
     * Searches template items.
     *
     * Searches template items by the provided query with pagination support.
     */
    public static getItemTemplateSearch<ThrowOnError extends boolean = true>(options?: Options<GetItemTemplateSearchData, ThrowOnError>): RequestResult<GetItemTemplateSearchResponses, GetItemTemplateSearchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemTemplateSearchResponses, GetItemTemplateSearchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/template/search',
            ...options
        });
    }
    
    /**
     * Creates a new template.
     *
     * Creates a new template with the configuration specified in the request model.
     */
    public static postTemplate<ThrowOnError extends boolean = true>(options: Options<PostTemplateData, ThrowOnError>): RequestResult<PostTemplateResponses, PostTemplateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostTemplateResponses, PostTemplateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/template',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a template.
     *
     * Deletes a template identified by the provided Id.
     */
    public static deleteTemplateById<ThrowOnError extends boolean = true>(options: Options<DeleteTemplateByIdData, ThrowOnError>): RequestResult<DeleteTemplateByIdResponses, DeleteTemplateByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTemplateByIdResponses, DeleteTemplateByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/template/{id}',
            ...options
        });
    }
    
    /**
     * Gets a template.
     *
     * Gets a template identified by the provided Id.
     */
    public static getTemplateById<ThrowOnError extends boolean = true>(options: Options<GetTemplateByIdData, ThrowOnError>): RequestResult<GetTemplateByIdResponses, GetTemplateByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetTemplateByIdResponses, GetTemplateByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/template/{id}',
            ...options
        });
    }
    
    /**
     * Updates a template.
     *
     * Updates a template identified by the provided Id with the details from the request model.
     */
    public static putTemplateById<ThrowOnError extends boolean = true>(options: Options<PutTemplateByIdData, ThrowOnError>): RequestResult<PutTemplateByIdResponses, PutTemplateByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutTemplateByIdResponses, PutTemplateByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/template/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets the template configuration.
     *
     * Gets the configuration settings for templates.
     */
    public static getTemplateConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetTemplateConfigurationData, ThrowOnError>): RequestResult<GetTemplateConfigurationResponses, GetTemplateConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTemplateConfigurationResponses, GetTemplateConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/template/configuration',
            ...options
        });
    }
    
    /**
     * Executes a template query.
     *
     * Executes a template query with the provided parameters and returns the matching content results with execution metrics.
     */
    public static postTemplateQueryExecute<ThrowOnError extends boolean = true>(options: Options<PostTemplateQueryExecuteData, ThrowOnError>): RequestResult<PostTemplateQueryExecuteResponses, PostTemplateQueryExecuteErrors, ThrowOnError> {
        return (options.client ?? client).post<PostTemplateQueryExecuteResponses, PostTemplateQueryExecuteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/template/query/execute',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets template query settings.
     *
     * Gets the available configuration settings for template queries including document type aliases, properties, and operators.
     */
    public static getTemplateQuerySettings<ThrowOnError extends boolean = true>(options?: Options<GetTemplateQuerySettingsData, ThrowOnError>): RequestResult<GetTemplateQuerySettingsResponses, GetTemplateQuerySettingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTemplateQuerySettingsResponses, GetTemplateQuerySettingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/template/query/settings',
            ...options
        });
    }
    
    /**
     * Gets a collection of ancestor template items.
     *
     * Gets a collection of template items that are ancestors to the provided Id.
     */
    public static getTreeTemplateAncestors<ThrowOnError extends boolean = true>(options?: Options<GetTreeTemplateAncestorsData, ThrowOnError>): RequestResult<GetTreeTemplateAncestorsResponses, GetTreeTemplateAncestorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeTemplateAncestorsResponses, GetTreeTemplateAncestorsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/template/ancestors',
            ...options
        });
    }
    
    /**
     * Gets a collection of template tree child items.
     *
     * Gets a paginated collection of template tree items that are children of the provided parent Id.
     */
    public static getTreeTemplateChildren<ThrowOnError extends boolean = true>(options?: Options<GetTreeTemplateChildrenData, ThrowOnError>): RequestResult<GetTreeTemplateChildrenResponses, GetTreeTemplateChildrenErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeTemplateChildrenResponses, GetTreeTemplateChildrenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/template/children',
            ...options
        });
    }
    
    /**
     * Gets a collection of template items from the root of the tree.
     *
     * Gets a paginated collection of template items from the root of the tree with optional filtering.
     */
    public static getTreeTemplateRoot<ThrowOnError extends boolean = true>(options?: Options<GetTreeTemplateRootData, ThrowOnError>): RequestResult<GetTreeTemplateRootResponses, GetTreeTemplateRootErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeTemplateRootResponses, GetTreeTemplateRootErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/template/root',
            ...options
        });
    }
    
    /**
     * Gets a collection of template tree sibling items.
     *
     * Gets a collection of template tree items that are siblings of the provided Id.
     */
    public static getTreeTemplateSiblings<ThrowOnError extends boolean = true>(options?: Options<GetTreeTemplateSiblingsData, ThrowOnError>): RequestResult<GetTreeTemplateSiblingsResponses, GetTreeTemplateSiblingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTreeTemplateSiblingsResponses, GetTreeTemplateSiblingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/tree/template/siblings',
            ...options
        });
    }
}

export class TemporaryFileService {
    /**
     * Creates a temporary file.
     *
     * Uploads and creates a temporary file that can be used in subsequent operations.
     */
    public static postTemporaryFile<ThrowOnError extends boolean = true>(options: Options<PostTemporaryFileData, ThrowOnError>): RequestResult<PostTemporaryFileResponses, PostTemporaryFileErrors, ThrowOnError> {
        return (options.client ?? client).post<PostTemporaryFileResponses, PostTemporaryFileErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/temporary-file',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a temporary file.
     *
     * Deletes a temporary file identified by the provided Id.
     */
    public static deleteTemporaryFileById<ThrowOnError extends boolean = true>(options: Options<DeleteTemporaryFileByIdData, ThrowOnError>): RequestResult<DeleteTemporaryFileByIdResponses, DeleteTemporaryFileByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTemporaryFileByIdResponses, DeleteTemporaryFileByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/temporary-file/{id}',
            ...options
        });
    }
    
    /**
     * Gets a temporary file.
     *
     * Gets a temporary file identified by the provided Id.
     */
    public static getTemporaryFileById<ThrowOnError extends boolean = true>(options: Options<GetTemporaryFileByIdData, ThrowOnError>): RequestResult<GetTemporaryFileByIdResponses, GetTemporaryFileByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetTemporaryFileByIdResponses, GetTemporaryFileByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/temporary-file/{id}',
            ...options
        });
    }
    
    /**
     * Gets the temporary file configuration.
     *
     * Gets the configuration settings for temporary files.
     */
    public static getTemporaryFileConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetTemporaryFileConfigurationData, ThrowOnError>): RequestResult<GetTemporaryFileConfigurationResponses, GetTemporaryFileConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetTemporaryFileConfigurationResponses, GetTemporaryFileConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/temporary-file/configuration',
            ...options
        });
    }
}

export class UpgradeService {
    /**
     * Authorizes the upgrade.
     *
     * Authorizes the currently authenticated user to perform the upgrade.
     */
    public static postUpgradeAuthorize<ThrowOnError extends boolean = true>(options?: Options<PostUpgradeAuthorizeData, ThrowOnError>): RequestResult<PostUpgradeAuthorizeResponses, PostUpgradeAuthorizeErrors, ThrowOnError> {
        return (options?.client ?? client).post<PostUpgradeAuthorizeResponses, PostUpgradeAuthorizeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/upgrade/authorize',
            ...options
        });
    }
    
    /**
     * Gets upgrade settings.
     *
     * Gets the current upgrade settings and status for the Umbraco installation.
     */
    public static getUpgradeSettings<ThrowOnError extends boolean = true>(options?: Options<GetUpgradeSettingsData, ThrowOnError>): RequestResult<GetUpgradeSettingsResponses, GetUpgradeSettingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUpgradeSettingsResponses, GetUpgradeSettingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/upgrade/settings',
            ...options
        });
    }
}

export class UserService {
    /**
     * Gets a filtered collection of users.
     *
     * Returns a paged collection of users matching the provided criteria — user groups, user states, user kinds (default or API users) and a name/username search term.
     */
    public static getFilterUser<ThrowOnError extends boolean = true>(options?: Options<GetFilterUserData, ThrowOnError>): RequestResult<GetFilterUserResponses, GetFilterUserErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetFilterUserResponses, GetFilterUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/filter/user',
            ...options
        });
    }
    
    /**
     * Gets a collection of user items.
     *
     * Gets a collection of user items identified by the provided Ids.
     */
    public static getItemUser<ThrowOnError extends boolean = true>(options?: Options<GetItemUserData, ThrowOnError>): RequestResult<GetItemUserResponses, GetItemUserErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemUserResponses, GetItemUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/user',
            ...options
        });
    }
    
    /**
     * Deletes multiple users.
     *
     * Deletes multiple users identified by the provided Ids. This operation cannot be undone.
     */
    public static deleteUser<ThrowOnError extends boolean = true>(options: Options<DeleteUserData, ThrowOnError>): RequestResult<DeleteUserResponses, DeleteUserErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a paginated collection of users.
     *
     * Gets a paginated collection of all users.
     */
    public static getUser<ThrowOnError extends boolean = true>(options?: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user',
            ...options
        });
    }
    
    /**
     * Creates a new user.
     *
     * Creates a new user with the configuration specified in the request model.
     */
    public static postUser<ThrowOnError extends boolean = true>(options: Options<PostUserData, ThrowOnError>): RequestResult<PostUserResponses, PostUserErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserResponses, PostUserErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a user.
     *
     * Deletes a user identified by the provided Id.
     */
    public static deleteUserById<ThrowOnError extends boolean = true>(options: Options<DeleteUserByIdData, ThrowOnError>): RequestResult<DeleteUserByIdResponses, DeleteUserByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserByIdResponses, DeleteUserByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}',
            ...options
        });
    }
    
    /**
     * Gets a user.
     *
     * Gets a user identified by the provided Id.
     */
    public static getUserById<ThrowOnError extends boolean = true>(options: Options<GetUserByIdData, ThrowOnError>): RequestResult<GetUserByIdResponses, GetUserByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetUserByIdResponses, GetUserByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}',
            ...options
        });
    }
    
    /**
     * Updates a user.
     *
     * Updates a user identified by the provided Id with the details from the request model.
     */
    public static putUserById<ThrowOnError extends boolean = true>(options: Options<PutUserByIdData, ThrowOnError>): RequestResult<PutUserByIdResponses, PutUserByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutUserByIdResponses, PutUserByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Lists two-factor providers for a user.
     *
     * Gets a list of available two-factor authentication providers for the specified user.
     */
    public static getUserById2Fa<ThrowOnError extends boolean = true>(options: Options<GetUserById2FaData, ThrowOnError>): RequestResult<GetUserById2FaResponses, GetUserById2FaErrors, ThrowOnError> {
        return (options.client ?? client).get<GetUserById2FaResponses, GetUserById2FaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}/2fa',
            ...options
        });
    }
    
    /**
     * Disables two-factor authentication for a user.
     *
     * Disables the specified two-factor authentication provider for a user.
     */
    public static deleteUserById2FaByProviderName<ThrowOnError extends boolean = true>(options: Options<DeleteUserById2FaByProviderNameData, ThrowOnError>): RequestResult<DeleteUserById2FaByProviderNameResponses, DeleteUserById2FaByProviderNameErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserById2FaByProviderNameResponses, DeleteUserById2FaByProviderNameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}/2fa/{providerName}',
            ...options
        });
    }
    
    /**
     * Calculates start nodes for users.
     *
     * Calculates the start nodes for the users identified by the provided Ids based on their permissions.
     */
    public static getUserByIdCalculateStartNodes<ThrowOnError extends boolean = true>(options: Options<GetUserByIdCalculateStartNodesData, ThrowOnError>): RequestResult<GetUserByIdCalculateStartNodesResponses, GetUserByIdCalculateStartNodesErrors, ThrowOnError> {
        return (options.client ?? client).get<GetUserByIdCalculateStartNodesResponses, GetUserByIdCalculateStartNodesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}/calculate-start-nodes',
            ...options
        });
    }
    
    /**
     * Changes a user's password.
     *
     * Changes the password for the user identified by the provided Id.
     */
    public static postUserByIdChangePassword<ThrowOnError extends boolean = true>(options: Options<PostUserByIdChangePasswordData, ThrowOnError>): RequestResult<PostUserByIdChangePasswordResponses, PostUserByIdChangePasswordErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserByIdChangePasswordResponses, PostUserByIdChangePasswordErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}/change-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets all client credentials for a user.
     *
     * Gets a collection of OAuth client credentials for the user identified by the provided Id.
     */
    public static getUserByIdClientCredentials<ThrowOnError extends boolean = true>(options: Options<GetUserByIdClientCredentialsData, ThrowOnError>): RequestResult<GetUserByIdClientCredentialsResponses, GetUserByIdClientCredentialsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetUserByIdClientCredentialsResponses, GetUserByIdClientCredentialsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}/client-credentials',
            ...options
        });
    }
    
    /**
     * Creates client credentials for a user.
     *
     * Creates OAuth client credentials for the user identified by the provided Id.
     */
    public static postUserByIdClientCredentials<ThrowOnError extends boolean = true>(options: Options<PostUserByIdClientCredentialsData, ThrowOnError>): RequestResult<PostUserByIdClientCredentialsResponses, PostUserByIdClientCredentialsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserByIdClientCredentialsResponses, PostUserByIdClientCredentialsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}/client-credentials',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes client credentials for a user.
     *
     * Deletes client credentials identified by the provided client Id for a user.
     */
    public static deleteUserByIdClientCredentialsByClientId<ThrowOnError extends boolean = true>(options: Options<DeleteUserByIdClientCredentialsByClientIdData, ThrowOnError>): RequestResult<DeleteUserByIdClientCredentialsByClientIdResponses, DeleteUserByIdClientCredentialsByClientIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserByIdClientCredentialsByClientIdResponses, DeleteUserByIdClientCredentialsByClientIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}/client-credentials/{clientId}',
            ...options
        });
    }
    
    /**
     * Resets a user's password.
     *
     * Resets the password for the user using the provided reset token.
     */
    public static postUserByIdResetPassword<ThrowOnError extends boolean = true>(options: Options<PostUserByIdResetPasswordData, ThrowOnError>): RequestResult<PostUserByIdResetPasswordResponses, PostUserByIdResetPasswordErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserByIdResetPasswordResponses, PostUserByIdResetPasswordErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/{id}/reset-password',
            ...options
        });
    }
    
    /**
     * Clears a user's avatar.
     *
     * Removes the avatar image for the user identified by the provided Id.
     */
    public static deleteUserAvatarById<ThrowOnError extends boolean = true>(options: Options<DeleteUserAvatarByIdData, ThrowOnError>): RequestResult<DeleteUserAvatarByIdResponses, DeleteUserAvatarByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserAvatarByIdResponses, DeleteUserAvatarByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/avatar/{id}',
            ...options
        });
    }
    
    /**
     * Sets a user's avatar.
     *
     * Sets or updates the avatar image for the user identified by the provided Id.
     */
    public static postUserAvatarById<ThrowOnError extends boolean = true>(options: Options<PostUserAvatarByIdData, ThrowOnError>): RequestResult<PostUserAvatarByIdResponses, PostUserAvatarByIdErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserAvatarByIdResponses, PostUserAvatarByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/avatar/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets multiple users.
     *
     * Gets multiple users identified by the provided Ids.
     */
    public static getUserBatch<ThrowOnError extends boolean = true>(options?: Options<GetUserBatchData, ThrowOnError>): RequestResult<GetUserBatchResponses, GetUserBatchErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserBatchResponses, GetUserBatchErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/batch',
            ...options
        });
    }
    
    /**
     * Gets the user configuration.
     *
     * Gets the configuration settings for users.
     */
    public static getUserConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetUserConfigurationData, ThrowOnError>): RequestResult<GetUserConfigurationResponses, GetUserConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserConfigurationResponses, GetUserConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/configuration',
            ...options
        });
    }
    
    /**
     * Gets the current user.
     *
     * Gets the currently authenticated back office user's information and permissions.
     */
    public static getUserCurrent<ThrowOnError extends boolean = true>(options?: Options<GetUserCurrentData, ThrowOnError>): RequestResult<GetUserCurrentResponses, GetUserCurrentErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserCurrentResponses, GetUserCurrentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current',
            ...options
        });
    }
    
    /**
     * Lists two-factor providers for the current user.
     *
     * Gets a list of available two-factor authentication providers for the current user.
     */
    public static getUserCurrent2Fa<ThrowOnError extends boolean = true>(options?: Options<GetUserCurrent2FaData, ThrowOnError>): RequestResult<GetUserCurrent2FaResponses, GetUserCurrent2FaErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserCurrent2FaResponses, GetUserCurrent2FaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/2fa',
            ...options
        });
    }
    
    /**
     * Disables two-factor authentication for the current user.
     *
     * Disables the specified two-factor authentication provider for the currently authenticated user.
     */
    public static deleteUserCurrent2FaByProviderName<ThrowOnError extends boolean = true>(options: Options<DeleteUserCurrent2FaByProviderNameData, ThrowOnError>): RequestResult<DeleteUserCurrent2FaByProviderNameResponses, DeleteUserCurrent2FaByProviderNameErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserCurrent2FaByProviderNameResponses, DeleteUserCurrent2FaByProviderNameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/2fa/{providerName}',
            ...options
        });
    }
    
    /**
     * Gets two-factor setup information.
     *
     * Gets the setup information for configuring a two-factor authentication provider.
     */
    public static getUserCurrent2FaByProviderName<ThrowOnError extends boolean = true>(options: Options<GetUserCurrent2FaByProviderNameData, ThrowOnError>): RequestResult<GetUserCurrent2FaByProviderNameResponses, GetUserCurrent2FaByProviderNameErrors, ThrowOnError> {
        return (options.client ?? client).get<GetUserCurrent2FaByProviderNameResponses, GetUserCurrent2FaByProviderNameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/2fa/{providerName}',
            ...options
        });
    }
    
    /**
     * Enables two-factor authentication for the current user.
     *
     * Enables the specified two-factor authentication provider for the currently authenticated user.
     */
    public static postUserCurrent2FaByProviderName<ThrowOnError extends boolean = true>(options: Options<PostUserCurrent2FaByProviderNameData, ThrowOnError>): RequestResult<PostUserCurrent2FaByProviderNameResponses, PostUserCurrent2FaByProviderNameErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserCurrent2FaByProviderNameResponses, PostUserCurrent2FaByProviderNameErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/2fa/{providerName}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Clears the current user's avatar.
     *
     * Removes the avatar image for the currently authenticated user.
     */
    public static deleteUserCurrentAvatar<ThrowOnError extends boolean = true>(options?: Options<DeleteUserCurrentAvatarData, ThrowOnError>): RequestResult<DeleteUserCurrentAvatarResponses, DeleteUserCurrentAvatarErrors, ThrowOnError> {
        return (options?.client ?? client).delete<DeleteUserCurrentAvatarResponses, DeleteUserCurrentAvatarErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/avatar',
            ...options
        });
    }
    
    /**
     * Sets the current user's avatar.
     *
     * Sets or updates the avatar image for the currently authenticated user.
     */
    public static postUserCurrentAvatar<ThrowOnError extends boolean = true>(options: Options<PostUserCurrentAvatarData, ThrowOnError>): RequestResult<PostUserCurrentAvatarResponses, PostUserCurrentAvatarErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserCurrentAvatarResponses, PostUserCurrentAvatarErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/avatar',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Changes the current user's password.
     *
     * Changes the password for the currently authenticated user.
     */
    public static postUserCurrentChangePassword<ThrowOnError extends boolean = true>(options: Options<PostUserCurrentChangePasswordData, ThrowOnError>): RequestResult<PostUserCurrentChangePasswordResponses, PostUserCurrentChangePasswordErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserCurrentChangePasswordResponses, PostUserCurrentChangePasswordErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/change-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets the current user's configuration.
     *
     * Gets the configuration settings for the current user.
     */
    public static getUserCurrentConfiguration<ThrowOnError extends boolean = true>(options?: Options<GetUserCurrentConfigurationData, ThrowOnError>): RequestResult<GetUserCurrentConfigurationResponses, GetUserCurrentConfigurationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserCurrentConfigurationResponses, GetUserCurrentConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/configuration',
            ...options
        });
    }
    
    /**
     * Lists external login providers.
     *
     * Gets a list of configured external login providers for authentication.
     */
    public static getUserCurrentLoginProviders<ThrowOnError extends boolean = true>(options?: Options<GetUserCurrentLoginProvidersData, ThrowOnError>): RequestResult<GetUserCurrentLoginProvidersResponses, GetUserCurrentLoginProvidersErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserCurrentLoginProvidersResponses, GetUserCurrentLoginProvidersErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/login-providers',
            ...options
        });
    }
    
    /**
     * Gets permissions for the current user.
     *
     * Gets the permissions for the currently authenticated user.
     */
    public static getUserCurrentPermissions<ThrowOnError extends boolean = true>(options?: Options<GetUserCurrentPermissionsData, ThrowOnError>): RequestResult<GetUserCurrentPermissionsResponses, GetUserCurrentPermissionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserCurrentPermissionsResponses, GetUserCurrentPermissionsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/permissions',
            ...options
        });
    }
    
    /**
     * Gets document permissions for the current user.
     *
     * Gets the document permissions for the currently authenticated user.
     */
    public static getUserCurrentPermissionsDocument<ThrowOnError extends boolean = true>(options?: Options<GetUserCurrentPermissionsDocumentData, ThrowOnError>): RequestResult<GetUserCurrentPermissionsDocumentResponses, GetUserCurrentPermissionsDocumentErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserCurrentPermissionsDocumentResponses, GetUserCurrentPermissionsDocumentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/permissions/document',
            ...options
        });
    }
    
    /**
     * Gets element permissions for the current user.
     *
     * Gets the element permissions for the currently authenticated user.
     */
    public static getUserCurrentPermissionsElement<ThrowOnError extends boolean = true>(options?: Options<GetUserCurrentPermissionsElementData, ThrowOnError>): RequestResult<GetUserCurrentPermissionsElementResponses, GetUserCurrentPermissionsElementErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserCurrentPermissionsElementResponses, GetUserCurrentPermissionsElementErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/permissions/element',
            ...options
        });
    }
    
    /**
     * Gets media permissions for the current user.
     *
     * Gets the media permissions for the currently authenticated user.
     */
    public static getUserCurrentPermissionsMedia<ThrowOnError extends boolean = true>(options?: Options<GetUserCurrentPermissionsMediaData, ThrowOnError>): RequestResult<GetUserCurrentPermissionsMediaResponses, GetUserCurrentPermissionsMediaErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserCurrentPermissionsMediaResponses, GetUserCurrentPermissionsMediaErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/permissions/media',
            ...options
        });
    }
    
    /**
     * Updates current user profile.
     *
     * Updates current user profile with the details from the request model.
     */
    public static putUserCurrentProfile<ThrowOnError extends boolean = true>(options: Options<PutUserCurrentProfileData, ThrowOnError>): RequestResult<PutUserCurrentProfileResponses, PutUserCurrentProfileErrors, ThrowOnError> {
        return (options.client ?? client).put<PutUserCurrentProfileResponses, PutUserCurrentProfileErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/current/profile',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Disables users.
     *
     * Disables the user accounts identified by the provided Ids.
     */
    public static postUserDisable<ThrowOnError extends boolean = true>(options: Options<PostUserDisableData, ThrowOnError>): RequestResult<PostUserDisableResponses, PostUserDisableErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserDisableResponses, PostUserDisableErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/disable',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Enables users.
     *
     * Enables the user accounts identified by the provided Ids.
     */
    public static postUserEnable<ThrowOnError extends boolean = true>(options: Options<PostUserEnableData, ThrowOnError>): RequestResult<PostUserEnableResponses, PostUserEnableErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserEnableResponses, PostUserEnableErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/enable',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Invites new users.
     *
     * Sends invitation emails to create new user accounts with the specified details.
     */
    public static postUserInvite<ThrowOnError extends boolean = true>(options: Options<PostUserInviteData, ThrowOnError>): RequestResult<PostUserInviteResponses, PostUserInviteErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserInviteResponses, PostUserInviteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/invite',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Creates an initial password for a user.
     *
     * Creates an initial password for a newly invited user using the provided token.
     */
    public static postUserInviteCreatePassword<ThrowOnError extends boolean = true>(options: Options<PostUserInviteCreatePasswordData, ThrowOnError>): RequestResult<PostUserInviteCreatePasswordResponses, PostUserInviteCreatePasswordErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserInviteCreatePasswordResponses, PostUserInviteCreatePasswordErrors, ThrowOnError>({
            url: '/umbraco/management/api/v1/user/invite/create-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Resends a user invitation.
     *
     * Resends the invitation email for the users identified by the provided Ids.
     */
    public static postUserInviteResend<ThrowOnError extends boolean = true>(options: Options<PostUserInviteResendData, ThrowOnError>): RequestResult<PostUserInviteResendResponses, PostUserInviteResendErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserInviteResendResponses, PostUserInviteResendErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/invite/resend',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Verifies a user invitation.
     *
     * Verifies that the invitation token is valid for creating a new user account.
     */
    public static postUserInviteVerify<ThrowOnError extends boolean = true>(options: Options<PostUserInviteVerifyData, ThrowOnError>): RequestResult<PostUserInviteVerifyResponses, PostUserInviteVerifyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserInviteVerifyResponses, PostUserInviteVerifyErrors, ThrowOnError>({
            url: '/umbraco/management/api/v1/user/invite/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Updates user group assignments.
     *
     * Updates the user group assignments for the specified users.
     */
    public static postUserSetUserGroups<ThrowOnError extends boolean = true>(options: Options<PostUserSetUserGroupsData, ThrowOnError>): RequestResult<PostUserSetUserGroupsResponses, PostUserSetUserGroupsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserSetUserGroupsResponses, PostUserSetUserGroupsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/set-user-groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Unlocks users.
     *
     * Unlocks the user accounts identified by the provided Ids.
     */
    public static postUserUnlock<ThrowOnError extends boolean = true>(options: Options<PostUserUnlockData, ThrowOnError>): RequestResult<PostUserUnlockResponses, PostUserUnlockErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserUnlockResponses, PostUserUnlockErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user/unlock',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class UserDataService {
    /**
     * Gets user data.
     *
     * Gets user-specific data stored for the current authenticated user.
     */
    public static getUserData<ThrowOnError extends boolean = true>(options?: Options<GetUserDataData, ThrowOnError>): RequestResult<GetUserDataResponses, GetUserDataErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserDataResponses, GetUserDataErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-data',
            ...options
        });
    }
    
    /**
     * Creates user data.
     *
     * Creates user-specific data for the current authenticated user with the provided key and value.
     */
    public static postUserData<ThrowOnError extends boolean = true>(options: Options<PostUserDataData, ThrowOnError>): RequestResult<PostUserDataResponses, PostUserDataErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserDataResponses, PostUserDataErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-data',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Updates user data.
     *
     * Updates user-specific data for the current authenticated user.
     */
    public static putUserData<ThrowOnError extends boolean = true>(options: Options<PutUserDataData, ThrowOnError>): RequestResult<PutUserDataResponses, PutUserDataErrors, ThrowOnError> {
        return (options.client ?? client).put<PutUserDataResponses, PutUserDataErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-data',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes user data.
     *
     * Deletes user data identified by the provided Id.
     */
    public static deleteUserDataById<ThrowOnError extends boolean = true>(options: Options<DeleteUserDataByIdData, ThrowOnError>): RequestResult<DeleteUserDataByIdResponses, DeleteUserDataByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserDataByIdResponses, DeleteUserDataByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-data/{id}',
            ...options
        });
    }
    
    /**
     * Gets user data.
     *
     * Gets user data identified by the provided Id.
     */
    public static getUserDataById<ThrowOnError extends boolean = true>(options: Options<GetUserDataByIdData, ThrowOnError>): RequestResult<GetUserDataByIdResponses, GetUserDataByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetUserDataByIdResponses, GetUserDataByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-data/{id}',
            ...options
        });
    }
}

export class UserGroupService {
    /**
     * Gets a filtered collection of user groups.
     *
     * Filters user groups based on the provided criteria with support for pagination.
     */
    public static getFilterUserGroup<ThrowOnError extends boolean = true>(options?: Options<GetFilterUserGroupData, ThrowOnError>): RequestResult<GetFilterUserGroupResponses, GetFilterUserGroupErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetFilterUserGroupResponses, GetFilterUserGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/filter/user-group',
            ...options
        });
    }
    
    /**
     * Gets a collection of user group items.
     *
     * Gets a collection of user group items identified by the provided Ids.
     */
    public static getItemUserGroup<ThrowOnError extends boolean = true>(options?: Options<GetItemUserGroupData, ThrowOnError>): RequestResult<GetItemUserGroupResponses, GetItemUserGroupErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemUserGroupResponses, GetItemUserGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/user-group',
            ...options
        });
    }
    
    /**
     * Deletes multiple user groups.
     *
     * Deletes multiple user groups identified by the provided Ids. This operation cannot be undone.
     */
    public static deleteUserGroup<ThrowOnError extends boolean = true>(options: Options<DeleteUserGroupData, ThrowOnError>): RequestResult<DeleteUserGroupResponses, DeleteUserGroupErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserGroupResponses, DeleteUserGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-group',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a paginated collection of user groups.
     *
     * Gets a paginated collection of all user groups.
     */
    public static getUserGroup<ThrowOnError extends boolean = true>(options?: Options<GetUserGroupData, ThrowOnError>): RequestResult<GetUserGroupResponses, GetUserGroupErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserGroupResponses, GetUserGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-group',
            ...options
        });
    }
    
    /**
     * Creates a new user group.
     *
     * Creates a new user group with the configuration specified in the request model.
     */
    public static postUserGroup<ThrowOnError extends boolean = true>(options: Options<PostUserGroupData, ThrowOnError>): RequestResult<PostUserGroupResponses, PostUserGroupErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserGroupResponses, PostUserGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-group',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a user group.
     *
     * Deletes a user group identified by the provided Id.
     */
    public static deleteUserGroupById<ThrowOnError extends boolean = true>(options: Options<DeleteUserGroupByIdData, ThrowOnError>): RequestResult<DeleteUserGroupByIdResponses, DeleteUserGroupByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserGroupByIdResponses, DeleteUserGroupByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-group/{id}',
            ...options
        });
    }
    
    /**
     * Gets a user group.
     *
     * Gets a user group identified by the provided Id.
     */
    public static getUserGroupById<ThrowOnError extends boolean = true>(options: Options<GetUserGroupByIdData, ThrowOnError>): RequestResult<GetUserGroupByIdResponses, GetUserGroupByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetUserGroupByIdResponses, GetUserGroupByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-group/{id}',
            ...options
        });
    }
    
    /**
     * Updates a user group.
     *
     * Updates a user group identified by the provided Id with the details from the request model.
     */
    public static putUserGroupById<ThrowOnError extends boolean = true>(options: Options<PutUserGroupByIdData, ThrowOnError>): RequestResult<PutUserGroupByIdResponses, PutUserGroupByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutUserGroupByIdResponses, PutUserGroupByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-group/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Removes users from a user group.
     *
     * Removes the specified users from the user group identified by the provided Id.
     */
    public static deleteUserGroupByIdUsers<ThrowOnError extends boolean = true>(options: Options<DeleteUserGroupByIdUsersData, ThrowOnError>): RequestResult<DeleteUserGroupByIdUsersResponses, DeleteUserGroupByIdUsersErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteUserGroupByIdUsersResponses, DeleteUserGroupByIdUsersErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-group/{id}/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Adds users to a user group.
     *
     * Adds the specified users to the user group identified by the provided Id.
     */
    public static postUserGroupByIdUsers<ThrowOnError extends boolean = true>(options: Options<PostUserGroupByIdUsersData, ThrowOnError>): RequestResult<PostUserGroupByIdUsersResponses, PostUserGroupByIdUsersErrors, ThrowOnError> {
        return (options.client ?? client).post<PostUserGroupByIdUsersResponses, PostUserGroupByIdUsersErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/user-group/{id}/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class WebhookService {
    /**
     * Gets a collection of webhook items.
     *
     * Gets a collection of webhook items identified by the provided Ids.
     */
    public static getItemWebhook<ThrowOnError extends boolean = true>(options?: Options<GetItemWebhookData, ThrowOnError>): RequestResult<GetItemWebhookResponses, GetItemWebhookErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetItemWebhookResponses, GetItemWebhookErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/item/webhook',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of webhooks.
     *
     * Gets a paginated collection of all webhooks.
     */
    public static getWebhook<ThrowOnError extends boolean = true>(options?: Options<GetWebhookData, ThrowOnError>): RequestResult<GetWebhookResponses, GetWebhookErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetWebhookResponses, GetWebhookErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/webhook',
            ...options
        });
    }
    
    /**
     * Creates a new webhook.
     *
     * Creates a new webhook with the configuration specified in the request model.
     */
    public static postWebhook<ThrowOnError extends boolean = true>(options: Options<PostWebhookData, ThrowOnError>): RequestResult<PostWebhookResponses, PostWebhookErrors, ThrowOnError> {
        return (options.client ?? client).post<PostWebhookResponses, PostWebhookErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/webhook',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a webhook.
     *
     * Deletes a webhook identified by the provided Id.
     */
    public static deleteWebhookById<ThrowOnError extends boolean = true>(options: Options<DeleteWebhookByIdData, ThrowOnError>): RequestResult<DeleteWebhookByIdResponses, DeleteWebhookByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteWebhookByIdResponses, DeleteWebhookByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/webhook/{id}',
            ...options
        });
    }
    
    /**
     * Gets a webhook.
     *
     * Gets a webhook identified by the provided Id.
     */
    public static getWebhookById<ThrowOnError extends boolean = true>(options: Options<GetWebhookByIdData, ThrowOnError>): RequestResult<GetWebhookByIdResponses, GetWebhookByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetWebhookByIdResponses, GetWebhookByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/webhook/{id}',
            ...options
        });
    }
    
    /**
     * Updates a webhook.
     *
     * Updates a webhook identified by the provided Id with the details from the request model.
     */
    public static putWebhookById<ThrowOnError extends boolean = true>(options: Options<PutWebhookByIdData, ThrowOnError>): RequestResult<PutWebhookByIdResponses, PutWebhookByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutWebhookByIdResponses, PutWebhookByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/webhook/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Gets a paginated collection of webhook logs for a specific webhook.
     *
     * Gets a paginated collection of webhook logs for the webhook identified by the provided Id.
     */
    public static getWebhookByIdLogs<ThrowOnError extends boolean = true>(options: Options<GetWebhookByIdLogsData, ThrowOnError>): RequestResult<GetWebhookByIdLogsResponses, GetWebhookByIdLogsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetWebhookByIdLogsResponses, GetWebhookByIdLogsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/webhook/{id}/logs',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of webhook events.
     *
     * Gets a paginated collection of available webhook events that can be subscribed to.
     */
    public static getWebhookEvents<ThrowOnError extends boolean = true>(options?: Options<GetWebhookEventsData, ThrowOnError>): RequestResult<GetWebhookEventsResponses, GetWebhookEventsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetWebhookEventsResponses, GetWebhookEventsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/webhook/events',
            ...options
        });
    }
    
    /**
     * Gets a paginated collection of webhook logs.
     *
     * Gets a paginated collection of webhook logs for all webhooks.
     */
    public static getWebhookLogs<ThrowOnError extends boolean = true>(options?: Options<GetWebhookLogsData, ThrowOnError>): RequestResult<GetWebhookLogsResponses, GetWebhookLogsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetWebhookLogsResponses, GetWebhookLogsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/umbraco/management/api/v1/webhook/logs',
            ...options
        });
    }
}
